<template>
  <div class="contanerBox">
    <!-- 头部Header -->
    <div class="conHeader">
      <div class="MenuBtns">
        <div class="logo-img-contener">
          <span class="logo-img-item">
            <img src="../assets/200.png" width="40px" alt="" />
            <span style="font-size: 12px">&nbsp</span>
          </span>
        </div>
        <!-- <div class="openMenu">
           <label class="open-svg display-clo">
            <span class="display-clo">
              <i class="iconfont icon-drawdakai"></i>
              <span style="font-size: 12px">打开</span>
            </span>
            <input
              type="file"
              accept="image/png,image/svg+xml,application/json"
              id="openSVG"
              @change="handleFileChange"
            />
          </label>
        </div> -->
        <div class="div-cursor" @click="dialogFormVisible = true">
          <i class="iconfont icon-drawxinjian10"></i>
          <span style="font-size: 12px">新建</span>
        </div>

        <div class="div-cursor" @click="saveMyPng">
          <!-- <el-tooltip
            class="item"
            effect="dark"
            content="保存PNG图"
            placement="bottom"
          > -->
          <i class="iconfont icon-drawPNG"></i>

          <span style="font-size: 12px">保存图</span>
          <!-- </el-tooltip> -->
        </div>
        <div
          class="div-cursor"
          @click="canUndo ? drawUndo(stateIndex - 1) : null"
           >
          <i
            :style="{ color: canUndo ? '' : '#878889' }"
            class="iconfont icon-drawnishizhen"
          ></i>
          <span style="font-size: 12px">撤销</span>
        </div>
        <div
          class="div-cursor"
          @click="canRedo ? drawRedo(stateIndex + 1) : null"
           >
          <i
            :style="{ color: canRedo ? '' : '#878889' }"
            class="iconfont icon-drawshunshizhen"
          ></i>
          <span style="font-size: 12px">恢复</span>
        </div>
        <div class="div-cursor" v-if="isClearSvg" @click="clearSvg">
          <i class="iconfont icon-drawqingkong"></i>
          <span style="font-size: 12px">清空</span>
        </div>
        <div class="div-cursor">
          <el-dropdown @command="handleHolesCommand">
            <span class="el-dropdown-link display-clo">
              <i
                class="iconfont icon-drawhuituxiadezicaidantubiao_tihuanyuanxingdingweikongweigulidian1"
              ></i>
              <span style="font-size: 12px">打孔机</span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="boliang">博亮打孔机</el-dropdown-item>
              <el-dropdown-item command="jingrui">精锐打孔机</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="div-cursor">
           <el-dropdown @command="handlExWaterJetCommand">
           <span class="el-dropdown-link display-clo">
          <i class="iconfont icon-drawqiege"></i>
          <span style="font-size: 12px">水刀</span>
          </span>
           <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="defa">德法水刀</el-dropdown-item>
              <el-dropdown-item command="aotuofu">奥拓福水刀</el-dropdown-item>
              <el-dropdown-item command="dadi">大地水刀</el-dropdown-item>
              <el-dropdown-item command="yifeng">亦丰水刀</el-dropdown-item>
              <el-dropdown-item command="jinbo">金玻水刀</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="div-cursor" @click="glassCut">
          <i class="iconfont icon-drawConcise"></i>
          <span style="font-size: 12px">切割机</span>
        </div>
        <!-- <div class="div-cursor" @click="changeRect">
          <i class="iconfont icon-drawjuxing"></i>
          <span style="font-size: 12px">改尺寸</span>
        </div> -->
        <!-- <div class="div-cursor" @click="creatImg">
          <i class="iconfont icon-drawiconmobanku"></i>
          <span style="font-size: 12px">存模板</span>
        </div>
        <div class="div-cursor" @click="openMdWin(mdParma.mdTpye)">
          <i class="iconfont icon-drawshujuyuanguanli"></i>
          <span style="font-size: 12px">模板库</span>
        </div>   -->
        <!-- <div class="div-cursor" @click="changeXYRadioeExp()">
          <i class="iconfont icon-drawzhengjiaoduobianxing"></i>
          <span style="font-size: 12px">切换坐标</span>
         </div> -->
        <!-- <div class="div-cursor" @click="openAbnormalShapedLibrary()">
          <i class="iconfont icon-drawzhengjiaoduobianxing"></i>
          <span style="font-size: 12px">异形库</span>
        </div>  -->
        <!--  <div class="div-cursor" @click="openDeepSeek()">
          <i class="iconfont icon-drawzhengjiaoduobianxing"></i>
          <span style="font-size: 12px">DeepSeek</span>
           </div>  -->
      </div>

      <div class="MenuBtns-right">
        <div class="r_content">
          <el-dropdown @command="handleClick">
            <span class="el-dropdown-link">
              <img class="user-img" src="../assets/image/girls.jpeg" />
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="sysSet">系统设置</el-dropdown-item>
              <!-- <el-dropdown-item command="logOut">退出</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
    </div>
    <!-- 内容conMain -->
    <div class="conMain">
      <!-- 右侧中间内容 conMainCon -->
      <div class="conMainCon" id="content">
        <div id="view" class="drawBack">
          <div id="drawCanvas" class="draw"></div>
        </div>
      </div>
      <div class="conMainRight">
        <div>
          <el-tabs type="border-card" @tab-click="handleClickCard">
            <el-tab-pane label="孔" v-model="activeName">
              <el-tabs
                :tab-position="tabPosition"
                v-model="activeName"
                @tab-click="handleClickHole"
                style="height: 80vh"
              >
                <el-tab-pane label="单孔" name="first">
                  <!-- 单孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/SingleHole.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">请输入孔的直径D：</div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-input
                          ref="SingleHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="X"
                          ref="SingleHoleInput2"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          ref="SingleHoleInput3"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'SingleHole')"
                          @keydown.enter="drawLevelOne('Hole', 'SingleHole')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 单孔 -->
                </el-tab-pane>
                <el-tab-pane label="吊轮孔2" name="second">
                  <!-- 吊轮孔2 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/HangWheelHoleTwo.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">请输入孔的直径D：</div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoInput2"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoInput3"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HangWheelHoleTwo')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'HangWheelHoleTwo')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 吊轮孔2 -->
                </el-tab-pane>
                <el-tab-pane label="双固定孔列" name="eight">
                  <!-- 双固定孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/DoubleFixHolesCol.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesColInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesColInput2"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesColInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesColInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'DoubleFixHolesCol')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'DoubleFixHolesCol')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 双固定孔 -->
                </el-tab-pane>
                <el-tab-pane label="双固定孔" name="nine">
                  <!-- 双固定孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/DoubleFixHoles.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="DoubleFixHolesInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'DoubleFixHoles')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'DoubleFixHoles')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 双固定孔 -->
                </el-tab-pane>
                <el-tab-pane label="双吊轮孔列" name="fourth">
                  <!-- 双吊轮孔列 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/HangWheelHoleTwoCol.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoColInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoColInput2"
                          v-model="H"
                          placeholder="请输入孔参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoColInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoColInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HangWheelHoleTwoCol')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'HangWheelHoleTwoCol')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 双吊轮孔列 -->
                </el-tab-pane>
                <el-tab-pane label="双吊轮孔排" name="five">
                  <!-- 双吊轮孔排 -->

                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/HangWheelHoleTwoRow.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoRowInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoRowInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoRowInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleTwoRowInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HangWheelHoleTwoRow')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'HangWheelHoleTwoRow')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 双吊轮孔排 -->
                </el-tab-pane>
                <el-tab-pane label="三孔" name="seventeen">
                  <!-- 三孔 -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="threeHolePic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="threeHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="threeHoleInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="threeHoleInput3"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="threeHoleInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="threeHoleInput5"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                  >
                    <el-col :span="12"
                      ><el-radio
                        @change="threeHolesChange"
                        v-model="threeHoleType"
                        label="A"
                        >类型A</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="threeHolesChange"
                        v-model="threeHoleType"
                        label="B"
                        >类型B</el-radio
                      ></el-col
                    >
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                  >
                    <el-col :span="12"
                      ><el-radio
                        @change="threeHolesChange"
                        v-model="threeHoleType"
                        label="C"
                        >类型C</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="threeHolesChange"
                        v-model="threeHoleType"
                        label="D"
                        >类型D</el-radio
                      ></el-col
                    >
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="threeHoleFnClick()"
                          @keydown.enter="threeHoleFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 三孔 -->
                </el-tab-pane>
                <el-tab-pane label="拉手孔" name="eleven">
                  <!-- 拉手孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/HandleHole.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HandleHole')"
                          @keydown.enter="drawLevelOne('Hole', 'HandleHole')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 拉手孔 -->
                </el-tab-pane>
                <el-tab-pane label="吊轮孔列" name="fourteen">
                  <!-- 吊轮孔列 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/HangWheelHoleCol.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleColInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleColInput2"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleColInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleColInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HangWheelHoleCol')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'HangWheelHoleCol')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 吊轮孔列 -->
                </el-tab-pane>
                <el-tab-pane label="吊轮孔3" name="third">
                  <!-- 吊轮孔3 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/HangWheelHoleThree.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">请输入孔的直径D：</div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleThreeInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleThreeInput2"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangWheelHoleThreeInput3"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HangWheelHoleThree')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'HangWheelHoleThree')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 吊轮孔3 -->
                </el-tab-pane>
                <el-tab-pane label="晾物孔" name="six">
                  <!-- 晾物孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/HangHole.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> D:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HangHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> W:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HangHoleInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> H1:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HangHoleInput3"
                          v-model="H1"
                          placeholder="请输入孔的参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> H2:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HangHoleInput4"
                          v-model="H2"
                          placeholder="请输入孔的参数H2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangHoleInput5"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangHoleInput6"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HangHole')"
                          @keydown.enter="drawLevelOne('Hole', 'HangHole')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 晾物孔 -->
                </el-tab-pane>
                <el-tab-pane label="拉手孔T字" name="seven">
                  <!-- 拉手孔T字 -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/HandleHoleTShaped.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> D:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleTShapedInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> W:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleTShapedInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> H1:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleTShapedInput3"
                          v-model="H1"
                          placeholder="请输入孔的参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px"> H2:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleTShapedInput4"
                          v-model="H2"
                          placeholder="请输入孔的参数H2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleTShapedInput5"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHoleTShapedInput6"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HandleHoleTShaped')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'HandleHoleTShaped')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 拉手孔T字 -->
                </el-tab-pane>
                <el-tab-pane label="相对吊轮孔" name="ten">
                  <!-- 相对吊轮孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/RelSuWheelHole.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RelSuWheelHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RelSuWheelHoleInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RelSuWheelHoleInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RelSuWheelHoleInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'RelSuWheelHole')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'RelSuWheelHole')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 相对吊轮孔 -->
                </el-tab-pane>
                <el-tab-pane label="旋转锁孔" name="twelve">
                  <!-- 旋转锁孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/RotatLockHole.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="3">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="5">
                      <div class="grid-content">
                        <el-input
                          ref="RotatLockHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="5">
                      <div class="grid-content">
                        <el-input
                          ref="RotatLockHoleInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="3">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="5">
                      <div class="grid-content">
                        <el-input
                          ref="RotatLockHoleInput3"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RotatLockHoleInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RotatLockHoleInput5"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'RotatLockHole')"
                          @keydown.enter="drawLevelOne('Hole', 'RotatLockHole')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 旋转锁孔 -->
                </el-tab-pane>
                <el-tab-pane label="拉手孔3" name="thirteen">
                  <!-- 拉手孔3 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/HandleHole3.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHole3Input1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHole3Input2"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHole3Input3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HandleHole3Input4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'HandleHole3')"
                          @keydown.enter="drawLevelOne('Hole', 'HandleHole3')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 拉手孔3 -->
                </el-tab-pane>
                <el-tab-pane label="7字拉手孔" name="fifteen">
                  <!-- 7字拉手孔 -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img
                          src="../assets/image/7ShapedHandleHole.jpg"
                          alt=""
                        />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="Shaped7HandleHoleInput1"
                          v-model="D"
                          placeholder="请输入孔的直径D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="Shaped7HandleHoleInput2"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="Shaped7HandleHoleInput3"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="Shaped7HandleHoleInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="Shaped7HandleHoleInput5"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'Shaped7HandleHole')"
                          @keydown.enter="
                            drawLevelOne('Hole', 'Shaped7HandleHole')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 7字拉手孔 -->
                </el-tab-pane>
                <el-tab-pane label="锁孔" name="sixteen">
                  <!-- 锁孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/KeyHole.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">D1：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="KeyHoleInput1"
                          v-model="D1"
                          placeholder="请输入孔的直径D1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">D2：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="KeyHoleInput2"
                          v-model="D2"
                          placeholder="请输入孔的直径D2"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="KeyHoleInput3"
                          v-model="W"
                          placeholder="请输入孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="KeyHoleInput4"
                          v-model="H"
                          placeholder="请输入孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="X"
                          placeholder="X"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="KeyHoleInput5"
                          v-model="Y"
                          placeholder="Y"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Hole', 'KeyHole')"
                          @keydown.enter="drawLevelOne('Hole', 'KeyHole')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 锁孔 -->
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="缺" v-model="activeName">
              <!-- <el-divider><i class="el-icon-more-outline"></i></el-divider> -->
              <el-tabs
                :tab-position="tabPosition"
                v-model="activeName"
                @tab-click="handleClickGap"
                style="height: 80vh"
              >
                <el-tab-pane label="蝴蝶" name="first">
                  <!-- 蝴蝶 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="ButterflyGapPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >蝴蝶参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGapInput1"
                          v-model="R"
                          placeholder="请输入蝴蝶参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGapInput2"
                          v-model="W"
                          placeholder="请输入蝴蝶参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGapInput3"
                          v-model="H"
                          placeholder="请输入蝴蝶参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> 
                  <!-- <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGapInput4"
                          @keyup.enter.native="focusNext('ButterflyGapInput5')"
                          v-model="R1"
                          placeholder="请输入蝴蝶参数R"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> -->
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGapInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGapChange"
                        v-model="ButterflyGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGapChange"
                        v-model="ButterflyGap3Type"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="ButterflyGapInput5"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="ButterflyGapInput6"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="ButterflyGapFnClick()"
                          @keydown.enter="ButterflyGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 蝴蝶 -->
                </el-tab-pane>
                <el-tab-pane label="蝴蝶2" name="second">
                  <!-- 蝴蝶 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="ButterflyGap2Pic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >蝴蝶参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input1"
                          v-model="R"
                          placeholder="请输入蝴蝶参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input2"
                          v-model="W"
                          placeholder="请输入蝴蝶参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input3"
                          v-model="W1"
                          placeholder="请输入蝴蝶参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input4"
                          v-model="H"
                          placeholder="请输入蝴蝶参数H"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input5"
                          v-model="H1"
                          placeholder="请输入蝴蝶参数R1"
                        ></el-input>
                      </div>
                    </el-col>

                    <!-- <el-col :span="2">
                      <div class="grid-content">R1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input6"
                          @keyup.enter.native="focusNext('ButterflyGap2Input7')"
                          v-model="R1"
                          placeholder="请输入蝴蝶参数H1"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col> -->

                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap2Input6"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  

                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGap2Change"
                        v-model="ButterflyGap2Type"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGap2Change"
                        v-model="ButterflyGap2Type"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="ButterflyGap2Input7"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="ButterflyGap2Input7"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="ButterflyGap2FnClick()"
                          @keydown.enter="ButterflyGap2FnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 蝴蝶 -->
                </el-tab-pane>
                <el-tab-pane label="蝴蝶3" name="third">
                  <!-- 蝴蝶 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="ButterflyGap3Pic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >蝴蝶参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>

                    <el-col :span="2">
                      <div class="grid-content">R1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input1"
                          v-model="R1"
                          placeholder="请输入蝴蝶参数R1"
                        ></el-input>
                      </div>
                    </el-col>

                    <el-col :span="2">
                      <div class="grid-content">R2：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input2"
                          v-model="R2"
                          placeholder="请输入蝴蝶参数R2"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input3"
                          v-model="W"
                          placeholder="请输入蝴蝶参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input4"
                          v-model="H"
                          placeholder="请输入蝴蝶参数H"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input5"
                          v-model="H1"
                          placeholder="请输入蝴蝶参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H2：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input6"
                          v-model="H2"
                          placeholder="请输入蝴蝶参数H2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap3Input7"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                  

                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGap3Change"
                        v-model="ButterflyGap3Type"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGap3Change"
                        v-model="ButterflyGap3Type"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="ButterflyGap3Input8"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="ButterflyGap3Input9"
                          @keyup.enter.native="focusNext('ButterflyGap3Input1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="ButterflyGap3FnClick()"
                          @keydown.enter="ButterflyGap3FnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 蝴蝶 -->
                </el-tab-pane>
                <el-tab-pane label="蝴蝶4" name="twelfth">
                  <!-- 蝴蝶 -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="ButterflyGap4Pic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >蝴蝶参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap4Input1"
                          v-model="R1"
                          placeholder="请输入蝴蝶参数R1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">R2：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap4Input2"
                          v-model="R2"
                          placeholder="请输入蝴蝶参数R2"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap4Input3"
                          v-model="W"
                          placeholder="请输入蝴蝶参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">W1：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap4Input4"
                          v-model="W1"
                          placeholder="请输入蝴蝶参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap4Input5"
                          v-model="H"
                          placeholder="请输入蝴蝶参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="ButterflyGap4Input6"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGap4Change"
                        v-model="ButterflyGap4Type"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="ButterflyGap4Change"
                        v-model="ButterflyGap4Type"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="ButterflyGap4Input7"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="ButterflyGap4Input8"
                          @keyup.enter.native="focusNext('ButterflyGap4Input1')" 
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="ButterflyGap4FnClick()"
                          @keydown.enter="ButterflyGap4FnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 蝴蝶 -->
                </el-tab-pane>
                <el-tab-pane label="U型" name="fourth">
                  <!-- U型 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="UShapeGapPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >U型缺参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="UShapeGapInput1"
                          v-model="D"
                          placeholder="请输入U型缺参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="UShapeGapInput2"
                          v-model="H"
                          placeholder="请输入U型缺参数参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="UShapeGapInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                  >
                    <el-col :span="12"
                      ><el-radio
                        @change="UShapeGapChange"
                        v-model="UShapeGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="UShapeGapChange"
                        v-model="UShapeGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="UShapeGapInput4"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="UShapeGapInput5"
                          @keyup.enter.native="focusNext('UShapeGapInput1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="UShapeGapFnClick()"
                          @keydown.enter="threeHoleFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- U型 -->
                </el-tab-pane>
                <el-tab-pane label="应力孔" name="six">
                  <!-- 应力孔 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="StressHoleGapPic"  alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >应力孔参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StressHoleGapInput1"
                          v-model="D"
                          placeholder="请输入应力孔的参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StressHoleGapInput2"
                          v-model="W"
                          placeholder="请输入应力孔的参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StressHoleGapInput3"
                          v-model="H"
                          placeholder="请输入应力孔的参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="StressHoleGapInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="StressHoleGapChange"
                        v-model="StressHoleGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="StressHoleGapChange"
                        v-model="StressHoleGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="StressHoleGapInput5"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="StressHoleGapInput6"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="StressHoleGapFnClick()"
                          @keydown.enter="StressHoleGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 应力孔 -->
                </el-tab-pane>
                <el-tab-pane label="跑道缺" name="seven">
                  <!-- 跑道缺 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="RunwayGapPic"  alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >跑道缺参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">H:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="RunwayGapInput1"
                          v-model="H"
                          placeholder="跑道缺参数H"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">H1:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="RunwayGapInput2"
                          v-model="H1"
                          placeholder="跑道缺参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">W:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="RunwayGapInput3"
                          v-model="W"
                          placeholder="跑道缺参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">W1:</span>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">
                        <el-input
                          ref="RunwayGapInput4"
                          v-model="W1"
                          placeholder="跑道缺参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RunwayGapInput5"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="RunwayGapChange"
                        v-model="RunwayGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="RunwayGapChange"
                        v-model="RunwayGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="RunwayGapInput6"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="RunwayGapInput7"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="RunwayGapFnClick()"
                          @keydown.enter="RunwayGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 跑道缺 -->
                </el-tab-pane>
                <el-tab-pane label="方缺" name="eight">
                  <!-- 方缺 -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="SquareGapPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >方缺参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="SquareGapInput1"
                          v-model="R"
                          placeholder="请输入方缺参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="SquareGapInput2"
                          v-model="W"
                          placeholder="请输入方缺参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="SquareGapInput3"
                          v-model="H"
                          placeholder="请输入方缺参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="SquareGapInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="SquareGapChange"
                        v-model="SquareGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="SquareGapChange"
                        v-model="SquareGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="SquareGapInput5"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="SquareGapInput6"
                          @keyup.enter.native="focusNext('SquareGapInput1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="SquareGapFnClick()"
                          @keydown.enter="SquareGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 方缺 -->
                </el-tab-pane>
                <el-tab-pane label="矩形缺" name="nine">
                  <!-- 方缺 -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/RectAngleGap.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >矩形缺参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="RectAngleGapInput1"
                          v-model="R"
                          placeholder="请输入矩形缺参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="RectAngleGapInput2"
                          v-model="W"
                          placeholder="请输入矩形缺参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="RectAngleGapInput3"
                          v-model="H"
                          placeholder="请输入矩形缺参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectAngleGapInput4"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectAngleGapInput5"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  水刀参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="RectAngleGapInput6"
                          @keyup.enter.native="focusNext('RectAngleGapInput7')"
                          v-model="cutLine"
                          placeholder="cutLine"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="RectAngleGapInput7"
                          @keyup.enter.native="focusNext('RectAngleGapInput1')" 
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row> -->
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Gap', 'RectAngleGap')"
                          @keydown.enter="drawLevelOne('Gap', 'RectAngleGap')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 方缺 -->
                </el-tab-pane>
                <el-tab-pane label="铜夹" name="ten">
                  <!-- 铜夹 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="CopperClipGapPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >铜夹参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">D:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CopperClipGapInput1"
                          v-model="D"
                          placeholder="请输入铜夹参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">R:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CopperClipGapInput2"
                          v-model="R"
                          placeholder="请输入铜夹参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">W:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CopperClipGapInput3"
                          v-model="W"
                          placeholder="请输入铜夹参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">H:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CopperClipGapInput4"
                          v-model="H"
                          placeholder="请输入铜夹参数H"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">H1:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CopperClipGapInput5"
                          v-model="H1"
                          placeholder="请输入铜夹参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="CopperClipGapInput6"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="CopperClipGapChange"
                        v-model="CopperClipGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="CopperClipGapChange"
                        v-model="CopperClipGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="CopperClipGapInput7"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="CopperClipGapInput8"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="CopperClipGapFnClick()"
                          @keydown.enter="CopperClipGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 铜夹 -->
                </el-tab-pane>
                <el-tab-pane label="长条夹" name="eleven">
                  <!-- 长条夹 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="LongClipGapPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >长条夹参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="LongClipGapInput1"
                          v-model="D"
                          placeholder="请输入长条夹参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">D1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="LongClipGapInput2"
                          v-model="D1"
                          placeholder="请输入长条夹参数D1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="LongClipGapInput3"
                          v-model="H"
                          placeholder="请输入长条夹参数H"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="LongClipGapInput4"
                          v-model="H1"
                          placeholder="请输入长条夹参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="LongClipGapInput5"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  
                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="LongClipGapChange"
                        v-model="LongClipGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="LongClipGapChange"
                        v-model="LongClipGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="LongClipGapInput6"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="LongClipGapInput7"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="LongClipGapFnClick()"
                          @keydown.enter="LongClipGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 长条夹 -->
                </el-tab-pane>
                <el-tab-pane label="吊夹" name="twelve">
                  <!-- 长条夹 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="HangClipGapPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >长条夹参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                   <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">D:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="HangClipGapInput1"
                          v-model="D"
                          placeholder="请输入吊夹参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">W:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="HangClipGapInput2"
                          v-model="W"
                          placeholder="请输入吊夹参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">W1:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="HangClipGapInput3"
                          v-model="W1"
                          placeholder="请输入吊夹参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">H:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="HangClipGapInput4"
                          v-model="H"
                          placeholder="请输入吊夹参数H"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">
                        <span style="font-size: 12px">H1:</span>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="HangClipGapInput5"
                          v-model="H1"
                          placeholder="请输入吊夹参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="HangClipGapInput5"
                          v-model="X"
                          placeholder="X"
                          :disabled="false"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="false"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                                   

                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="HangClipGapChange"
                        v-model="HangClipGapType"
                        label="A"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="HangClipGapChange"
                        v-model="HangClipGapType"
                        label="B"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="HangClipGapInput6"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="HangClipGapInput7"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="HangClipGapFnClick()"
                          @keydown.enter="HangClipGapFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 长条夹 -->
                </el-tab-pane>
                <el-tab-pane label="椭圆" name="thirteen">
                  <!-- 长条夹 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/EllipseGap.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >椭圆参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">Rx：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="EllipseGapInput1"
                          v-model="Rx"
                          placeholder="请输入椭圆参数Rx"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Ry：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="EllipseGapInput2"
                          v-model="Ry"
                          placeholder="请输入椭圆参数Ry"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="EllipseGapInput3"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="EllipseGapInput4"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  水刀参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="EllipseGapInput5"
                          @keyup.enter.native="focusNext('EllipseGapInput6')"
                          v-model="cutLine"
                          placeholder="cutLine"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="EllipseGapInput6"
                          @keyup.enter.native="focusNext('EllipseGapInput1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row> -->
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Gap', 'EllipseGap')"
                          @keydown.enter="drawLevelOne('Gap', 'EllipseGap')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 长条夹 -->
                </el-tab-pane>

                <!-- 圆角矩形A -->
                <el-tab-pane label="圆角矩形A" name="fourteen">
                  <!-- 长条夹 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/RectRoundGapA.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆角矩形 参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >圆角矩形参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput1"
                          v-model="W"
                          placeholder="请输入圆角矩形参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W1:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput2"
                          v-model="W1"
                          placeholder="请输入圆角矩形参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W2:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput3"
                          v-model="W2"
                          placeholder="请输入圆角矩形参数W2"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput4"
                          v-model="H"
                          placeholder="请输入圆角矩形参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">H1:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput5"
                          v-model="H1"
                          placeholder="请输入圆角矩形参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H2:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput6"
                          v-model="H2"
                          placeholder="请输入圆角矩形参数H2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">R:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput7"
                          v-model="R"
                          placeholder="请输入圆角矩形参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">R1</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput8"
                          v-model="R1"
                          placeholder="请输入圆角矩形参数R1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">R2</div>
                    </el-col>
                    <el-col :span="20">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput9"
                          v-model="R2"
                          placeholder="请输入圆角矩形参数R2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput10"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapAInput11"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  水刀参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="RectRoundGapAInput12"
                          @keyup.enter.native="
                            focusNext('RectRoundGapAInput13')
                          "
                          v-model="cutLine"
                          placeholder="cutLine"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="RectRoundGapAInput13"
                          @keyup.enter.native="
                            focusNext('RectRoundGapAInput1')
                          "
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row> -->

                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Gap', 'RectRoundGapA')"
                          @keydown.enter="drawLevelOne('Gap', 'RectRoundGapA')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 长条夹 -->
                </el-tab-pane>
                <!-- 圆角矩形B -->
                <el-tab-pane label="圆角矩形B" name="fifteen">
                  <!-- 圆角矩形B -->
                  <!-- 位置和示意图 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/RectRoundGapB.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆角矩形B 参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >圆角矩形B参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput1"
                          v-model="W"
                          placeholder="请输入圆角矩形参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W1:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput2"
                          v-model="W1"
                          placeholder="请输入圆角矩形参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W2:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput3"
                          v-model="W2"
                          placeholder="请输入圆角矩形参数W2"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">R:</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput4"
                          v-model="R"
                          placeholder="请输入圆角矩形参数R"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">R1:</div>
                    </el-col>
                    <el-col :span="20">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput5"
                          v-model="R1"
                          placeholder="请输入圆角矩形参数R1"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <!--  偏移参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput6"
                          v-model="X"
                          placeholder="X"
                          :disabled="showX"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="RectRoundGapBInput7"
                          v-model="Y"
                          placeholder="Y"
                          :disabled="showY"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  水刀参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="RectRoundGapBInput8"
                          @keyup.enter.native="focusNext('RectRoundGapBInput9')"
                          v-model="cutLine"
                          placeholder="cutLine"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="RectRoundGapBInput9"
                          @keyup.enter.native="focusNext('RectRoundGapBInput1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row> -->

                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Gap', 'RectRoundGapB')"
                          @keydown.enter="drawLevelOne('Gap', 'RectRoundGapB')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 长条夹 -->
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="角" v-model="activeName">
              <!-- <el-divider><i class="el-icon-more-outline"></i></el-divider> -->
              <el-tabs
                :tab-position="tabPosition"
                v-model="activeName"
                @tab-click="handleClickCorner"
                style="height: 80vh"
              >
                <el-tab-pane label="斜角" name="first">
                  <!-- 斜角 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/ObliqueAngle.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >斜角参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="ObliqueAngleInput1"
                          v-model="W"
                          placeholder="斜角参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="ObliqueAngleInput2"
                          v-model="H"
                          placeholder="斜角参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> 
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          v-model="cutLine"
                          ref="ObliqueAngleInput3"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="ObliqueAngleInput4"
                          @keyup.enter.native="focusNext('ObliqueAngleInput1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Corner', 'ObliqueAngle')"
                          @keydown.enter="
                            drawLevelOne('Corner', 'ObliqueAngle')
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 斜角 -->
                </el-tab-pane>
                <el-tab-pane label="圆角" name="second">
                  <!-- 圆角 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/Fillet.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >圆角参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-input
                          v-model="R"
                          placeholder="请输入圆角参数R"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 20250325-->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="X"
                          placeholder="X"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          v-model="cutLine"
                          placeholder="cutLine"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Corner', 'Fillet')"
                          @keydown.enter="drawLevelOne('Corner', 'Fillet')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 圆角 -->
                </el-tab-pane>
                <el-tab-pane label="方角" name="third">
                  <!-- 方角 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="CornerPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >方角参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CornerInput1"
                          v-model="R"
                          placeholder="请输入方角参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CornerInput2"
                          v-model="W"
                          placeholder="请输入方角参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="CornerInput3"
                          v-model="H"
                          placeholder="请输入方角参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                <!--  选择H参数类型 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择H参数类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="CornerChange"
                        v-model="CornerType"
                        label="A"
                        >矩形</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="CornerChange"
                        v-model="CornerType"
                        label="B"
                        >异形H与左边平行</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="CornerChange"
                        v-model="CornerType"
                        label="C"
                        >异形H与底边垂直</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  选择H参数类型 -->

                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="CornerInput4"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="CornerInput5"
                          @keyup.enter.native="focusNext('CornerInput1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Corner', 'Corner')"
                          @keydown.enter="drawLevelOne('Corner', 'Corner')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 方角 -->
                </el-tab-pane>
                <el-tab-pane label="圆角2" name="fourth">
                  <!-- 圆角2 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img src="../assets/image/Fillet2.jpg" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >圆角2参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="2">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="Fillet2Input1"
                          v-model="R"
                          placeholder="请输入圆角2参数R"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="Fillet2Input2"
                          v-model="W"
                          placeholder="请输入圆角2参数W"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="2">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="Fillet2Input3"
                          v-model="H"
                          placeholder="请输入圆角2参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  偏移参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="X"
                          placeholder="X"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input 
                          v-model="Y"
                          placeholder="Y"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="Fillet2Input4"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <!-- <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="Fillet2Input5"
                          @keyup.enter.native="focusNext('Fillet2Input1')"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                     </el-col> -->
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="drawLevelOne('Corner', 'Fillet2')"
                          @keydown.enter="drawLevelOne('Corner', 'Fillet2')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 圆角2 -->
                </el-tab-pane>
                <el-tab-pane label="地弹簧" name="five">
                  <!-- 地弹簧 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="FloorSpringPic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >地弹簧参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput1"
                          v-model="D"
                          placeholder="请输入地弹簧参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput2"
                          v-model="H"
                          placeholder="请输入地弹簧参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">H1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput3"
                          v-model="H1"
                          placeholder="请输入地弹簧参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput4"
                          v-model="W"
                          placeholder="请输入地弹簧参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput5"
                          v-model="W1"
                          placeholder="请输入地弹簧参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W2：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput6"
                          v-model="W2"
                          placeholder="请输入地弹簧参数W2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">R1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput7"
                          v-model="R1"
                          placeholder="请输入地弹簧参数R1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">R2：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpringInput8"
                          v-model="R2"
                          placeholder="请输入地弹簧参数R2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <!--  偏移参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="X"
                          placeholder="X"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> -->

                     <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="FloorSpringChange"
                        v-model="FloorSpringType"
                        label="A"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="FloorSpringChange"
                        v-model="FloorSpringType"
                        label="B"
                        >长边X轴轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="FloorSpringInput9"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="FloorSpringInput10"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="FloorSpringFnClick()"
                          @keydown.enter="FloorSpringFnClick()"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 地弹簧 -->
                </el-tab-pane>
                <el-tab-pane label="地弹簧2" name="six">
                  <!-- 地弹簧 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img <img :src="FloorSpring2Pic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >地弹簧参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input1"
                          v-model="D"
                          placeholder="请输入地弹簧参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input2"
                          v-model="H"
                          placeholder="请输入地弹簧参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">H1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input3"
                          v-model="H1"
                          placeholder="请输入地弹簧参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input4"
                          v-model="W"
                          placeholder="请输入地弹簧参数W"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input5"
                          v-model="W1"
                          placeholder="请输入地弹簧参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W2：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input6"
                          v-model="W2"
                          placeholder="请输入地弹簧参数W2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring2Input7"
                          v-model="R"
                          placeholder="请输入地弹簧参数R"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <!--  偏移参数 -->
                  <!-- <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >偏移参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">X：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="X"
                          placeholder="X"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">Y：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          v-model="Y"
                          placeholder="Y"
                          :disabled="true"
                          @focus="handleFocus"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row> -->
                  <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="FloorSpring2Change"
                        v-model="FloorSpring2Type"
                        label="A"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="FloorSpring2Change"
                        v-model="FloorSpring2Type"
                        label="B"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="FloorSpring2Input8"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="FloorSpring2Input9"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="FloorSpring2FnClick()"
                          @keydown.enter="
                            FloorSpring2FnClick()
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 地弹簧 -->
                </el-tab-pane>
                <el-tab-pane label="地弹簧3" name="seven">
                  <!-- 地弹簧 -->
                  <!-- 位置和示意图 -->

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 左侧 -->
                        <img :src="FloorSpring3Pic" alt="" />
                        <!-- 左侧 -->
                      </div></el-col
                    >
                    <el-col :span="12"
                      ><div class="grid-content">
                        <!-- 右侧 -->
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="1"
                                >A</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="2"
                                >B</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="3"
                                >C</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          class="row-bg hole-lineH"
                          type="flex"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="4"
                                >D</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="5"
                                >E</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="6"
                                >F</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>
                        <el-row
                          type="flex"
                          class="row-bg hole-lineH"
                          justify="center"
                        >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="7"
                                >G</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                disabled
                                v-model="radio"
                                label="8"
                                >H</el-radio
                              >
                            </div></el-col
                          >
                          <el-col :span="8"
                            ><div class="grid-content hole-position">
                              <el-radio
                                @change="pationChange"
                                v-model="radio"
                                label="9"
                                >I</el-radio
                              >
                            </div></el-col
                          >
                        </el-row>

                        <!-- 右侧 -->
                      </div></el-col
                    >
                  </el-row>
                  <!--  圆形参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >地弹簧参数设置</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">D：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring3Input1"
                          v-model="D"
                          placeholder="请输入地弹簧参数D"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">H：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring3Input2"
                          v-model="H"
                          placeholder="请输入地弹簧参数H"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">H1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring3Input3"
                          v-model="H1"
                          placeholder="请输入地弹簧参数H1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">R：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring3Input4"
                          v-model="R"
                          placeholder="请输入地弹簧参数R"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">W1：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring3Input5"
                          v-model="W1"
                          placeholder="请输入地弹簧参数W1"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content">W2：</div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content">
                        <el-input
                          ref="FloorSpring3Input6"
                          v-model="W2"
                          placeholder="请输入地弹簧参数W2"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                    <!--  类型选择 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >选择类型</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row
                    class="row-bg hole-lineH"
                    type="flex"
                    justify="center"
                       >
                    <el-col :span="12"
                      ><el-radio
                        @change="FloorSpring3Change"
                        v-model="FloorSpring3Type"
                        label="A"
                        >短边Y轴方向</el-radio
                      ></el-col
                    >
                    <el-col :span="12"
                      ><el-radio
                        @change="FloorSpring3Change"
                        v-model="FloorSpring3Type"
                        label="B"
                        >长边X轴方向</el-radio
                      ></el-col
                    >
                  </el-row>
                    <!--  类型选择 -->
                  <!--  水刀参数 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">水刀设置</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                         <el-row>
                    <el-col :span="8">
                      <div class="grid-content txtRt">出入刀线：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input
                          ref="FloorSpring3Input7"
                          v-model="cutLine"
                          placeholder="cutLine"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="grid-content txtRt">圆角：</div>
                    </el-col>
                    <el-col :span="4">
                      <div class="grid-content txtRt">
                        <el-input 
                          ref="FloorSpring3Input8"
                          v-model="cutFilletRadius"
                          placeholder="filletRadius"
                        ></el-input>
                      </div>
                     </el-col>
                    </el-row>
                      </div>
                    </el-col>
                  </el-row>
                  <!--  添加按钮 -->
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="FloorSpring3FnClick()"
                          @keydown.enter="
                            threeHoleFnClick()
                          "
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- 地弹簧 -->
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
            <el-tab-pane label="异形" v-model="activeName">
              <el-tabs
                :tab-position="tabPosition"
                v-model="activeName"
                @tab-click="handleClickSpecialShaped"
                style="height: 80vh"
              >
                <el-tab-pane label="楼梯" name="first">
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >示意图及区域位置选择</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12"
                      ><div class="grid-content">
                        <img
                          src="../assets/image/specialShaped.jpg"
                          alt=""
                        /></div
                    ></el-col>
                    <el-col :span="12">
                      <el-row>
                        <div class="grid-content">
                          <el-divider content-position="left"
                            >矩形外框尺寸</el-divider
                          >
                        </div>
                      </el-row>
                      <el-row>
                        <el-col :span="4">
                          <div class="grid-content">W：</div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content">
                            <el-input
                              ref="StairCaseInput1"
                              @keyup.enter.native="focusNext('StairCaseInput2')"
                              v-model="specialShapedRect.w"
                              @focus="handleFocus"
                              placeholder="W"
                            ></el-input>
                          </div>
                        </el-col>
                        <el-col :span="4">
                          <div class="grid-content">H：</div>
                        </el-col>
                        <el-col :span="8">
                          <div class="grid-content">
                            <el-input
                              ref="StairCaseInput2"
                              @keyup.enter.native="focusNext('StairCaseInput3')"
                              v-model="specialShapedRect.h"
                              @focus="handleFocus"
                              placeholder="H"
                            ></el-input>
                          </div>
                        </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >底边起始坐标</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="6">
                      <div class="grid-content">X(始)：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StairCaseInput3"
                          @keyup.enter.native="focusNext('StairCaseInput4')"
                          v-model="bottomLinePoint.startP.x"
                          @focus="handleFocus"
                          placeholder="坐标点X"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">Y(始)：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StairCaseInput4"
                          @keyup.enter.native="focusNext('StairCaseInput5')"
                          v-model="bottomLinePoint.startP.y"
                          @focus="handleFocus"
                          placeholder="坐标点Y"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <div class="grid-content">X(终)：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StairCaseInput5"
                          @keyup.enter.native="focusNext('StairCaseInput6')"
                          v-model="bottomLinePoint.endP.x"
                          @focus="handleFocus"
                          placeholder="坐标点X"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">Y(终)：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          ref="StairCaseInput6"
                          @keyup.enter.native="focusNext('StairCaseInput1')"
                          v-model="bottomLinePoint.endP.y"
                          @focus="handleFocus"
                          placeholder="坐标点Y"
                        ></el-input>
                      </div>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left"
                          >从左到右输入点坐标</el-divider
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="4">
                      <div class="grid-content">序号</div>
                    </el-col>
                    <el-col :span="5">
                      <div class="grid-content inputPadding">X值</div>
                    </el-col>
                    <el-col :span="5">
                      <div class="grid-content inputPadding">Y值</div>
                    </el-col>
                    <el-col :span="10">
                      <div class="grid-content inputPadding">
                        <el-button
                          type="success"
                          size="mini"
                          @click="dialogStairFloorVisible = true"
                          >楼层</el-button
                        >
                        <el-button
                          type="success"
                          size="mini"
                          @click="dialogStairAddVisible = true"
                          >添加</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                  <!-- <el-divider></el-divider> -->
                  <div
                    v-for="(item, index) in brokenLinePoint"
                    :key="item.id"
                    style="width: 100%"
                  >
                    <el-row>
                      <el-col :span="4">
                        <div class="grid-content">
                          <span>{{ index + 1 }}</span>
                        </div>
                      </el-col>
                      <el-col :span="5">
                        <div class="grid-content">
                          <el-input
                            :ref="`input${index}`"
                            v-model="item.x"
                            placeholder="坐标点X"
                            @focus="handleFocus"
                          ></el-input>
                        </div>
                      </el-col>
                      <el-col :span="5">
                        <div class="grid-content">
                          <el-input
                            @focus="handleFocus"
                            @keyup.enter.native="handleEnterPoint(index)"
                            v-model="item.y"
                            placeholder="坐标点Y"
                          ></el-input>
                        </div>
                      </el-col>
                      <el-col :span="10">
                        <div class="grid-content">
                          <el-button
                            class="btnTop"
                            size="mini"
                            @click="delPoint(index)"
                            type="danger"
                            >删除</el-button
                          >
                        </div>
                      </el-col>
                    </el-row>
                  </div>
                  <el-row>
                    <el-col :span="24">
                      <div class="grid-content">
                        <el-divider content-position="left">操作</el-divider>
                      </div>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <div class="grid-content">圆角：</div>
                    </el-col>
                    <el-col :span="6">
                      <div class="grid-content">
                        <el-input
                          v-model="roundCorner"
                          @focus="handleFocus"
                          placeholder="圆角值"
                        ></el-input>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="grid-content">
                        <el-button
                          type="primary"
                          icon="el-icon-plus"
                          @click="creatStairDraw('SpecialShaped', 'StairCase')"
                          >添加图形</el-button
                        >
                      </div>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <!-- 底部FOOTER -->
    <div class="footers">
      <div class="foot_lf">
        Copyright &copy; 2013-2053 营口经济技术开发区贵友软件开发有限公司　
        <a
          target="_blank"
          href="http://www.beian.gov.cn/portal/registerSystemInfo"
        >
          <img src="../assets/image/gonganwang.png" width="12" height="12" />
          辽公网安备21080402111341号　
        </a>
        <a target="_blank" href="http://beian.miit.gov.cn"
          >辽ICP备2022000450号-2</a
        ><br />
      </div>
    </div>
    <div v-if="abnormalShapeBox">
      <el-dialog
        title="异形图形"
        width="60%"
        :visible="abnormalShapeBox"
        :show-close="false"
      >
        <div class="drawBack">
          <div ref="myDraws" id="drawAbCanvas" class="draw"></div>
          <div>
            <!-- <el-dropdown>
      <span class="el-dropdown-link">
        导出文件<i class="el-icon-arrow-down el-icon--right"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item icon="el-icon-picture-outline" @click="saveAbMyPng">图片</el-dropdown-item>
        <el-dropdown-item icon="el-icon-circle-plus-outline">打孔机</el-dropdown-item>
        <el-dropdown-item icon="el-icon-scissors">水刀</el-dropdown-item>
        <el-dropdown-item icon="icon-drawqiege">切割机</el-dropdown-item>
      </el-dropdown-menu>
           </el-dropdown> -->
            <el-button
              type="primary"
              icon="el-icon-picture-outline"
              @click="saveAbMyPng"
              >图片</el-button
            >
            <el-button
              type="primary"
              icon="el-icon-scissors"
              @click="exAbWaterJet"
              >水刀</el-button
            >
            <el-button type="primary" icon="icon-drawqiege" @click="glassAbCut"
              >切割机</el-button
            >
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="abnormalShapeBox = false"
            >关闭</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 底部FOOTER -->
    <!-- 矩形尺寸参数设置弹出框 20250406-->
    <div class="conMdMain" v-show="false">
      <div class="conMdMainCon">
        <div id="viewMd" class="drawBackMd">
          <div id="svgToImg" class="drawmd"></div>
        </div>
      </div>
    </div>
    <!-- 保留生成缩略图用 -->
    <div>
      <el-dialog
        title="新建玻璃尺寸设置"
        :visible.sync="dialogFormVisible"
        width="24%"
        center
      >
        <el-form :model="form">
          <!-- <el-form-item label="长度X(mm)" :label-width="formLabelWidth">
            <el-input v-model="form.glassW" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="宽度Y(mm)" :label-width="formLabelWidth">
            <el-input v-model="form.glassH" autocomplete="off"></el-input>
          </el-form-item> -->
           <!-- <div class="grid-content">
                <el-divider content-position="left"
                  >是否切换 X Y轴数值</el-divider
                >
              </div> -->
         
          <el-form-item label="厚度(mm)" :label-width="formLabelWidth">
            <el-input
              v-model="GlassThickness"
              @focus="handleFocus"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="block">
          <component
            :formGlassW="form.glassW"
            :formGlassH="form.glassH"
            :is="currenGlassFrameComponent"
            @sedX="recieveMsg"
            :my-post="myPost"
          ></component>
          <el-row>
            <el-col :span="24">
              <div class="grid-content">
                <el-divider content-position="left"
                  >示意图及区域位置选择</el-divider
                >
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12"
              ><div class="grid-content">
                <img :src="imageGlassFrameSrc" alt="" /></div
            ></el-col>
            <el-col :span="12"
              ><div class="grid-content txtHeight">
                <el-row>
                  <el-col :span="12" class=""> 选择外框类型</el-col>
                </el-row>
                <el-row>
                  <el-cascader
                    v-model="glassFrameOptionsValue"
                    :options="glassFrameOptions"
                    :props="{ expandTrigger: 'hover' }"
                    @change="selGlassFrameChanged"
                  ></el-cascader>
                </el-row></div
            ></el-col>
          </el-row>
        </div>
        <div>
           <el-row>
            <el-col :span="24">
              <div class="grid-content">
                <el-divider content-position="left"
                  >是否切换X、Y轴</el-divider
                >
              </div>
            </el-col>
          </el-row>
            <el-row>
            <el-radio-group 
            v-model="changeXYRadio"
            @change="changeXYRadioEvent">
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>            
          </el-row>
        </div>
         
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="dialogFormVisible = false"
            @keydown.enter="dialogFormVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="
              creatShapeBorder('special-shaped', currenGlassFrameComponent)
            "
            @keydown.enter="
              creatShapeBorder('special-shaped', currenGlassFrameComponent)
            "
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>

    <!-- /**登录窗口 */ -->

    <!-- 矩形尺寸参数设置弹出框 -->
    <!-- 矩形尺寸修改参数弹出框 -->
    <div>
      <el-dialog
        title="玻璃尺寸修改"
        :visible.sync="changeGlassVisible"
        width="18%"
        center
      >
        <el-form :model="form">
          <el-form-item label="长度X(mm)" :label-width="formLabelWidth">
            <el-input
              v-model="form.glassW"
              @focus="handleFocus"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="宽度Y(mm)" :label-width="formLabelWidth">
            <el-input
              v-model="form.glassH"
              @focus="handleFocus"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="厚度(mm)" :label-width="formLabelWidth">
            <el-input
              v-model="GlassThickness"
              @focus="handleFocus"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="changeGlassVisible = false"
            @keydown.enter="changeGlassVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changeSetRect"
            @keydown.enter="changeSetRect"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 矩形尺寸修改参数弹出框 -->
    <!-- 系统设置参数弹出框 -->
    <div>
      <el-dialog
        title="系统设置"
        :visible.sync="systemSetVisible"
        width="25%"
        center
      >
        <el-form>
          <el-form-item label="字体" :label-width="formSysLabelWidth">
            <el-select v-model="renderOptions.fontSize" placeholder="请选择">
              <el-option
                v-for="item in SystemSetFontSizeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="线条粗细" :label-width="formSysLabelWidth">
            <el-select v-model="renderOptions.strokeWidth" placeholder="请选择">
              <el-option
                v-for="item in SystemSetStrokeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="图形放大倍数" :label-width="formSysLabelWidth">
            <el-select v-model="zoomM" placeholder="请选择">
              <el-option
                v-for="item in zoomOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="XY轴转换" :label-width="formSysLabelWidth">
            <el-select v-model="changeXYAxis" placeholder="请选择">
              <el-option
                v-for="item in changeXYAxisOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="水刀文件是否包含孔" :label-width="formSysLabelWidth">
            <el-select v-model="waterCutSetPram" placeholder="请选择">
              <el-option
                v-for="item in waterCutSetPramOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="自用模板库水刀文件是否包含孔" :label-width="formSysLabelWidth">
            <el-select v-model="waterCutSetPramMd" placeholder="请选择">
              <el-option
                v-for="item in waterCutSetPramMdOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="systemSetVisible = false">取 消</el-button>
          <el-button type="primary" @click="saveSystemSet">保 存</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 系统设置参数弹出框 -->
    <!-- 厚度参数弹出框 -->
    <div>
      <el-dialog
        title="打孔玻璃厚度设置"
        :visible.sync="thicknessSetVisible"
        width="18%"
        center
      >
        <el-form>
          <el-form-item label="厚度X(mm)" :label-width="formLabelWidth">
            <el-input
              @focus="handleFocus"
              v-model="GlassThickness"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="thicknessSetVisible = false"
            @keydown.enter="thicknessSetVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changSetThickness"
            @keydown.enter="changSetThickness"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 厚度参数弹出框 changSetUserMdThickness-->
    <!-- 主界面导出水刀格式2025.10.11参数设置 -->
    <!-- <div>
      <el-dialog
        title="水刀格式参数设置"
        :visible.sync="waterCutSetVisible"
        width="18%"
        center
      >
         <el-form label-width="80px" size="mini">
            <el-form-item label="包含孔" >
              <el-radio  @change="waterCutSetChange" v-model="waterCutSetPram" label="1">不包含孔</el-radio>
              <el-radio @change="waterCutSetChange" v-model="waterCutSetPram" label="2">包含孔</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="waterCutSetVisible = false"
            @keydown.enter="waterCutSetVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changSetWaterCut"
            @keydown.enter="changSetWaterCut"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div> -->
    <!-- 主界面导出水刀格式2025.10.11参数设置 -->
    <!-- 自用模板库导出水刀格式2025.10.26参数设置 -->
    <!-- <div>
      <el-dialog
        title="自用模板库水刀格式参数设置"
        :visible.sync="waterCutSetVisibleMd"
        width="18%"
        center
      >
         <el-form label-width="80px" size="mini">
            <el-form-item label="文件" >
              <el-radio  @change="waterCutSetChangeMd" v-model="waterCutSetPramMd" label="1">不包含孔</el-radio>
              <el-radio @change="waterCutSetChangeMd" v-model="waterCutSetPramMd" label="2">包含孔</el-radio>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="waterCutSetVisibleMd = false"
            @keydown.enter="waterCutSetVisibleMd = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changSetWaterCutMd"
            @keydown.enter="changSetWaterCutMd"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div> -->
    <!-- 自用模板库导出水刀格式2025.10.26参数设置 -->
    <!-- 模板自用库厚度设置弹出窗口 -->
    <div>
      <el-dialog
        title="模板自用库玻璃厚度设置"
        :visible.sync="thicknessUserMdSetVisible"
        width="18%"
        center
      >
        <el-form>
          <el-form-item label="厚度X(mm)" :label-width="formLabelWidth">
            <el-input
              @focus="handleFocus"
              v-model="GlassThickness"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="thicknessUserMdSetVisible = false"
            @keydown.enter="thicknessUserMdSetVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="changSetUserMdThickness"
            @keydown.enter="changSetUserMdThickness"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 模板自用库厚度设置弹出窗口 -->
    <!-- 上传信息弹出框 -->
    <div>
      <el-dialog
        title="模板信息"
        :visible.sync="saveJsonDataVisible"
        width="25%"
        center
      >
        <el-form :model="jsonForm">
          <el-form-item label="模板名称：" :label-width="formUpJsonLableWidth">
            <el-input
              v-model="jsonForm.MdObjName"
              autocomplete="off"
              @focus="handleFocus"
            ></el-input>
          </el-form-item>
          <el-form-item label="模板类型：" :label-width="formUpJsonLableWidth">
            <el-radio-group v-model="jsonForm.MdObjType">
              <el-radio :label="1">孔</el-radio>
              <el-radio :label="2">缺</el-radio>
              <el-radio :label="3">角</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="示意图：" :label-width="formUpJsonLableWidth">
            <!-- <el-button type="primary" @click="creatImg" icon="el-icon-edit"></el-button> -->
            <el-image
              style="width: 200px; height: 200px"
              :src="upLoadImgURL"
            ></el-image>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="saveJsonDataVisible = false">取 消</el-button>
          <el-button type="primary" @click="sendDataToPHP">立即创建</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 上传信息弹出框 -->

    <!-- 20250307异形模板库窗口 -->
    <div>
      <el-drawer
        title="异形模板库"
        :visible.sync="MdAbnormalShapeWin"
        direction="ltr"
        size="100%"
      >
        <el-container>
          <el-aside>
            <div v-for="(item, index) in MDASMenulabel" :key="item.AslID">
              <el-card
                shadow="hover"
                style="width: 95%"
                class="asideCard"
                :class="{ mdashapeActiveMenu: index === activeMdasideMenu }"
                @click.native="mdashapeasideMenuClick(index, item.TypeName)"
              >
                <el-row>
                  <el-image :src="item.TypeImg" fit="contain"></el-image>
                  <!-- </div> -->
                  <span>{{ item.TypeName }}</span>
                </el-row>
              </el-card>
            </div>
          </el-aside>
          <el-main>
            <div v-if="mainMdShow">
              <el-row :gutter="20">
                <el-col :span="20" class="bgMain">
                  <div class="mdashape-img-container">
                    <div v-for="(item, index) in MainImg" :key="item.id">
                      <div class="mdashape-img-item">
                        <img
                          :class="{
                            mdashapeActiveImg: index === activeMdashape,
                          }"
                          class="showimgstyle"
                          :src="item.TypeSubImg"
                          @click="mdashapeImgClick(index, item.TypeSubName)"
                        />
                        <ul class="span-title">
                          {{
                            item.TypeSubName
                          }}
                        </ul>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="4" class="bgParma">
                  <div class="parmaRect">
                    <div class="grid-content bg-purple-dark">
                      <div v-for="item in activeParamData" :key="item.id">
                        <el-input
                          @focus="handleFocus"
                          :placeholder="item.param"
                          v-model="item.param"
                          @input="changeAbInputParma"
                        >
                          <template slot="prepend">{{ item.name }}</template>
                        </el-input>
                      </div>
                    </div>
                  </div>
                  <div class="imgRect"><img :src="activeImgimgURL" /></div>
                  <div class="imgBtn">
                    <el-button
                      type="success"
                      @click="drawAbnormalShape()"
                      icon="el-icon-check"
                      >画图</el-button
                    >
                    <el-button type="danger" icon="el-icon-close"
                      >取消</el-button
                    >
                  </div>
                </el-col>
              </el-row>
            </div>
            <div v-else="">
              <el-empty :image-size="200"></el-empty>
            </div>
          </el-main>
        </el-container>
      </el-drawer>
    </div>
    <!-- 20250307异形模板库窗口 -->

    <!-- 模板库窗口 -->
    <div>
      <el-drawer
        title="模板图库"
        :visible.sync="MdWin"
        direction="rtl"
        size="80%"
      >
        <el-tabs type="border-card" v-model="activeMD">
          <el-tab-pane name="userMd" label="自用库">
            <el-tabs
              :tab-position="tabUserMdPosition"
              v-model="activeUserMD"
              @tab-click="handleUserMdClickGap"
              style="height: 950px"
            >
              <el-tab-pane name="1" label="孔">
                <div v-if="holesMdShow">
                  <div class="holes-img-container">
                    <div
                      v-for="(item, index) in getMdDataDraw"
                      :key="item.userMdID"
                    >
                      <div class="holes-img-item">
                        <el-image
                          :class="{ holesActiveImg: index === activeImg }"
                          class="showimgstyle"
                          :src="item.userMdUrl"
                          @click="mdImgClick(index)"
                          fit="contain"
                        >
                        </el-image>
                        <span class="demonstration holes-img-bottom">{{
                          item.userMdName
                        }}</span
                        ><br />
                        <span class="demonstration holes-img-bottom"
                          ><el-button
                            type="text"
                            @click="
                              delMdImgClick(
                                item.userMdID,
                                item.userMdType,
                                index
                              )
                            "
                            ><i class="el-icon-delete"></i>删除</el-button
                          ></span
                        >
                      </div>
                    </div>
                  </div>
                  <el-divider>
                    <span class="holes-img-parmSet">— 参数设置 —</span>
                  </el-divider>
                  <el-row :gutter="20" class="setParamH">
                    <el-col :span="6">
                      <el-form
                        status-icon
                        :model="inputLoadParam"
                        ref="inputLoadParam"
                        label-width="200px"
                        class="demo-ruleForm"
                      >
                        <el-collapse
                          v-model="activeUserMdNames"
                          @change="handleCollapseChange"
                          accordion
                        >
                          <el-collapse-item
                            v-for="(valA, keyA, i) in inputLoadParam"
                            :key="i"
                            :title="paramName[keyA.split('-')[0]] + '参数:'"
                            :name="i"
                          >
                            <div v-for="(valB, keyB, j) in valA" :key="j">
                              <el-form-item
                                :label="
                                  paramName[keyA.split('-')[0]] + ':' + keyB
                                "
                                :prop="keyB"
                              >
                                <el-input
                                  @focus="handleFocus"
                                  v-model="valA[keyB]"
                                  :placeholder="valB"
                                  @input="changeMdUpdataMsg"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </el-collapse-item>
                        </el-collapse>

                        <el-form-item class="btnUserMdReSet">
                          <el-button
                            @click="resetUserMdForm(inputLoadParam)"
                            @keydown.enter="resetUserMdForm(inputLoadParam)"
                            >重置</el-button
                          >
                          <!-- <el-button type="primary" @click="submitUserMdForm(inputLoadParam)">修改</el-button> -->
                        </el-form-item>
                      </el-form>
                      <!-- </div> -->
                    </el-col>
                    <el-col :span="18">
                      <div class="exportMenu">
                        <el-row class="block-col-2">
                          <el-col :span="2">
                            <el-button
                              class="imgUserMdMenu"
                              type="text"
                              @click="loadMdPng(activeBigImgUrl)"
                              ><i icon="el-icon-edit"></i>图片<i
                                class="el-icon-picture-outline"
                              ></i
                            ></el-button>
                          </el-col>
                          <el-col :span="2" class="imgUserMdDrop">
                            <el-dropdown @command="handleHolesUserMdCommand">
                              <span class="el-dropdown-link">
                                孔模板<i class="el-icon-arrow-down"></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                <el-dropdown-item
                                  icon="el-icon-plus"
                                  command="boliang"
                                  >博亮</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="jingrui"
                                  >精锐</el-dropdown-item
                                >
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-col>
                          <el-col :span="2" class="imgUserMdDrop">
                            <el-dropdown @command="exUserMdWaterJet">
                              <span class="el-dropdown-link">
                                水刀<i
                                  class="el-icon-arrow-down el-icon--right"
                                ></i>
                              </span>
                              <el-dropdown-menu slot="dropdown">
                                
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="defa"
                                  >德法</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="aotuofu"
                                  >奥拓福</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-plus"
                                  command="yifeng"
                                  >亦丰</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="jinbo"
                                  >金玻</el-dropdown-item
                                >
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-col>
                          <el-col :span="2">
                            <el-button
                              class="imgUserMdMenu"
                              type="text"
                              @click="glassUserMdCut()"
                              ><i icon="icon-drawqiegeji1"></i>切割机<i
                                class="icon-drawqiegeji1"
                              ></i
                            ></el-button>
                          </el-col>
                        </el-row>
                      </div>
                      <div class="grid-content bg-purple">
                        <div class="holes-img-parmSet-imgs">
                          <span class="demonstration div-cursor"
                            >{{ activeBigSize.X }}*{{ activeBigSize.Y }}</span
                          >
                          <div class="showImgBig">
                            <el-image
                              class="centered-image"
                              style="
                                width: 100%;
                                overflow: visible;
                                height: 100%;
                                margin-top: 5px;
                              "
                              :src="activeBigImgUrl"
                              fit="contain"
                            ></el-image>
                          </div>
                        </div>
                      </div>
                      <!-- <el-divider>
                        <span class="holes-img-parmSet">— 选择导出文件 —</span>
                      </el-divider> -->
                    </el-col>
                  </el-row>
                </div>
                <div v-else="">
                  <el-empty :image-size="200"></el-empty>
                </div>
              </el-tab-pane>
              <el-tab-pane name="2" label="缺">
                <div v-if="gapsMdShow">
                  <div class="holes-img-container">
                    <div
                      v-for="(item, index) in getMdDataDraw"
                      :key="item.userMdID"
                    >
                      <div class="holes-img-item">
                        <el-image
                          :class="{ holesActiveImg: index === activeImg }"
                          @click="mdImgClick(index)"
                          class="showimgstyle"
                          :src="item.userMdUrl"
                          fit="contain"
                        ></el-image>
                        <span class="demonstration holes-img-bottom">{{
                          item.userMdName
                        }}</span
                        ><br />
                        <span class="demonstration holes-img-bottom"
                          ><el-button
                            type="text"
                            @click="
                              delMdImgClick(item.userMdID, item.userMdType)
                            "
                            ><i class="el-icon-delete"></i>删除</el-button
                          ></span
                        >
                      </div>
                    </div>
                  </div>
                  <el-divider>
                    <span class="holes-img-parmSet">— 参数设置 —</span>
                  </el-divider>
                  <el-row :gutter="20" class="setParamH">
                    <el-col :span="6">
                      <el-form
                        status-icon
                        :model="inputLoadParam"
                        ref="inputLoadParam"
                        label-width="200px"
                        class="demo-ruleForm"
                      >
                        <el-collapse
                          v-model="activeUserMdNames"
                          @change="handleCollapseChange"
                          accordion
                        >
                          <el-collapse-item
                            v-for="(valA, keyA, i) in inputLoadParam"
                            :key="i"
                            :title="paramName[keyA.split('-')[0]] + '参数:'"
                            :name="i"
                          >
                            <div v-for="(valB, keyB, j) in valA" :key="j">
                              <el-form-item
                                :label="
                                  paramName[keyA.split('-')[0]] + ':' + keyB
                                "
                                :prop="keyB"
                              >
                                <el-input
                                  @focus="handleFocus"
                                  v-model="valA[keyB]"
                                  :placeholder="valB"
                                  @input="changeMdUpdataMsg"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </el-collapse-item>
                        </el-collapse>

                        <el-form-item class="btnUserMdReSet">
                          <el-button
                            @click="resetUserMdForm(inputLoadParam)"
                            @keydown.enter="resetUserMdForm(inputLoadParam)"
                            >重置</el-button
                          >
                          <!-- <el-button type="primary" @click="submitUserMdForm(inputLoadParam)">修改</el-button> -->
                        </el-form-item>
                      </el-form>
                      <!-- </div> -->
                    </el-col>
                    <el-col :span="18">
                      <div class="exportMenu">
                        <el-row class="block-col-2">
                          <el-col :span="2">
                            <el-button
                              class="imgUserMdMenu"
                              type="text"
                              @click="loadMdPng(activeBigImgUrl)"
                              ><i icon="el-icon-edit"></i>图片<i
                                class="el-icon-picture-outline"
                              ></i
                            ></el-button>
                          </el-col>
                          <el-col :span="2" class="imgUserMdDrop">
                            <el-dropdown @command="exUserMdWaterJet">
                              <span class="el-dropdown-link">
                                水刀<i
                                  class="el-icon-arrow-down el-icon--right"
                                ></i>
                              </span>
                              <el-dropdown-menu slot="dropdown"> 
                                 <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="defa"
                                  >德法</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="aotuofu"
                                  >奥拓福</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-plus"
                                  command="yifeng"
                                  >亦丰</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="jinbo"
                                  >金玻</el-dropdown-item
                                >
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-col>
                          <el-col :span="2">
                            <el-button
                              class="imgUserMdMenu"
                              type="text"
                              @click="glassUserMdCut()"
                              ><i icon="icon-drawqiegeji1"></i>切割机<i
                                class="icon-drawqiegeji1"
                              ></i
                            ></el-button>
                          </el-col>
                        </el-row>
                      </div>
                      <div class="grid-content bg-purple">
                        <div class="block holes-img-parmSet-imgs">
                          <span class="demonstration div-cursor"
                            >{{ activeBigSize.X }}*{{ activeBigSize.Y }}</span
                          >
                          <div class="showImgBig">
                            <el-image
                              :preview-teleported="true"
                              :teleported="true"
                              class="centered-image"
                              style="
                                width: 100%;
                                overflow: visible;
                                height: 100%;
                                margin-top: 5px;
                              "
                              :src="activeBigImgUrl"
                              fit="contain"
                            ></el-image>
                          </div>
                        </div>
                      </div>
                      <!-- <el-divider>
                        <span class="holes-img-parmSet">— 选择导出文件 —</span>
                      </el-divider> -->
                    </el-col>
                  </el-row>
                </div>
                <div v-else="">
                  <el-empty :image-size="200"></el-empty>
                </div>
              </el-tab-pane>
              <el-tab-pane name="3" label="角">
                <div v-if="cornersMdShow">
                  <div class="holes-img-container">
                    <div
                      v-for="(item, index) in getMdDataDraw"
                      :key="item.userMdID"
                    >
                      <div class="holes-img-item">
                        <el-image
                          :class="{ holesActiveImg: index === activeImg }"
                          @click="mdImgClick(index)"
                          class="showimgstyle"
                          :src="item.userMdUrl"
                          fit="contain"
                        ></el-image>
                        <span class="demonstration holes-img-bottom">{{
                          item.userMdName
                        }}</span
                        ><br />
                        <span class="demonstration holes-img-bottom"
                          ><el-button
                            type="text"
                            @click="
                              delMdImgClick(item.userMdID, item.userMdType)
                            "
                            ><i class="el-icon-delete"></i>删除</el-button
                          ></span
                        >
                      </div>
                    </div>
                  </div>
                  <el-divider>
                    <span class="holes-img-parmSet">— 参数设置 —</span>
                  </el-divider>
                  <el-row :gutter="20" class="setParamH">
                    <el-col :span="6">
                      <el-form
                        status-icon
                        :model="inputLoadParam"
                        ref="inputLoadParam"
                        label-width="200px"
                        class="demo-ruleForm"
                      >
                        <el-collapse
                          v-model="activeUserMdNames"
                          @change="handleCollapseChange"
                          accordion
                        >
                          <el-collapse-item
                            v-for="(valA, keyA, i) in inputLoadParam"
                            :key="i"
                            :title="paramName[keyA.split('-')[0]] + '参数:'"
                            :name="i"
                          >
                            <div v-for="(valB, keyB, j) in valA" :key="j">
                              <el-form-item
                                :label="
                                  paramName[keyA.split('-')[0]] + ':' + keyB
                                "
                                :prop="keyB"
                              >
                                <el-input
                                  @focus="handleFocus"
                                  v-model="valA[keyB]"
                                  :placeholder="valB"
                                  @input="changeMdUpdataMsg"
                                ></el-input>
                              </el-form-item>
                            </div>
                          </el-collapse-item>
                        </el-collapse>

                        <el-form-item class="btnUserMdReSet">
                          <el-button
                            @click="resetUserMdForm(inputLoadParam)"
                            @keydown.enter="resetUserMdForm(inputLoadParam)"
                            >重置</el-button
                          >
                          <!-- <el-button type="primary" @click="submitUserMdForm(inputLoadParam)">修改</el-button> -->
                        </el-form-item>
                      </el-form>
                      <!-- </div> -->
                    </el-col>
                    <el-col :span="18">
                      <div class="exportMenu">
                        <el-row class="block-col-2">
                          <el-col :span="2">
                            <el-button
                              class="imgUserMdMenu"
                              type="text"
                              @click="loadMdPng(activeBigImgUrl)"
                              ><i icon="el-icon-edit"></i>图片<i
                                class="el-icon-picture-outline"
                              ></i
                            ></el-button>
                          </el-col>
                          <el-col :span="2" class="imgUserMdDrop">
                            <el-dropdown @command="exUserMdWaterJet">
                              <span class="el-dropdown-link">
                                水刀<i
                                  class="el-icon-arrow-down el-icon--right"
                                ></i>
                              </span>
                              <el-dropdown-menu slot="dropdown"> 
                                 <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="defa"
                                  >德法</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="aotuofu"
                                  >奥拓福</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-plus"
                                  command="yifeng"
                                  >亦丰</el-dropdown-item
                                >
                                <el-dropdown-item
                                  icon="el-icon-circle-plus"
                                  command="jinbo"
                                  >金玻</el-dropdown-item
                                >
                              </el-dropdown-menu>
                            </el-dropdown>
                          </el-col>
                          <el-col :span="2">
                            <el-button
                              class="imgUserMdMenu"
                              type="text"
                              @click="glassUserMdCut()"
                              ><i icon="icon-drawqiegeji1"></i>切割机<i
                                class="icon-drawqiegeji1"
                              ></i
                            ></el-button>
                          </el-col>
                        </el-row>
                      </div>
                      <div class="showimgsmd grid-content bg-purple">
                        <div class="block holes-img-parmSet-imgs">
                          <span class="demonstration div-cursor"
                            >{{ activeBigSize.X }}*{{ activeBigSize.Y }}</span
                          >
                          <div class="showImgBig">
                            <el-image
                              class="centered-image"
                              style="
                                width: 100%;
                                overflow: visible;
                                height: 100%;
                                margin-top: 5px;
                              "
                              :src="activeBigImgUrl"
                              fit="contain"
                            ></el-image>
                          </div>
                        </div>
                      </div>
                      <!-- <el-divider>
                        <span class="holes-img-parmSet">— 选择导出文件 —</span>
                      </el-divider> -->
                    </el-col>
                  </el-row>
                </div>
                <div v-else="">
                  <el-empty :image-size="200"></el-empty>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-tab-pane>
          <el-tab-pane name="sysMd" label="系统库">系统库</el-tab-pane>
        </el-tabs>
        <div class="demo-drawer__content" hidden>
          <div class="conMdMain">
            <div class="conMdMainCon">
              <div id="viewMd" class="drawBackMd">
                <div id="svgToImg" class="drawmd"></div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
    </div>
    <!-- 模板库窗口 -->

    <!-- 楼梯增加坐标点窗口20241223 -->
    <div>
      <el-dialog
        title="请从左到右输入每个点的坐标"
        :visible.sync="addStairPointWinVisible"
        width="18%"
        center
      >
        <div v-for="item in brokenLinePoint" :key="item.id" style="width: 100%">
          <el-row>
            <el-col :span="4">
              <div class="grid-content">序号</div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content inputPadding">X值</div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content inputPadding">Y值</div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content inputPadding">操作</div>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="4">
              <div class="grid-content">
                <span>{{ item.id * 1 + 1 }}</span>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content">
                <el-input
                  v-model="item.x"
                  @focus="handleFocus"
                  placeholder="坐标点X"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="5">
              <div class="grid-content">
                <el-input
                  v-model="item.y"
                  @focus="handleFocus"
                  placeholder="坐标点Y"
                ></el-input>
              </div>
            </el-col>
            <el-col :span="10">
              <div class="grid-content">
                <el-button size="mini">添加</el-button>
                <el-button size="mini" type="danger">删除</el-button>
              </div>
            </el-col>
          </el-row>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="addStairPointWinVisible = false"
            @keydown.enter="addStairPointWinVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="addStairPoint"
            @keydown.enter="addStairPoint"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 楼梯增加坐标点窗口20241223 -->
    <!-- 楼梯层数选择 -->
    <div>
      <el-dialog
        title="楼梯层数"
        :visible.sync="dialogStairFloorVisible"
        width="10%"
        center
      >
        <el-select v-model="addFloorNum" placeholder="请选择楼层">
          <el-option
            v-for="item in optionsFloor"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="dialogStairFloorVisible = false"
            @keydown.enter="dialogStairFloorVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="addFloor()"
            @keydown.enter="addFloor()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 楼梯层数选择 -->
    <!-- 楼梯添加坐标输入框选择 -->
    <div>
      <el-dialog
        title="添加输入坐标数量"
        :visible.sync="dialogStairAddVisible"
        width="10%"
        center
      >
        <el-input
          @focus="handleFocus"
          placeholder="数量"
          v-model="addPointNum"
          clearable
        >
        </el-input>
        <div slot="footer" class="dialog-footer">
          <el-button
            @click="dialogStairAddVisible = false"
            @keydown.enter="dialogStairAddVisible = false"
            >取 消</el-button
          >
          <el-button
            type="primary"
            @click="addPoint()"
            @keydown.enter="addPoint()"
            >确 定</el-button
          >
        </div>
      </el-dialog>
    </div>
    <!-- 楼梯添加坐标输入框选择 -->
    <!--异形库模板画图窗口-->

    <!--异形库模板画图窗口-->
  </div>
</template>
<script>
// import mdDrawer from "../components/mdDrawer.vue";
import Rectangle from "../components/Rectangle/Rectangle.vue";
import IsoscelesTrapezoid from "../components/Trapezoid/IsoscelesTrapezoid.vue";
import RightAngledTrapezoid from "../components/Trapezoid/RightAngledTrapezoid.vue";
import OtherTrapezoidsA from "../components/Trapezoid/OtherTrapezoidsA.vue";
import OtherTrapezoidsB from "../components/Trapezoid/OtherTrapezoidsB.vue";
import ParallelogramA from "../components/Parallelogram/ParallelogramA.vue";
import ParallelogramB from "../components/Parallelogram/ParallelogramB.vue";
// 引入 axios（需先安装：npm install axios）
import axios from 'axios';
import makerjs from "makerjs";
import Cookies from "js-cookie";
import cloneDeep from "lodash/cloneDeep"; //引入 lodash 加  深层拷贝

/////引入DeepSeek  相关代码
// import { getDeepseekReply } from '@/utils/deepseek';
// import md from 'markdown-it';
// import DOMPurify from 'dompurify';

/////引入DeepSeek  相关代码
export default {
  components: {
    Rectangle,
    IsoscelesTrapezoid,
    RightAngledTrapezoid,
    OtherTrapezoidsA,
    OtherTrapezoidsB,
    ParallelogramA,
    ParallelogramB,
  },
  data() {
    var checkPhone = (rule, value, callback) => {
      // 手机号验证
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3456789]\d{9}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      visitCount: null, // 20260120存储访问次数
      //权限管理参数
      connERPPram:{},
      ComIsActive:"1",//是否激活导出不同格式文件功能 此参数一般适用于是否开通  一般通过到期时间来判定
      ComIsMd:"0",   //是否有自用库
      ComIsSysMd:"0",   // //是否有系统库
      ComIsWaterCut: "0",   ////是否开通水刀格式
      ComIsHoles: "0",   // //是否开通打孔机格式
      ComIsCutMS: "0",   // //是否开通切割机格式
      //权限管理参数
      waterCutSetPramMd:"2", //自用模板库水刀格式导出是否包含孔参数 20251026  1为不包含 2为包含      
      waterCutSetPramMdOptions:[{
          value: "1",
          label: "不包含",
        },
        {
          value: "2",
          label: "包含",
        },],
      
      toDxfModesplate:"",
      toChangeXYCutplate:"",//天津洪鸿伊达德法水刀，竖着画图，导出的文件需要转换成横向。转换坐标后的图文件，未做镜像处理
      toChangeXYDxfCutplate:"",//天津洪鸿伊达德法水刀，竖着画图，导出的文件需要转换成横向。转换坐标后的DXF文件，未做镜像处理
      waterCutSetPram:"2", //水刀格式导出是否包含孔 1为不包含2包含      
      waterCutSetPramOptions:[{
          value: "1",
          label: "不包含",
        },
        {
          value: "2",
          label: "包含",
        },],
      
      /*生成的孔文件及水刀文件命名*/
      setOUtFileName:"B",//值为B是为华盛 ID+厚度；值为A，则名称为ID:
      /**修改外框尺寸相关参数 */
      // outerOpramData:[],
      GlassOuterThickness: "",
      userOuterHolesNum: "",
      userOuterPlate: { models: "" },
      userOutercutPlate: { models: "" },
      userOutermarkers: { models: "" }, //包含标记数据 给到SVG
      userOuterdxf: "",
      /**修改外框尺寸相关参数 */
      /**引入DeepSeek */
      // dialogDeepSeekVisible:false,//2025.05.14 引入DeepSeek
      // messages: [],      //2025.05.14 引入DeepSeek 消息记录
      // inputText: '',     //2025.05.14 引入DeepSeek 用户输入
      // isLoading: false,   //2025.05.14 引入DeepSeek 加载状态
      /**引入DeepSeek */
      visitMdNum: 0 /**记录自用模板库新建外框的次数20250401 */,
      visitNum: 0 /**记录新建外框的次数20250401 */,
      myScaleMdWAll: 1 /**记录模板库首次外框长 */,
      myScaleMdHAll: 1 /**记录模板库首次外框高 */,
      myScaleWAll: 1 /**记录外框首次外框长 */,
      myScaleHAll: 1 /**记录外框首次外框高 */,
      BorderScale: 1, //20250331 缩放比例
      BorderScaleMd: 1, //20250406 模板缩放比例
      paramName: {
        SingleHole: "单孔",
        HangWheelHoleTwo: "吊轮孔2",
        HangWheelHoleThree: "吊轮孔3",
        HangWheelHoleTwoCol: "双吊轮孔列",
        HangWheelHoleTwoRow: "双吊轮孔排",
        HangHole: "晾物孔",
        HandleHoleTShaped: "拉手孔T字",
        DoubleFixHoles: "双固定孔",
        DoubleFixHolesCol: "双固定孔列",
        RelSuWheelHole: "相对吊轮孔",
        HandleHole: "拉手孔",
        RotatLockHole: "旋转锁孔",
        HandleHole3: "拉手孔3",
        HangWheelHoleCol: "吊轮孔列",
        Shaped7HandleHole: "7字拉手孔",
        KeyHole: "锁孔",
        ThreeHoles: "三孔A",
        ThreeHoles2: "三孔B",
        ThreeHoles3: "三孔C",
        ThreeHoles4: "三孔D",
        ButterflyGap: "蝴蝶缺",
        ButterflyGapH: "蝴蝶缺H",
        ButterflyGap2: "蝴蝶缺2",
        ButterflyGap2H: "蝴蝶缺2H",
        ButterflyGap3: "蝴蝶缺3",
        ButterflyGap3H: "蝴蝶缺3H",
        ButterflyGap4: "蝴蝶缺4",
        ButterflyGap4H: "蝴蝶缺4H",
        UShapeGapH: "U型缺2",
        StressHoleGap: "应力孔",
        StressHoleGapH: "应力孔H",
        RunwayGap: "跑道缺",
        RunwayGapH: "跑道缺H",
        SquareGap: "方缺",
        SquareGapH: "方缺H",
        UShapeGap: "U型缺",
        RectAngleGap: "矩形缺",
        CopperClipGap: "铜夹",
        CopperClipGapH: "铜夹H",
        LongClipGap: "长条夹",
        LongClipGapH: "长条夹H",
        EllipseGap: "椭圆",
        HangClipGap: "吊夹",
        HangClipGapH: "吊夹H",
        RectRoundGapA: "圆角矩形A",
        RectRoundGapB: "圆角矩形B",
        ObliqueAngle: "斜角",
        Fillet: "圆角",
        Corner: "方角",
        Fillet2: "圆角2",
        FloorSpring: "地弹簧",
        FloorSpringH: "地弹簧H",
        FloorSpring2: "地弹簧2",
        FloorSpring2H: "地弹簧2H",
        FloorSpring3: "地弹簧3",
        FloorSpring3H: "地弹簧3H",//
        Rectangle: "矩形框",
        IsoscelesTrapezoid: "等腰梯形",
        RightAngledTrapezoid: "直角梯形",
        OtherTrapezoidsA: "梯形A框",
        OtherTrapezoidsB: "梯形B框",
        ParallelogramA: "平形四边形A框",
        ParallelogramB: "平形四边形B框",
      },
      /**异形模板库相关参数 */
      BorderScaleAb: 1, //20250406 模板缩放比例
      myScaleAbWAll: 1 /**记录模板库首次外框长 */,
      myScaleAbHAll: 1 /**记录模板库首次外框高 */,
      visitAbNum: 0 /**记录异形模板库新建外框的次数20250620 */,
      InputParma: "",
      //生成图形
      abForm: {
        glassW: "", //长度
        glassH: "", //宽度
      },
      abPlate: "", //只有路径数据 供转换DXF格式使用
      abMarkers: "", //包含标记数据 给到SVG
      abDxf: "", //设备格式
      drawAbCanvasID: "",
      abnormalShapeBox: false, //异形模板库画图
      activeMdasideMenu: "",
      activeMdashape: "",
      MDASMenuType: "Type_A",
      MDASSubMenuType: "A_01",
      input1: "",
      MdAbnormalShapeWin: false,
      MDASMenulabel: [],
      MainImg: [],
      activeImgimgURL: "",
      activeParamData: "",
      mainMdShow: true,
      /**异形模板库相关参数 */

      /**楼梯相关参数 */
      roundCorner: "2.5", //楼梯圆角值
      optionsFloor: [
        {
          value: "1",
          label: "一层",
        },
        {
          value: "2",
          label: "二层",
        },
        {
          value: "3",
          label: "三层",
        },
        {
          value: "4",
          label: "四层",
        },
        {
          value: "5",
          label: "五层",
        },
        {
          value: "6",
          label: "六层",
        },
        {
          value: "7",
          label: "七层",
        },
        {
          value: "8",
          label: "八层",
        },
        {
          value: "9",
          label: "九层",
        },
        {
          value: "10",
          label: "十层",
        },
        {
          value: "11",
          label: "十一层",
        },
        {
          value: "12",
          label: "十二层",
        },
        {
          value: "23",
          label: "十三层",
        },
      ],
      addPointNum: "2",
      addFloorNum: "2",
      dialogStairFloorVisible: false,
      dialogStairAddVisible: false,
      specialShapedRect: { w: 0, h: 0 },
      addStairPointWinVisible: false,
      bottomLinePoint: {
        startP: { x: 0, y: 0 },
        endP: { x: 0, y: 0 },
      }, //底部直接开始，结束点坐标
      brokenLinePoint: [
        {
          id: new Date().getTime() + Math.random().toString(36).substring(2),
          x: 0,
          y: 0,
        },
      ], //中间折线点坐标
      /**楼梯相关参数 */

      /**模板窗口 */
      isRefresh: true,
      showImage: true,
      showMask: false,
      glassMDFrameParam: "",
      activeUserMdNames: [0],
      userMdDxf: "",
      thicknessUserMdSetVisible: false,
      GlassUserMdThickness: "5",
      holeUserMdD: "", //导出孔文件中的所有孔坐标 数组
      showUserMdBigImgH: "",
      userMdHolesBrand: "", //打孔机品牌
      userMdWaterJetBrand: "", //水刀品牌
      changeMdRectWinVisible: false,
      GlassMDThickness: "",
      userMdHolesNum: "",
      userMdPlate: { models: "" },
      userMdcutPlate: { models: "" },
      userMdmarkers: { models: "" }, //包含标记数据 给到SVG
      userMddxf: "",
      activeImg: "",
      holesMdShow: false,
      gapsMdShow: false,
      cornersMdShow: false,
      inputLoadParam: {},
      activeParam: [],
      activeBigSize: {
        X: "",
        Y: "",
      },
      userMdRect: "",
      testSvg: "",
      activeBigImgUrl: "",
      MdWin: false,
      activeMD: "userMd",
      tabUserMdPosition: "left", //自用库左右分
      activeUserMD: "1", //1:Hole  2:Gap 3:Corner
      /**孔模板 */
      mdParma: {
        userName: "",
        mdTpye: "1",
      },
      holesNum: 0,
      holesCount: 10,
      holesLoading: false,
      holesUrl: "../assets/image/girls.jpeg",
      mdName: [],
      getMdDataDraw: [],
      getDrawOp: [],
      downMdImgUrl: "",
      // url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      /**孔模板 */

      mdWinActive: ["1"],

      /**模板窗口 */
      showImg: false,
      upLoadImgURL: "",
      limitCount: 1,
      uploadImgDisabled: false,
      addAddressRules: {
        comPhone: [
          { required: true, message: "请输入正确手机号", trigger: "blur" },
          { validator: checkPhone, trigger: ["blur", "change"] },
        ],
      },
      myPost: false,
      drawer: false,
      innerDrawer: false,
      //水刀基准点位置
      benchMark: "G",
      tabLabel: "",
      changeGlassVisible: false, //修改玻璃尺寸弹窗可见性
      //画基本图形相关参数
      /*
      楼梯相关参数
      */
      spacelOptions: [
        {
          value: "1",
          label: "3",
        },
        {
          value: "2",
          label: "4",
        },
        {
          value: "3",
          label: "5",
        },
        {
          value: "4",
          label: "6",
        },
        {
          value: "5",
          label: "7",
        },
      ],
      spacelOptionsValue: "",
      //外框形状选择
      glassFrameOptions: [
        {
          value: "0",
          Name: "Rectangle",
          label: "矩形",
          inputParam: {
            W: 0,
            H: 0,
          },
        },
        {
          value: "1",
          Name: "Trapezoid",
          label: "梯形",
          children: [
            {
              value: "0",
              Name: "IsoscelesTrapezoid",
              label: "等腰梯形",
              inputParam: {
                H: 0,
                W: 0,
                W1: 0,
              },
            },
            {
              value: "1",
              Name: "RightAngledTrapezoid",
              label: "直角梯形",
              inputParam: {
                H: 0,
                H1: 0,
                W: 0,
                W1: 0,
              },
            },
            {
              value: "2",
              Name: "OtherTrapezoidsA",
              label: "其它梯形A",
              inputParam: {
                H1: 0,
                H2: 0,
                W: 0,
                W1: 0,
                W2: 0,
              },
            },
            {
              value: "3",
              Name: "OtherTrapezoidsB",
              label: "其它梯形B",
              inputParam: {
                H: 0,
                W: 0,
                W1: 0,
                W2: 0,
              },
            },
          ],
        },
        {
          value: "2",
          Name: "Parallelogram",
          label: "平形四边形",
          children: [
            {
              value: "0",
              Name: "ParallelogramA",
              label: "平形四边形A",
              inputParam: {
                H: 0,
                W: 0,
                W1: 0,
              },
            },
            {
              value: "1",
              Name: "ParallelogramB",
              label: "平形四边形B",
              inputParam: {
                H: 0,
                W: 0,
                W1: 0,
                W2: 0,
              },
            },
          ],
        },
      ],
      glassFrameOptionsValue: "0",
      imgGlassFrameName: "Rectangle",
      currenGlassFrameComponent: "Rectangle",
      glassFrameParam: "",
      /*
      楼梯相关参数
      */
      /*梯形相关参数*/
      spacelTrapezoidOptions: [
        {
          value: "0",
          Name: "IsoscelesTrapezoid",
          label: "等腰梯形",
          inputParam: [],
        },
        {
          value: "1",
          Name: "RightAngledTrapezoid",
          label: "直角梯形",
          inputParam: [],
        },
        {
          value: "2",
          Name: "OtherTrapezoidsA",
          label: "其它梯形A",
          inputParam: [],
        },
        {
          value: "3",
          Name: "OtherTrapezoidsB",
          label: "其它梯形B",
          inputParam: [],
        },
      ],
      spacelTrapezoidOptionsValue: "0",
      imgTrapezoidName: "IsoscelesTrapezoid",
      currenTrapezoidComponent: "IsoscelesTrapezoid",
      /*梯形相关参数*/
      /*平形四边相关参数*/
      spacelParallelogramOptions: [
        {
          value: "0",
          Name: "ParallelogramA",
          label: "平形四边形A",
          inputParam: [],
        },
        {
          value: "1",
          Name: "ParallelogramB",
          label: "平形四边形B",
          inputParam: [],
        },
      ],
      spacelParallelogramOptionsValue: "0",
      imgParallelogramName: "ParallelogramA",
      currenParallelogramComponent: "ParallelogramA",
      /*平形四边相关参数*/
      holeD: "", //导出孔文件中的所有孔坐标 数组
      toERPParams: false, //标记是否有数据从ERP传过来
      setSysStorage: {
        fontSize: "16px",
      }, //需要缓存数据
      SystemSetStrokeOptions: [
        {
          value: "0.3mm",
          label: "0.3mm",
        },
        {
          value: "0.6mm",
          label: "0.6mm",
        },
        {
          value: "1.0mm",
          label: "1.0mm",
        },
        {
          value: "1.2mm",
          label: "1.2mm",
        },
        {
          value: "1.5mm",
          label: "1.5mm",
        },
      ],
      SystemSetFontSizeOptions: [
        {
          value: "16px",
          label: "16px",
        },
        {
          value: "18px",
          label: "18px",
        },
        {
          value: "20px",
          label: "20px",
        },
        {
          value: "22px",
          label: "22px",
        },
        {
          value: "24px",
          label: "24px",
        },
        {
          value: "28px",
          label: "28px",
        },
        {
          value: "32px",
          label: "32px",
        },
        {
          value: "36px",
          label: "36px",
        },
        {
          value: "42px",
          label: "42px",
        },
        {
          value: "48px",
          label: "48px",
        },
      ],
      zoomM: 1,
      zoomOptions: [
        {
          value: "1",
          label: "1",
        },
        {
          value: "2",
          label: "2",
        },
        {
          value: "3",
          label: "3",
        },
        {
          value: "4",
          label: "4",
        },
        {
          value: "5",
          label: "5",
        },
      ],
      
      //图形是否从竖向转向横向 XY轴转换
      changeXYAxis:1,
      changeXYAxisOptions:[{
          value: "1",
          label: "不转换",
        },
        {
          value: "2",
          label: "转换坐标",
        },],
      isLoadCanvas: false,
      stateIndex: 0,
      isDrawUndo: true,
      isDrawRedo: true,
      isClearSvg: true,
      canvasState: [],
      //初始化固定参数不会发生变化
      disabled: false, //区域位置是否可选择性 禁用
      //矩形框相关参数
      dialogFormVisible: false,
      //矩形框相关参数
      systemSetVisible: false,
      thicknessSetVisible: false, //厚度参数设置弹窗
      waterCutSetVisible:false,//水刀格式设置窗口
      waterCutSetVisibleMd:false,//自用模板库水刀格式设置窗口
      formLabelWidth: "100px",
      formSysLabelWidth: "300px",
      //矩形框相关参数
      springOffset: 0,
      direction: "rtl",
      tabPosition: "left",
      //x、y标记偏移位置 孔
      // markShiftF: 5, //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
      markShift: 10, //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
      //markShiftTow: 15, //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
      markShiftTwo: 15, //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
      markShiftThree: 20, //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
      markShiftFour: 25, //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
      //圆形直径标注线加长设置 孔
      markHolesOneD: 30,

      /*撤销和恢复/反撤销操作*/
      myStep: 0,
      history: [], // 存储历史记录
      future: [], // 存储未来的操作记录
      currentState: {}, // 当前状态  Initial state 初始状态
      operationHistory: [], // 存储历史记录的参数记录
      operationFuture: [], // 存储未来的参数记录
      operationCurrent: {}, // 当前状态  Initial state 初始参数状态
      /*撤销和恢复/反撤销操作*/
      showX: false,
      showY: false,
      activeName: "first",
      form: {
        glassW: "0", //长度
        glassH: "0", //宽度
      },
      //区域位置选择单选
      radio: "7",
      //////**类型选择相关参数***///////
      //三孔不同类型选择单选
      threeHoleType: "A",
      //三孔示意图参数
      threeHolePic: require("../assets/image/ThreeHoles.jpg"),
      //三孔调用函数名称变化参数
      threeHoleFn: "creatThreeHoles",

      //蝴蝶缺不同类型选择单选
      ButterflyGapType: "A",
      //蝴蝶缺示意图参数
      ButterflyGapPic: require("../assets/image/ButterflyGap.jpg"),
      //蝴蝶缺调用函数名称变化参数
      ButterflyGapFn: "creatButterflyGap",

      //蝴蝶缺2不同类型选择单选
      ButterflyGap2Type: "A",
      //蝴蝶缺2示意图参数
      ButterflyGap2Pic: require("../assets/image/ButterflyGap2.jpg"),
      //蝴蝶缺2调用函数名称变化参数
      ButterflyGap2Fn: "creatButterflyGap2",

      //蝴蝶缺3不同类型选择单选
      ButterflyGap3Type: "A",
      //蝴蝶缺3示意图参数
      ButterflyGap3Pic: require("../assets/image/ButterflyGap3.jpg"),
      //蝴蝶缺3调用函数名称变化参数
      ButterflyGap3Fn: "creatButterflyGap3",

      //蝴蝶缺4不同类型选择单选
      ButterflyGap4Type: "A",
      //蝴蝶缺4示意图参数
      ButterflyGap4Pic: require("../assets/image/ButterflyGap4.jpg"),
      //蝴蝶缺4调用函数名称变化参数
      ButterflyGap4Fn: "creatButterflyGap4",

      //U型缺不同类型选择单选
      UShapeGapType: "A",
      //U型缺示意图参数
      UShapeGapPic: require("../assets/image/UShapeGap.jpg"),
      //U型缺调用函数名称变化参数
      UShapeGapFn: "creatUShapeGap",

      //应力孔不同类型选择单选
      StressHoleGapType: "A",
      //应力孔示意图参数
      StressHoleGapPic: require("../assets/image/StressHoleGap.jpg"),
      //应力孔调用函数名称变化参数
      StressHoleGapFn: "creatStressHoleGap",

      //跑道缺不同类型选择单选
      RunwayGapType: "A",
      //跑道缺示意图参数
      RunwayGapPic: require("../assets/image/RunwayGap.jpg"),
      //跑道缺调用函数名称变化参数
      RunwayGapFn: "creatRunwayGap",

      //方缺不同类型选择单选
      SquareGapType: "A",
      //方缺示意图参数
      SquareGapPic: require("../assets/image/SquareGap.jpg"),
      //方缺调用函数名称变化参数
      SquareGapFn: "creatSquareGap",

      //铜夹不同类型选择单选
      CopperClipGapType: "A",
      //铜夹示意图参数
      CopperClipGapPic: require("../assets/image/CopperClipGap.jpg"),
      //铜夹调用函数名称变化参数
      CopperClipGapFn: "CopperClipGap",

      //长条夹不同类型选择单选
      LongClipGapType: "A",
      //长条夹示意图参数
      LongClipGapPic: require("../assets/image/LongClipGap.jpg"),
      //长条夹调用函数名称变化参数
      LongClipGapFn: "creatLongClipGap",

      //吊夹不同类型选择单选
      HangClipGapType: "A",
      //吊夹示意图参数
      HangClipGapPic: require("../assets/image/HangClipGap.jpg"),
      //吊夹调用函数名称变化参数
      HangClipGapFn: "creatHangClipGap",

      //地弹簧不同类型选择单选
      FloorSpringType: "A",
      //地弹簧示意图参数
      FloorSpringPic: require("../assets/image/FloorSpring.jpg"),
      //地弹簧调用函数名称变化参数
      FloorSpringFn: "creatFloorSpring",

      //地弹簧2不同类型选择单选
      FloorSpring2Type: "A",
      //地弹簧2示意图参数
      FloorSpring2Pic: require("../assets/image/FloorSpring2.jpg"),
      //地弹簧2调用函数名称变化参数
      FloorSpring2Fn: "creatFloorSpring2",

      //地弹簧3不同类型选择单选
      FloorSpring3Type: "A",
      //地弹簧3示意图参数
      FloorSpring3Pic: require("../assets/image/FloorSpring3.jpg"),
      //地弹簧3调用函数名称变化参数
      FloorSpring3Fn: "creatFloorSpring3",

      
      //////**类型选择相关参数***///////

      /**方角选择H参数类型设置参数 */
      

      //吊夹不同类型选择单选
      CornerType: "A",
      //吊夹示意图参数
      CornerPic: require("../assets/image/Corner.jpg"),
      //水刀是否选择
      checked: false,
      //X、Y偏移值 初始值
      X: 0,
      Y: 0,
      D: 0,
      R: 0,
      Rx: 0,
      Ry: 0,
      R1: 0,
      R2: 0,
      D1: 0,
      D2: 0,
      H: 0,
      H1: 0,
      H2: 0,
      W: 0,
      W1: 0,
      W2: 0,
      //画图相关参数      
      WaterJetBrand: "", //水刀品牌
      myHolesNum: 0, //孔的数量
      plate: "", //只有路径数据 供转换DXF格式使用
      markers: "", //包含标记数据 给到SVG
      dxf: "",
      mirrorDxf: "",//德法水刀 需要镜像处理 主界面
      mirrorUserMdDxf:"",//t自用模板库 镜像后的图像
      removeHolesDxf:"",//去除孔相关图后的DXF
      MyJSON: {
        MdUserName: "",
        MdObjJsons: {
          plate: "", //初始只包含图 不包含出入刀线等信息
          cutPlate: "", // 包含出入刀线 和水刀相关
          markers: "", //包含标注的图片信息
          Rect: "", //玻璃尺寸
          operationHistory: "",
          frame: "",
        },
        MdObjName: "",
        MdObjUrl: "",
      },
      /****************/
      draw: "",
      svg: "",
      metaParameters: [
        { title: "width", type: "range", min: 1, max: 200, value: 50 },
        { title: "height", type: "range", min: 1, max: 100, value: 30 },
        { title: "hole radius", type: "range", min: 0, max: 10, value: 3 },
        { title: "rim", type: "range", min: 1, max: 20, value: 2 },
        { title: "fillet", type: "range", min: 0, max: 10, value: 5 },
      ], //画图参数
      operationHistory: [], //操作记录
      operationParam: "",
     
      renderOptions: {
        accuracy: 0.01,
        // origin: [0,0],
        strokeLineCap: "round",
        annotate: true,
        flow: { size: 8 },
        units: makerjs.unitType.Millimeter,
        svgAttrs: {
          id: "myDrawing",
          // style: "padding-left:" + 10 + "px; padding-top:" + 10 + "px",
        },
        strokeWidth: "0.3mm",
        fontSize: "16px",
        scale: 1,
        useSvgPathOnly: true,
        viewBox: true,
      },
      renderOptionsImg: {
        accuracy: 0.01,
        // origin: [0,0],
        strokeLineCap: "round",
        annotate: true,
        flow: { size: 8 },
        units: makerjs.unitType.Millimeter,
        svgAttrs: {
          id: "myImgs",
          // style: "padding-left:" + 10 + "px; padding-top:" + 10 + "px",
        },
        strokeWidth: "0.3mm",
        fontSize: "16px",
        scale: 1,
        useSvgPathOnly: true,
        viewBox: true,
      },
      renderOptionsAb: {
        accuracy: 0.01,
        // origin: [0,0],
        strokeLineCap: "round",
        annotate: true,
        flow: { size: 8 },
        units: makerjs.unitType.Millimeter,
        svgAttrs: {
          id: "myAbImgs",
          // style: "padding-left:" + 10 + "px; padding-top:" + 10 + "px",
        }, //异形模板库
        strokeWidth: "0.3mm",
        fontSize: "16px",
        scale: 1,
        useSvgPathOnly: true,
        viewBox: true,
      },
      //todxf option
       dxfOption:{
        accuracy:0.0001,
        usePOLYLINE:true,
      },
      /**
       * 对接水刀相关参数
       */
      isWaterJet: false,
      θCut: 45, //出入刀线角度，默认45
      rCut: 2.5, //出入刀线 切线圆的半径
      cutPlate: "",
      cutParam: {
        θCut: 45, //出入刀线角度，默认45
        rCut: 2.5, //出入刀线 切线圆的半径  
        cutLine:"2",  //出入刀线 延长线
        cutFilletRadius:"3", //水刀 圆角
      }, //水刀相关参数
      /**
       * 对接水刀相关参数
       */

      //***水刀圆角和出入刀线设置*/
      cutLine:"2",  //出入刀线 延长线
      cutFilletRadius:"3", //水刀 圆角
      //***水刀圆角和出入刀线设置*/

      /**
       * 对接博亮打孔机 参数
       */
      GlasslD: "GYID001", //玻璃ID
      Pieces: "1", //   未知
      GlassThickness: "5", //玻璃厚度
      gyName: "测试", //操作人员
      gySer:"",
      gySerNum: "", //服务器序号
      gySerCusName: "", //客户服务器名称
      HolesBrand: "", //打孔机品牌
     
      /**
       * 对接博亮打孔机 参数
       */
      gyErpParam: { OrderChildId: "", Name: "", Thick: "" },
      gyErpUrl: [
        "http://www.gyglass.cn/ghscan",
        "https://www.xd475.com/ghscan",
        "https://www.gy429.cn/ghscan",
        "https://www.gyxd475.cn/ghscan",
        "https://www.xd475.cn/ghscan",
        "https://www.w35db.cn/ghscan",
        "https://www.w35fb.cn/ghscan",
        "https://www.wn35fb.cn/ghscan",
        "https://www.wn35db.cn/ghscan",
        "https://www.gy429.com/ghscan",
        "https://www.gy065.cn/ghscan",
        "https://www.gy066.cn/ghscan",
        "https://www.gy068.cn/ghscan",
      ],
      upUrl: "",
      // frame:"Rectangle"
      /**登录相关 */
      logSetVisible: false, //登录窗口
      logForm: {
        comName: "",
        comPhone: "",
        comPassCode: "",
      },
      /**登录相关 */
      /**上传模板数据弹窗 */
      jsonForm: {
        MdObjName: "",
        MdObjType: 1,
      },
      saveJsonDataVisible: false,
      imageUrl: "",
      formUpJsonLableWidth: "120px",
      /**上传模板数据弹窗 */
      frame: "Rectangle",
      shapeName: "Rectangle",
      changeXYRadio:0,
    };
  },
  
  watch: {
    GlassThickness(newValue) {
      this.cutFilletRadius = Math.ceil((newValue*1)/2); // 当firstValue变化时，同步更新secondValue
    },
    GlassUserMdThickness(newValue) {
      this.cutFilletRadius = Math.ceil((newValue*1)/2); // 当firstValue变化时，同步更新secondValue
    },
  },
  computed: {
    mdWinSetParamChange(val) {
      console.log(val);
    },

    /**孔模板加载图 */
    holesNoMore() {
      return this.holesCount >= 20;
    },
    holesDisabled() {
      return this.holesLoading || this.holesNoMore;
    },
    /**孔模板加载图 */

    imageGlassFrameSrc() {
      return require(`@/assets/image/${this.imgGlassFrameName}.jpg`);
    },

    /**梯形示意图动态调用图片*/
    imageTrapezoidSrc() {
      // 使用require动态导入图片
      return require(`@/assets/image/${this.imgTrapezoidName}.jpg`);
      //this.selectParallelogramID=this.selectParallelogramID
    },

    /**平形四边形示意图动态调用图片*/

    /**平形四边形示意图动态调用图片*/
    imageParallelogramSrc() {
      // 使用require动态导入图片
      return require(`@/assets/image/${this.imgParallelogramName}.jpg`);
    },

    /**梯形示意图动态调用图片*/

    canUndo() {
      console.log("this.stateIndex > 0=", this.stateIndex > 0);
      return this.stateIndex > 0;
    },
    canRedo() {
      console.log("this.stateIndex =", this.stateIndex);
      console.log("this.history.length - 1=", this.history.length - 1);
      return this.stateIndex < this.myStep;
    },
    cachedUserList() {
      // 如果缓存中已有数据，直接返回缓存数据
      if (localstorage.getItem("setSysStorage")) {
        return JsON.parse(localstorage.getItem("setSysStorage"));
      } else {

      }
    },
    

    
  },
  mounted() {
    // 组件挂载时校验，防止页面刷新后状态丢失
    /**
    * // 页面挂载完成后执行统计逻辑
    * 20260120统计次数
      this.handleVisitCount()
    */
    

    /**20260120统计次数 */

    const myURLErp = window.location.href;
    //console.log("myURLErp==", myURLErp);
    ////获取URL地址参数
    //http://localhost:8082/index.html?id=gy123&gyLen=800&gyWid=600&gyThick=8&gyName=8&gySer=9_ycyss2024
    //http://localhost:8082/?id=gy123&gyLen=800&gyWid=600&gyThick=8&gyName=8&gySer=9_ycyss2024  20250508测试URL
    const params = new URLSearchParams(window.location.search);
    //toERPParams
    //console.log("params", params);
    //console.log("params.size=", params.size);
    if (params.size == 0) {
      this.toERPParams = false;
    } else if (params.size > 0) {
      this.toERPParams = true;
      let id = params.get("id"); // ID
      this.GlasslD = id;
      console.log("id=", id);
      console.log("this.GlasslD=", this.GlasslD);
      //比较 值大的为长度，小的为宽度。
      let gyLen = params.get("gyLen"); // gyLen
      let gyWid = params.get("gyWid"); // gyWid

      console.log("gyLen=", gyLen);
      console.log("gyWid=", gyWid);
      if (gyLen * 1 >= gyWid * 1) {
        console.log("长=长");
        this.form.glassW = gyLen; // gyLen
        this.form.glassH = gyWid; // gyWid
      } else {
        this.form.glassW = gyWid; // gyLen
        this.form.glassH = gyLen; // gyWid
      }

      console.log("this.form.glassW=", this.form.glassW);
      console.log("this.form.glassH=", this.form.glassH);
      let gyThick = params.get("gyThick"); // gyThick
      let gyName = params.get("gyName"); // gyName
      let gySer = params.get("gySer"); // gySer
      this.GlassThickness = gyThick;
      this.cutFilletRadius=Math.ceil((gyThick*1)/2);
      this.gySer = gySer;
      this.gyName = gyName;
      if(gySer=="2_HuaSheng2020"){
        this.setOUtFileName="B";
      }else{
        this.setOUtFileName="B";
      }
      let arr = gySer.split("_");
      //跨域
      /*************/
      /*************/
      // this.gySerNum=arr[0];//服务器序号
      // this.gySerCusName=arr[1];//客户服务器名称
      // this.upUrl='/nine/ghscan'+this.gySerCusName+'/ghscan.asmx/GetOkFromHuaTu';
      /*************/
      /*************/
      //同域
      /*************/
      /*************/
      let index = arr[0] - 1;
      let upSer = arr[1];
      this.upUrl = this.gyErpUrl[index] + upSer + "/ghscan.asmx/GetOkFromHuaTu";
      /*************/
      /*************/
      //var UPURL='/api'+this.gySerNum+'/ghscan'+this.gySerCusName+'/ghscan.asmx/GetOkFromHuaTu';
      //console.log("this.upUrl==", this.upUrl);
      //console.log("this.gyName==", this.gyName);
    }
    //// 页面挂载完成后执行权限状态检查
    this.executeDailyMethod();
    // 页面挂载完成后执行统计逻辑
    this.handleVisitCount();
  },
  methods: {
/**
 * 每天执行一次 检查权限状态 2026.01.23
 * 
 */
 /**
     * 获取当前日期（格式：YYYY-MM-DD，仅保留年月日）
     */
    getCurrentDate() {
      const now = new Date()
      const year = now.getFullYear()
      // 月份从0开始，需+1，不足2位补0
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },

    /**
     * 核心：每日限1次的方法
     */
    executeDailyMethod() {
      const currentDate = this.getCurrentDate()
      const lastCallDate = localStorage.getItem('daily_method_last_call')

      // 校验：最后调用日期不是今日，才允许执行
      if (lastCallDate !== currentDate) {
        try {
          // --------------------------
          // 这里替换成你的实际业务逻辑
          this.checkAuthority()
          // --------------------------
          // 执行成功后，记录本次调用日期到本地存储
          localStorage.setItem('daily_method_last_call', currentDate)
          // // 更新按钮状态
          // this.buttonText = '今日已执行，明日再试'
          // this.isMethodDisabled = true
        } catch (error) {
          // 业务逻辑执行失败时，不记录日期，允许重试
          console.error('方法执行失败：', error)
          //alert('执行失败，请重试！')
        }
      } else {
        // 今日已调用过，给出提示
        // alert('该方法每天只能调用一次，明天再来吧！')
      }
    },

    /**
     * 获取权限，赋值
     */
    checkAuthority() {
      console.log('执行成功：', new Date())
      //alert('方法执行成功！')
       var _this = this;
      /*
      connERPPram:"",
      ComIsActive:"",//是否激活导出不同格式文件功能 此参数一般适用于是否开通  一般通过到期时间来判定
      ComIsMd:"",   //是否有自用库
      ComMdName:"",   ////自用库名称
      ComIsSysMd:"",   // //是否有系统库
      ComIsWaterCut: "",   ////是否开通水刀格式
      ComIsHoles: "",   // //是否开通打孔机格式
      ComIsCutMS: "",   // //是否开通切割机格式
      ComNameURL:"",//  客户URL
      */
      console.log("handleVisitCount_this.gySer==",_this.gySer);
       _this.connERPPram.ComNameURL = _this.gySer;
      // _this.connERPPram.ComIsActive = _this.ComIsActive;
      // _this.connERPPram.ComIsMd = _this.ComIsMd;
      // _this.connERPPram.ComIsSysMd = _this.ComIsSysMd;
      // _this.connERPPram.ComIsWaterCut = _this.ComIsWaterCut;
      // _this.connERPPram.ComIsHoles = _this.ComIsHoles;
      // _this.connERPPram.ComIsCutMS = _this.ComIsCutMS;
      // //const strOk = _this.connERPPram;// 要传递给后端的数据 ;// 要传递给后端的数据
      
      const mystrOk = JSON.stringify(_this.connERPPram); // 要传递给后端的数据 ;// 要传递给后端的数据
      //console.log("strOk==", mystrOk);
      console.log("mystrOk", mystrOk);

     // 1. 获取本地存储的上次访问时间，防重复统计        
        const vistUpURL='https://www.gy429.com/getData/management/getAuthority.php';
         _this
        .axios({
          url: vistUpURL,
          method: "POST",
          data: { strOk: mystrOk},
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          //console.log(res);
         console.log("res.data==",res.data);         
          if (res.data.code === 200) {
            _this.visitCount = res.data.data.count;
            _this.ComIsCutMS=res.data.data.ComIsCutMS;
            _this.ComIsHoles=res.data.data.ComIsHoles;
            _this.ComIsMd=res.data.data.ComIsMd;
            _this.ComIsSysMd=res.data.data.ComIsSysMd;
            _this.ComIsWaterCut=1;
            //console.log("*****res.data.=", res.data);
          }
        })
        .catch((err) => {
          console.log("*****0621.1345=", err);
        });
       
    },
 
/**
 * 每天执行一次 检查权限状态 2026.01.23
 * 
 */
/**上传数据到ERP当中 */
    handleVisitCount() {
      var _this = this;
      /*
      connERPPram:"",
      ComIsActive:"",//是否激活导出不同格式文件功能 此参数一般适用于是否开通  一般通过到期时间来判定
      ComIsMd:"",   //是否有自用库
      ComMdName:"",   ////自用库名称
      ComIsSysMd:"",   // //是否有系统库
      ComIsWaterCut: "",   ////是否开通水刀格式
      ComIsHoles: "",   // //是否开通打孔机格式
      ComIsCutMS: "",   // //是否开通切割机格式
      ComNameURL:"",//  客户URL
      */
      //console.log("handleVisitCount_this.gyName==",_this.gySer);
      _this.connERPPram.ComNameURL = _this.gySer;
      // _this.connERPPram.ComIsActive = _this.ComIsActive;
      // _this.connERPPram.ComIsMd = _this.ComIsMd;
      // _this.connERPPram.ComIsSysMd = _this.ComIsSysMd;
      // _this.connERPPram.ComIsWaterCut = _this.ComIsWaterCut;
      // _this.connERPPram.ComIsHoles = _this.ComIsHoles;
      // _this.connERPPram.ComIsCutMS = _this.ComIsCutMS;
      //const strOk = _this.connERPPram;// 要传递给后端的数据 ;// 要传递给后端的数据
      
      const mystrOk = JSON.stringify(_this.connERPPram); // 要传递给后端的数据 ;// 要传递给后端的数据
      //console.log("strOk==", mystrOk);
      //console.log("upUrl==0621.000", _this.upUrl);

     // 1. 获取本地存储的上次访问时间，防重复统计
        const lastVisitTime = localStorage.getItem('last_visit_time');
        const now = Date.now();
        const vistUpURL='https://www.gy429.com/getData/management/visitCount.php';
        // 1小时 = 3600000 毫秒，超过1小时才新增统计
         if (!lastVisitTime || now - lastVisitTime >3600000) {
          // 2. 发送「增加访问次数」请求
         _this
        .axios({
          url: vistUpURL,
          method: "POST",
          data: { strOk: mystrOk},
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          //console.log(res);
         // console.log(res.data);
          var mystringArr = res.data.split(">");
         // console.log("test_mystringArr0" + mystringArr[0]);
        //  console.log("test_mystringArr1" + mystringArr[1]);
          var mystringArrs = mystringArr[2].split("<");
          var mydata = mystringArrs[0];
        //  console.log("mydata" + mydata);
          if (res.data.code === 200) {
            this.visitCount = res.data.data.count
            // 3. 记录本次访问时间到本地存储
            localStorage.setItem('last_visit_time', now.toString())
          }
        })
        .catch((err) => {
         // console.log("*****0621.1345=", err);
        });
        }
      //const strOk = _this.gyErpParam;// 要传递给后端的数据 ;// 要传递给后端的数据
      // const mystrOk = JSON.stringify(_this.gyErpParam); // 要传递给后端的数据 ;// 要传递给后端的数据
      // console.log("strOk==", mystrOk);
      // console.log("upUrl==0621.000", _this.upUrl);

      
    },
   /**2026.01.20统计访问次数 */
/**
 * 2026.01.23 读取 当前权限
 */


    //引入DeepSeek
    openDeepSeek() {
      this.dialogDeepSeekVisible = true;
    },
    async sendMessage() {
      if (!this.inputText.trim()) return;

      this.isLoading = true;
      this.messages.push({ type: "user", content: this.inputText });

      try {
        const reply = await getDeepseekReply(this.inputText);
        this.messages.push({ type: "bot", content: reply });
        this.inputText = "";
      } finally {
        this.isLoading = false;
      }
    },
    parseContent(content) {
      const dirtyHtml = md().render(content);
      return DOMPurify.sanitize(dirtyHtml); // XSS防护
    },
    //引入DeepSeek
    focusNext(nextInputRef) {
      console.log("nextInputRef==", nextInputRef);
      this.$nextTick(() => {
        this.$refs[nextInputRef].focus(); // 使用Vue的$refs来聚焦到下一个输入框
      });
    },

 /**
 * 切换XY画图，1、画图完成后导出图再切换回原状态
 * changeXYRadioEvent（）
 * 
 * 
 * 
 */
  changeXYRadioEvent(e){
     console.log("20250822--e==",e);
    // var w=this.form.glassW,h=this.form.glassH;

   if(e==1){
         console.log("e==1");
        [this.form.glassW,this.form.glassH]=[this.form.glassH,this.form.glassW];
      }else if(e==0){
         console.log("e==0");
       [this.form.glassW,this.form.glassH]=[this.form.glassH,this.form.glassW];
      }

  },
  //切换坐标  2、导出的文件切换XY轴坐标
  changeXYRadioeExp(){
        [this.form.glassW,this.form.glassH]=[this.form.glassH,this.form.glassW];
        [this.glassFrameParam.X,this.glassFrameParam.Y]=[this.glassFrameParam.Y,this.glassFrameParam.X];
      if (this.operationHistory.length >= 1){  
        for (let i = 1; i < this.operationHistory.length; i++){
          console.log("坐标转换this.operationHistory[i]==",this.operationHistory[i]);
                [this.operationHistory[i].X,this.operationHistory[i].Y]=[this.operationHistory[i].Y,this.operationHistory[i].X];
                this.operationHistory[i].Y="0";
            if(this.operationHistory[i].area * 1 == 1){
                this.operationHistory[i].area="7"; 
              }else if(this.operationHistory[i].area * 1 == 2){
                this.operationHistory[i].area="4";  
              }else if(this.operationHistory[i].area * 1 == 3){
                this.operationHistory[i].area="1";  
              }else if(this.operationHistory[i].area * 1 == 4){
                this.operationHistory[i].area="8"; 
              }else if(this.operationHistory[i].area * 1 == 6){
                this.operationHistory[i].area="2"; 
              }else if(this.operationHistory[i].area * 1 == 7){
                this.operationHistory[i].area="9"; 
              }else if(this.operationHistory[i].area * 1 == 8){
                this.operationHistory[i].area="6"; 
              }else if(this.operationHistory[i].area * 1 == 9){
                this.operationHistory[i].area="3"; 
              }
            }     
      } 
      console.log("坐标转换this.operationHistory==",this.operationHistory);
      console.log("坐标转换this.operationHistory.length==",this.operationHistory.length);
      console.log("坐标转换this.shapeName==",this.shapeName);
     if (this.shapeName == "Rectangle") {
        // var form = this.glassFrameParam;
        var form = this.form;
      //    var model = {
      //   plate: _.cloneDeep(this.plate),
      //   markers: _.cloneDeep(this.markers),
      //   cutPlate: _.cloneDeep(this.cutPlate),
      // };
         var model = {
        plate: {},
        markers: {},
        cutPlate: {},
      };
      var HolesNum=0;
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };      
      for (var i = 1; i < this.operationHistory.length; i++) {
           var shape=this.operationHistory[i].shape;
        
          console.log("坐标转换shape===",shape);
          console.log("坐标转换this.operationHistory[i]===",this.operationHistory[i]);
          console.log("坐标转换model===",model);
          console.log("坐标转换HolesNum===",HolesNum);
          console.log("坐标转换fixedParam===",fixedParam);
          console.log("坐标转换form===",form);
          var myobj = this.$myutils[shape](
          this.operationHistory[i],
           model,
           HolesNum,
           form,
           fixedParam,
           this.zoomM,
           this.θCut,
           this.rCut,
           this.cutLine,
           this.cutFilletRadius
        );
     }
     console.log("坐标转换myobj===",myobj);
     var myRectObj = this.$myutils[this.shapeName](
        this.glassFrameParam,
        model,
        fixedParam,
        this.zoomM
      );
      console.log("坐标转换myRectObj===",myRectObj);
      // myobj.cutPlate.models["Rectangle"] = myRectObj.cutPlate.models.Rectangle;
      myobj.plate.models["Rectangle"] = myRectObj.plate.models.Rectangle;
      myobj.markers.models["Rectangle"] = myRectObj.markers.models.Rectangle;
      myobj.markers.models["myWidthMark"] = myRectObj.markers.models.myWidthMark;
      myobj.markers.models["myHeightMark"] = myRectObj.markers.models.myHeightMark;

      }else {
        // ?var form = _.cloneDeep(frame);
      }

      this.setCanvas();
      var w=this.form.glassW*1;
      var h=this.form.glassH*1;
      /*
      console.log("坐标转换typeof(myobj)===",typeof(myobj));
      console.log("坐标转换==myobj=",myobj);
      console.log("坐标转换==myobj=",myobj.markers);
      console.log("坐标转换w===",w);
      console.log("坐标转换h===",h);
      console.log("坐标转换this.form.glassW===",this.form.glassW);
      console.log("坐标转换this.form.glassH===",this.form.glassH);
      var svg = makerjs.exporter.toSVG(myobj.markers, this.renderOptions);
      document.getElementById("drawCanvas").innerHTML = svg;
      //重写SVG
      var myDrawing = document.getElementById("myDrawing").innerHTML;
      var html =
        '<svg width="' +
        (this.form.glassW * 1 + 400) +
        '" height="' +
        (this.form.glassH * 1 + 400) +
        '" viewBox="-200 150 ' +
        (this.form.glassW * 1 + 400) +
        " " +
        (this.form.glassH * 1 + 400) +
        '" xmlns="http://www.w3.org/2000/svg" id="myDrawing">';
      var mySVGHtml = html + myDrawing + "</svg>";
      document.getElementById("drawCanvas").innerHTML = "";
      document.getElementById("drawCanvas").innerHTML = mySVGHtml; 
      */
     this.creatSvg(w, h, myobj.markers); 
      this.toChangeXYCutplate=_.cloneDeep(myobj.cutPlate);  
      console.log("坐标转换this.toChangeXYCutplate===",this.toChangeXYCutplate);  
  },

/**
 * 切换XY画图，画图完成后导出图再切换回原状态
 * changeXYRadioEvent（）
 * 
 * 
 * 
 */

    /**为输入框添加 如果焦点在刚内容处于选中状态 */
    handleFocus(event) {
      // 延迟执行以确保内容被正确选中
      setTimeout(() => {
        event.target.select();
      }, 0);
    },
    /**为输入框添加 如果焦点在刚内容处于选中状态 */

    drawAb(glassW, glassH, plate, markers) {
      // document.getElementById("drawAbCanvas").innerHTML = "";
      //this.setAbCanvas();

      //      console.log("document.getElementByIdinnerHTML==",document.getElementById("drawAbCanvas").innerHTML);
      // var elements=document.getElementById("drawAbCanvas").innerHTML;
      // console.log("elements=***=",elements);
      this.$nextTick(() => {
        //console.log(this.$refs.myDraws.innerText); // 打印 "end"

        ////
        ////
        this.setAbCanvas();

        console.log("this.BorderScaleAb===", this.BorderScaleAb);
        if (this.BorderScaleAb < 1) {
          var bordwd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
          var bordhd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
          var hd = h * 1 - this.myScaleAbHAll * 1;
          var wd = 0;
          console.log("h*this.BorderScaleAb*1===", h * this.BorderScaleAb * 1);
          console.log("bordhd*1===", bordhd * 1);
          console.log("markShiftThree===", this.markShiftThree);
          console.log("hd===", hd);
          console.log("wd===", wd);
          console.log("bordwd===", bordwd);
          console.log("bordhd===", bordhd);
        } else if (this.BorderScaleAb > 1) {
          var bordwd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
          var bordhd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
          var hd = h * 1 - this.myScaleAbHAll * 1;
          var wd = 0;
          console.log("this.BorderScaleAb*1===", this.BorderScaleAb * 1);
          console.log("h*this.BorderScaleAb*1===", h * this.BorderScaleAb * 1);
          console.log("bordhd*1===", bordhd * 1);
          console.log("markShiftThree===", this.markShiftThree);
          console.log("hd===", hd);
          console.log("wd===", wd);
          console.log("bordwd===", bordwd);
          console.log("bordhd===", bordhd);
        } else if (this.BorderScaleAb == 1) {
          if (this.myScaleAbHAll < h) {
            var hd = h * 1 - this.myScaleAbHAll * 1,
              wd = 0;
            var bordwd = -((this.markShiftThree * 5) / 2) * 2,
              bordhd = -((this.markShiftThree * 5) / 2) * 2;
          } else if (this.myScaleAbHAll > h) {
            var hd = h * 1 - this.myScaleAbHAll * 1,
              wd = 0;
            var bordwd = -((this.markShiftThree * 5) / 2) * 2,
              bordhd = -((this.markShiftThree * 5) / 2) * 2;
          } else {
            console.log("this.markShiftThree=", this.markShiftThree);
            console.log(
              "this.markShiftThree*1/2=",
              (this.markShiftThree * 1) / 2
            );
            var hd = 0,
              wd = 0;
            var bordwd = -((this.markShiftThree * 5) / 2) * 2,
              bordhd = -((this.markShiftThree * 5) / 2) * 2;
          }

          console.log("bordwd===", bordwd);
        }
        console.log("bordwd202020202020202020===", bordwd);
        console.log("bordhd02020202020202020202===", bordhd);
        ///////

        makerjs.model.move(markers, [-wd, -hd]);

        var w = glassW,
          h = glassH;
        var svg = makerjs.exporter.toSVG(markers, this.renderOptionsAb);
        console.log("svg==", svg);
        var ggg1 = svg.split('id="myAbImgs">');
        var ggg2 = ggg1[1].split("</svg>");
        console.log("ggg1==", ggg1);
        console.log("ggg2==", ggg2);
        var mirrorPlate=makerjs.model.mirror(plate, true, false);
        //德法水刀 坐标需要镜像处理  mirrorDxf
        this.mirrorDxf = makerjs.exporter.toDXF(mirrorPlate,this.dxfOption);
        this.abDxf = makerjs.exporter.toDXF(plate,this.dxfOption);
        this.$refs.myDraws.innerHTML = ggg2[0];
        console.log("++++++==", this.$refs.myDraws.innerHTML);
        //重写SVG
        var html =
          '<svg width="' +
          (w * 1 + this.markShiftThree * 25) +
          '" height="' +
          (h * 1 + this.markShiftThree * 10) +
          '" viewBox="' +
          -100 +
          " " +
          -100 +
          " " +
          (w * 1 + this.markShiftThree * 25) +
          " " +
          (h * 1 + this.markShiftThree * 10) +
          '" xmlns="http://www.w3.org/2000/svg" id="myAbImgs">';
        var mySVGHtml = html + ggg2[0] + "</svg>";
        this.$refs.myDraws.innerHTML = "";
        this.$refs.myDraws.innerHTML = mySVGHtml;
        // this.updateState();
      });
    },
    drawAbnormalShape() {
      this.abnormalShapeBox = true;
      if (this.abnormalShapeBox) {
        console.log("this.MDASSubMenuType==", this.MDASSubMenuType);
        // console.log("this.MDASMenuType==",this.MDASMenuType);
        console.log("activeParamData=", _.cloneDeep(this.activeParamData));

        var shape = this.MDASSubMenuType.replace("_", "");
        console.log("shape=", shape);
        //shape="drawAbnormalShape"+shape;
        console.log("shape00000=", shape);
        var model = {
          plate: this.plate,
          markers: this.markers,
          cutPlate: this.cutPlate,
        };
        var fixedParam = {
          markShift: this.markShift,
          markShiftTwo: this.markShiftTwo,
          markShiftThree: this.markShiftThree,
          markShiftFour: this.markShiftFour,
          markHolesOneD: this.markHolesOneD,
        };
        var Param = _.cloneDeep(this.activeParamData);
        var myobj = this.$myutils[shape](
          //this.operationParam,
          model,
          this.zoomM,
          Param,
          fixedParam
        );
        console.log("myobj=", myobj);
        console.log("myobj.markers=", myobj.markers);
        this.abPlate = _.cloneDeep(myobj.plate); //只有路径数据 供转换DXF格式使用
        this.abMarkers = _.cloneDeep(myobj.markers); //包含标记数据 给到SVG
        this.abForm.glassW = _.cloneDeep(myobj.w); //设备格式
        this.abForm.glassH = _.cloneDeep(myobj.h); //设备格式

        this.drawAb(myobj.w, myobj.h, myobj.plate, myobj.markers);
      }
    },

    ////20250620异形模板库根据矩形的大小设置画面的大小及缩放比例
    setAbCanvas() {
      console.log("setMdCanvas===this.visitMdNum访问次****=", this.visitAbNum);
      var w = this.abForm.glassW * 1, //1200  51vw
        h = this.abForm.glassH * 1; //600   75vh
      var myScaleW = (1000 / w).toFixed(1);
      var myScaleH = (600 / h).toFixed(1);
      //this.myScaleH=myScaleH;
      //this.BorderScaleMd=myScaleW*1;
      console.log("wwwwwww=", w, "HHHH====", h);
      console.log("myScaleW=", myScaleW, "myScaleH====", myScaleH);
      var drawCanvas = document.getElementById("drawAbCanvas");
      console.log("drawCanvas===", drawCanvas);
      drawCanvas.style.display = "flex";
      drawCanvas.style.justifyContent = "center";
      drawCanvas.style.alignItems = "center";
      drawCanvas.style.height = 65 + "vh";
      drawCanvas.style.width = 51 + "vw";

      this.renderOptionsAb.fontSize = "16px";
      this.renderOptionsAb.strokeWidth = "0.3mm";

      this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）

      if (this.visitAbNum == 0) {
        this.myScaleAbWAll = w;
        this.myScaleAbHAll = h;
        ///////////////////////////////////////////
        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            // this.BorderScale=myScaleW*1;
            this.renderOptionsAb.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptionsAb.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.renderOptionsAb.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptionsAb.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          }
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例

          this.renderOptionsAb.fontSize = "16px";
          this.renderOptionsAb.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        }
        //////////////////////////////////////
        this.BorderScaleAb = 1;
      } else {
        //this.myScaleHAll=myScaleH
        console.log("this.myScaleAbHAll===", this.myScaleAbHAll);
        console.log("myScaleH===", myScaleH);

        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            this.BorderScaleAb = myScaleW * 1;
            this.renderOptionsAb.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptionsAb.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.BorderScaleAb = myScaleH * 1;
            this.renderOptionsAb.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptionsAb.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          }
        } else if (myScaleH > 1 && myScaleW > 1) {
          console.log("myScaleW>1||myScaleH>1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScaleAb = myScaleH * 1;
          this.renderOptionsAb.fontSize = "16px";
          this.renderOptionsAb.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScaleAb = 1;
          this.renderOptionsAb.fontSize = "16px";
          this.renderOptionsAb.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        }
      }
    },

    ////////////异形模板库

    handleClickSpecialShaped() {},
    /**输入框参数修改获取修改后参数 */
    changeAbInputParma() {
      console.log("*******===this.activeParamData==", this.activeParamData);
      this.$forceUpdate();
    },
    openAbnormalShapedLibrary() {
      this.MdAbnormalShapeWin = true;
      this.activeMdashape = 0;
      this.activeMdasideMenu = 0;
      this.getAbnormalShapedMdMenuLabel();
      this.getAbnormalShapedMdSubMenuLabel(this.MDASMenuType);
      this.getAbnormalShapedMdSubEx(this.MDASSubMenuType);
    },
    handleOpenLabelMenu(key, keyPath) {
      console.log(key, keyPath);
    },
    handleCloseLabelMenu(key, keyPath) {
      console.log(key, keyPath);
    },
    /**异形模板库主分类**/
    getAbnormalShapedMdMenuLabel() {
      //MDASMenulabel
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      var myURLToJson = base + "/getData/getAbShapeData.php";
      /**POST */
      // console.log("this.mdParma==", this.mdParma);
      var MenuParma = {};
      this.axios
        .post(myURLToJson, MenuParma, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("res=主分类=", res);
          if (res.data.flag == "1") {
            var getData = _.cloneDeep(res.data.datas);
            console.log("getData==", getData[0].TypeName);
            this.MDASMenulabel = getData;
          } else if (res.data.flag == "2") {
            this.$message.error(res.data.info);
          } else if (res.data.flag == "3") {
            this.$message.error(res.data.info);
          }
          // console.log("res.data22==",JSON.parse(datas));
        })
        .catch((error) => {
          // 处理错误
          console.error("error=", error);
        });
      /**POST */
    },
    /**异形模板库子分类**/
    getAbnormalShapedMdSubMenuLabel(type) {
      //MDASMenulabel
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      var myURLToJson = base + "/getData/getAbShapeSubData.php";
      /**POST */
      // console.log("this.mdParma==", this.mdParma);MDASMenuType
      var mytype = type;
      var MenuParma = { TypeName: mytype };
      this.axios
        .post(myURLToJson, MenuParma, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("res=子分类=", res);
          if (res.data.flag == "1") {
            var getData = _.cloneDeep(res.data.datas);
            //console.log("getData==", getData[0].TypeName);
            this.MainImg = getData;
          } else if (res.data.flag == "2") {
            this.$message.error(res.data.info);
          } else if (res.data.flag == "3") {
            this.$message.error(res.data.info);
          }
          // console.log("res.data22==",JSON.parse(datas));
        })
        .catch((error) => {
          // 处理错误
          console.error("error=", error);
        });
      /**POST */
    },
    /**以最后一个等号分割成两个字符串 */
    splitCharacters(str) {
      let index = str.lastIndexOf("=");
      console.log("index==", index);
      let leftPart = str.substring(0, index); // 分割后的左边部分
      let rightPart = str.substring(index + 1); // 分割后的右边部分
      console.log("leftPart=", leftPart); // 输出: example=test
      console.log("rightPart=", rightPart); // 输出: data
      return [leftPart, rightPart];
    },
    /**异形模板库示意图分类**/

    getAbnormalShapedMdSubEx(type) {
      //MDASMenulabel
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      var myURLToJson = base + "/getData/getAbShapeSubDataEx.php";
      /**POST */
      // console.log("this.mdParma==", this.mdParma);MDASMenuType
      var mytype = type;
      var MenuParma = { TypeSubName: mytype };
      this.axios
        .post(myURLToJson, MenuParma, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("res=示意图分类=", res);
          if (res.data.flag == "1") {
            var getData = _.cloneDeep(res.data.datas);
            // console.log("getData==", getData[0].TypeName);
            if (getData == "") {
              console.log("数据为空！");
            } else {
              //activeImg:{"imgURL":"","parmaData":""},
              this.activeImgimgURL = getData[0].TypeSubImgEx;
              var recDatas = _.cloneDeep(getData[0].TypeSubParamEx);
              console.log("recDatas==", recDatas);
              console.log("recDatas.length==", recDatas.length);
              console.log("type=", typeof recDatas);
              var recDatasMid = JSON.parse(recDatas);
              var objLen = this.objHasOwnProperty(recDatasMid);
              console.log("objLen=", objLen);
              var objArr = [];
              if (objLen > 0) {
                console.log("*****");

                for (let key in recDatasMid) {
                  if (recDatasMid.hasOwnProperty(key)) {
                    // 确保key是对象自身的属性
                    let value = recDatasMid[key];
                    console.log(key + "*******: *****" + value);
                    var arr = this.splitCharacters(value);

                    var objParams = {
                      name: arr[0],
                      param: arr[1],
                    };
                    objArr.push(objParams);
                    //var propName = this.activeParam[key].shape + "-" +key;
                  }
                }
              }
              var objParam = objArr;
              console.log("this.objArr!!!!!!!!===", objArr);
              console.log("this.objParam!!!!!!!!===", objParam);
              //this.activeParamData=JSON.parse(getData[0].TypeSubParamEx);
              this.activeParamData = objArr;
              console.log("activeParamData=示意图分类=", this.activeParamData);
            }
          } else if (res.data.flag == "2") {
            this.$message.error(res.data.info);
          } else if (res.data.flag == "3") {
            this.$message.error(res.data.info);
          }
          // console.log("res.data22==",JSON.parse(datas));
        })
        .catch((error) => {
          // 处理错误
          console.error("error=", error);
        });
      /**POST */
    },
    /*****点击子分类图片获取示意图 */
    mdashapeImgClick(index, typename) {
      console.log("typename=", typename);
      this.activeMdashape = index;
      this.MDASSubMenuType = typename;
      this.getAbnormalShapedMdSubEx(typename);
    },
    /**点击主分类图片获取子分类 */
    mdashapeasideMenuClick(index, typename) {
      console.log("typename=", typename);
      this.MDASMenuType = typename;
      var type = typename.slice(-1) + "_01";
      console.log("type=", type);
      this.MDASSubMenuType = type;
      this.activeMdasideMenu = index;
      this.getAbnormalShapedMdSubEx(type);
      this.getAbnormalShapedMdSubMenuLabel(typename);
      this.mdashapeImgClick(0, typename);
    },
    ////////////异形模板库
    //楼梯相关函数方法
    ///局部刷新函数

    /******楼梯相关函数*/
    /**打开添加坐标窗口
     * 可见性控制
     */
    openAddStairPointWin() {
      this.addStairPointWinVisible = true;
    },
    //添加坐标窗口，确定按钮，
    /**
     *确定后图完成，添加坐标可实时改变图的形状
     *
     */
    addStairPoint() {
      this.addStairPointWinVisible = false;
    },
    addPoint() {
      this.dialogStairAddVisible = false;
      // addPointNum:"2",
      // addFloorNum:"2",
      console.log("this.addPointNum=", this.addPointNum);
      console.log("this.addFloorNum=", this.addFloorNum);
      for (let i = 0; i < this.addPointNum; i++) {
        var obj = {
          id: new Date().getTime() + Math.random().toString(36).substring(2),
          x: 0,
          y: 0,
        };
        this.brokenLinePoint.push(obj);
      }
      console.log("this.brokenLinePoint==", this.brokenLinePoint);
    },
    addFloor() {
      this.dialogStairFloorVisible = false;
      // addPointNum:"2",
      // addFloorNum:"2",
      var nums = this.addFloorNum * 2 + 2;
      for (let i = 1; i < nums; i++) {
        var obj = {
          id: new Date().getTime() + Math.random().toString(36).substring(2),
          x: 0,
          y: 0,
        };
        this.brokenLinePoint.push(obj);
      }
      console.log("this.brokenLinePoint==", this.brokenLinePoint);
    },
    handleEnterPoint(index) {
      var obj = {
        id: new Date().getTime() + Math.random().toString(36).substring(2),
        x: 0,
        y: 0,
      };
      this.brokenLinePoint.push(obj);
      // console.log("index==",`input${index+1}`);
      // console.log("this.$refs==",this.$refs);
      // var input="input"+(index+1);
      // console.log("input=",input);
      // console.log("this.$refs[input]=",this.$refs[input]);
      // setTimeout(() => {
      //     if (this.$refs[input]["0"]) {
      //       this.$refs[input]["0"].focus();
      //     }
      //     }, 500);

      // var obj={id:id*1+1,x:0,y:0};
      // var newId=obj.id
      // console.log("newId",newId);
      // this.brokenLinePoint.push(obj);
    },

    delPoint(id) {
      this.brokenLinePoint.splice(id, 1);
    },
    creatStairDraw(type, shape) {
      //creatStairDraw('SpecialShaped', 'StairCase')"
      //roundCorner
      console.log("type==", type);
      console.log("shape==", shape);
      var brokenLinePoint = _.cloneDeep(this.brokenLinePoint);
      var inputPoint = { ...this.bottomLinePoint, brokenLinePoint };
      console.log("inputPoint==", inputPoint);
      var model = {
        plate: this.plate,
        markers: this.markers,
        cutPlate: this.cutPlate,
      };
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };
      var myobj = this.$myutils[shape](
        this.roundCorner,
        inputPoint,
        model,
        fixedParam,
        this.zoomM
      );
      console.log("myobj==", myobj);
      console.log("myobj.cutPlate.models==", myobj.cutPlate.models);
      var w = this.specialShapedRect.w,
        h = this.specialShapedRect.h,
        maker = myobj.cutPlate.models;
      if (w == 0 || h == 0) {
        this.myOpenMsg("矩形外框尺寸不能为0", "贵友提示您：");
      } else {
        this.creatDraw(myobj.markers, myobj.plate, myobj.cutPlate, w, h);
        this.plate = _.cloneDeep(myobj.plate);
        this.markers = _.cloneDeep(myobj.markers);
        this.cutPlate = _.cloneDeep(myobj.cutPlate);
        this.myHolesNum = _.cloneDeep(myobj.myHolesNum);
      }
    },

    //以上为楼梯相关函数方法
    //输入数字返回区域字母
    changeArea(num) {
      var areaPoint;
      switch (num) {
        case "1":
          areaPoint = "A";
          break;
        case "2":
          areaPoint = "B";
          break;
        case "3":
          areaPoint = "C";
          break;
        case "4":
          areaPoint = "D";
          break;
        case "5":
          areaPoint = "E";
          break;
        case "6":
          areaPoint = "F";
          break;
        case "7":
          areaPoint = "G";
          break;
        case "8":
          areaPoint = "H";
          break;
        case "9":
          areaPoint = "I";
          break;
      }
      return areaPoint;
    },
    //多层级对象属性值去掉双引号。
    removeQuotesDeep(obj) {
      if (typeof obj === "object" && obj !== null) {
        Object.keys(obj).forEach((key) => {
          if (typeof obj[key] === "string") {
            try {
              const parsed = JSON.parse(obj[key]);
              obj[key] = parsed;
            } catch (e) {
              // 不是有效的JSON，或者解析过程中抛出错误，保持原样
            }
          } else if (typeof obj[key] === "object") {
            this.removeQuotesDeep(obj[key]);
          }
        });
      }
      return obj;
    },
    //返回属性数量
    objHasOwnProperty(obj) {
      var count = 0;
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          count++;
        }
      }
      return count;
    },
    /**模板窗口 */
    handleUserMdClickGap(tab, event) {
      if (tab.label == "孔") {
        this.mdParma.mdTpye = 1;
      } else if (tab.label == "缺") {
        this.mdParma.mdTpye = 2;
      } else if (tab.label == "角") {
        this.mdParma.mdTpye = 3;
      }
      console.log("this.mdParma.mdTpye=", this.mdParma.mdTpye);
      this.openMdWin(this.mdParma.mdTpye);
      // mdParma: {
      //   userName: "",
      //   mdTpye: "",
      // },
      console.log("tab.label==", tab.label);
      console.log("handleUserMdClickGap==///////////tab//////////", tab);
      console.log("handleUserMdClickGap==///////////event//////////", event);
    },

    handleCollapseChange(val) {
      console.log("val=", val);
    },
    //自用模板志出切割机文件
    glassUserMdCut() {
      var i = this.activeImg;
      var rectW = this.activeBigSize.X,
        rectH = this.activeBigSize.Y;
      console.log(
        "this.getMdDataDraw=",
        _.cloneDeep(this.getMdDataDraw)[i].cutPlate.models
      );
      var obj = _.cloneDeep(this.getMdDataDraw[i].cutPlate);
      
        var mirrorPlate=makerjs.model.mirror(_.cloneDeep(this.getMdDataDraw[i].cutPlate), true, false);
        //德法水刀 坐标需要镜像处理  mirrorDxf
        this.mirrorUserMdDxf = makerjs.exporter.toDXF(mirrorPlate,this.dxfOption);
      this.userMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(obj),this.dxfOption);
      if (this.objIsEmpty(this.getMdDataDraw[i].cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        var arrs = [];
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          rectW +
          "\n20\n" +
          rectH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n" + rectW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = this.userMdDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.userMdDxf = strings + arrStr + arrs[1];
        console.log("this.userMdDxf******=", this.userMdDxf);
        //this.saveUserMdDXF();
        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.userMdDxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.userMdDxf
          );
          }
       
        //this.saveHolesPng();
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    //自用模板导出水刀格式
    saveUserMdDXF() {
      if(this.gySer==""){
        var fileNames = this.creatDate(); 
            }           
            else {
         var fileNames = this.GlasslD;
            }
      
      var blob = new Blob([this.userMdDxf]);
      console.log("blob====", blob);
      // 创建一个 URL 对象来引用 Blob 数据
      var url = window.URL || window.webkitURL;
      var downloadUrl = url.createObjectURL(blob);

      // 创建一个链接元素并设置其属性
      var link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileNames + ".dxf"; // 指定下载时的文件名
      // 模拟点击链接进行下载
      link.click();
      // 清除 URL 对象
      url.revokeObjectURL(downloadUrl);
    },
    saveUserMdWaterJetYiFeng() {
      console.log("亦丰水刀");
      // getMdDataDraw
      var i = this.activeImg;
      var rectW = this.activeBigSize.X,
        rectH = this.activeBigSize.Y;
      console.log(
        "this.getMdDataDraw=",
        _.cloneDeep(this.getMdDataDraw)[i].cutPlate.models
      );
      var obj = _.cloneDeep(this.getMdDataDraw[i].cutPlate);
      this.userMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(obj),this.dxfOption);
      if (this.objIsEmpty(this.getMdDataDraw[i].cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        var arrs = [];
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          rectW +
          "\n20\n" +
          rectH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n" + rectW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = this.userMdDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.userMdDxf = strings + arrStr + arrs[1];
        console.log("this.userMdDxf******=", this.userMdDxf);
       // this.saveUserMdDXF();


        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.userMdDxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.userMdDxf
          );
          }
       
        //this.saveHolesPng();
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    saveUserMdWaterJetJinBo() {
      console.log("玻锐水刀");
      // getMdDataDraw
      var i = this.activeImg;
      var rectW = this.activeBigSize.X,
        rectH = this.activeBigSize.Y;
      console.log(
        "this.getMdDataDraw=",
        _.cloneDeep(this.getMdDataDraw)[i].cutPlate.models
      );
      var obj = _.cloneDeep(this.getMdDataDraw[i].cutPlate);
      this.userMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(obj),this.dxfOption);
      if (this.objIsEmpty(this.getMdDataDraw[i].cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        var arrs = [];
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          rectW +
          "\n20\n" +
          rectH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n" + rectW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = this.userMdDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.userMdDxf = strings + arrStr + arrs[1];
        console.log("this.userMdDxf******=", this.userMdDxf);
        //this.saveUserMdDXF();
        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.userMdDxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.userMdDxf
          );
          }
       
        //this.saveHolesPng();
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    saveUserMdWaterJetDeFa() {
      console.log("saveUserMdWaterJetDeFa()德法水刀");
      // getMdDataDraw
      var i = this.activeImg;
      var rectW = this.activeBigSize.X,
        rectH = this.activeBigSize.Y;
      console.log(
        "this.getMdDataDraw=",
        _.cloneDeep(this.getMdDataDraw)[i].cutPlate.models
      );

      ///////////////////////////////////////////////////
      //////////////////////////////////////////////////

     if(this.waterCutSetPramMd=="1"){
         this.waterCutSetVisibleMd=false; 
         /////////////////**********去掉孔代码************//////////////////
        let obj = _.cloneDeep(this.getMdDataDraw[i].cutPlate.models);
        console.log("saveUserMdWaterJetDeFa()||obj0000==",obj);
        let propertyNames = Object.keys(obj); // 返回一个包含属性名称的数组 ['name', 'age']
        console.log("saveUserMdWaterJetDeFa()||获取属性名称==PPPPPPPPPPPP=20251008",propertyNames);
        var myObjs={models:{},};
        for(var i = 0; i < propertyNames.length; i++){
           var areaNames=propertyNames[i];
           //截取js字符串的前5位：;
            var substr = areaNames.substring(0, 9);
            console.log(substr); // 
            console.log(obj[areaNames]); // 
            var objModelsCut={models:{}};
            if(substr=="TypeCorne" || substr=="TypeGapes"){
             console.log("saveUserMdWaterJetDeFa()||删除属性！",areaNames);
                // delete obj[areaNames];
             myObjs.models[areaNames] = obj[areaNames];
             objModelsCut.models={...myObjs.models};
             }
        } 
         console.log("saveUserMdWaterJetDeFa()||obj==",obj);
         console.log("saveUserMdWaterJetDeFa()||objModelsCut==",objModelsCut);
         console.log("saveUserMdWaterJetDeFa()||this.getMdDataDraw[i].cutPlate.models==",this.getMdDataDraw[i].cutPlate.models);

       /////////////////***********去掉孔代码************//////////////////

      //////////////////////////////////////////////////////
      // var obj = _.cloneDeep(this.getMdDataDraw[i].cutPlate);
      console.log("obj===",obj);
      // obj=JSON.parse(JSON.stringify((obj));      
      console.log("obj==typeof=",typeof(obj));
      var mirrorPlateMd=makerjs.model.mirror(this.removeQuotesDeep(objModelsCut), true, false);
        //德法水刀 坐标需要镜像处理  mirrorDxf        
      console.log("saveUserMdWaterJetDeFa()德法水刀mirrorPlate===",mirrorPlateMd);
      console.log("saveUserMdWaterJetDeFa()德法水刀this.removeQuotesDeep(mirrorPlate)e===",this.removeQuotesDeep(mirrorPlateMd));

        var mirrorUserMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(mirrorPlateMd),this.dxfOption);
        // this.userMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(obj),this.dxfOption);
        //  console.log("this.mirrorUserMdDxf===",this.mirrorUserMdDxf);
      if (this.objIsEmpty(this.getMdDataDraw[i].cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        var arrs = [];
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          rectW +
          "\n20\n" +
          rectH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n" + rectW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = mirrorUserMdDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        mirrorUserMdDxf = strings + arrStr + arrs[1];
        if(this.setOUtFileName=="A"){
          this.downloadHoles(
            this.GlasslD  + ".dxf",
            mirrorUserMdDxf
          );
          }else if(this.setOUtFileName=="B"){
          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            mirrorUserMdDxf
          );
          }
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
           this.sendDataToERP();
         }
         }
      //////////////////////////////////////////////////
  
     }else if(this.waterCutSetPramMd=="2"){
      this.waterCutSetVisibleMd=false; 
      //////////////////////////////////////////////////////
      var obj = _.cloneDeep(this.getMdDataDraw[i].cutPlate);
      console.log("obj===",obj);
      // obj=JSON.parse(JSON.stringify((obj));      
      console.log("obj==typeof=",typeof(obj));
      var mirrorPlateMd=makerjs.model.mirror(this.removeQuotesDeep(obj), true, false);
        //德法水刀 坐标需要镜像处理  mirrorDxf        
      console.log("saveUserMdWaterJetDeFa()德法水刀mirrorPlate===",mirrorPlateMd);
      console.log("saveUserMdWaterJetDeFa()德法水刀this.removeQuotesDeep(mirrorPlate)e===",this.removeQuotesDeep(mirrorPlateMd));

        this.mirrorUserMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(mirrorPlateMd),this.dxfOption);
        // this.userMdDxf = makerjs.exporter.toDXF(this.removeQuotesDeep(obj),this.dxfOption);
        //  console.log("this.mirrorUserMdDxf===",this.mirrorUserMdDxf);
      if (this.objIsEmpty(this.getMdDataDraw[i].cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        var arrs = [];
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          rectW +
          "\n20\n" +
          rectH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n" + rectW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = this.mirrorUserMdDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        this.mirrorUserMdDxf = strings + arrStr + arrs[1];
        if(this.setOUtFileName=="A"){
          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.mirrorUserMdDxf
          );
          }else if(this.setOUtFileName=="B"){
          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.mirrorUserMdDxf
          );
          }
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
      //////////////////////////////////////////////////

     }     
    },
    
    //设置水刀格式
       // changSetWaterCutMd(){
       //  console.log("this.WaterJetBrand=2025.10.11=",this.userMdWaterJetBrand);
       //   if (this.userMdWaterJetBrand == "defa") {
       //     this.saveUserMdWaterJetDeFa();
       //   } else if (this.userMdWaterJetBrand == "aotuofu") {
         //     this.saveUserMdWaterJetYiFeng();
        //   } else if (this.userMdWaterJetBrand == "yifeng") {
        //     this.saveUserMdWaterJetYiFeng();
        //   }else if(this.userMdWaterJetBrand == "jinbo"){
        //     this.saveUserMdWaterJetJinBo();
        //   }else if(this.userMdWaterJetBrand == "dadi"){
        //     this.saveUserMdWaterJetYiFeng();
        //   }
        // },
        // waterCutSetChangeMd(e){     
        //    console.log("waterCutSetChange(e)==e==",e);     
        //    console.log("waterCutSetChange(e)==typeof(e)==",typeof(e));  
        //    this.waterCutSetPramMd=e;
       
        //   console.log("waterCutSetChange(e)==exWaterJetToDeFa|||this.cutPlate=", this.cutPlate);
        //    console.log("waterCutSetChange(e)==this.waterCutSetPram==",this.waterCutSetPramMd);
        // },
    exUserMdWaterJet(command) {
      console.log("exUserMdWaterJet=");
      this.userMdWaterJetBrand = command;      
      //  this.waterCutSetVisibleMd=true;
      console.log("this.WaterJetBrand=2025.10.11=",this.userMdWaterJetBrand);
      if (this.userMdWaterJetBrand == "defa") {
        this.saveUserMdWaterJetDeFa();
      } else if (this.userMdWaterJetBrand == "aotuofu") {
        this.saveUserMdWaterJetYiFeng();
      } else if (this.userMdWaterJetBrand == "yifeng") {
        this.saveUserMdWaterJetYiFeng();
      }else if(this.userMdWaterJetBrand == "jinbo"){
        this.saveUserMdWaterJetJinBo();
      }else if(this.userMdWaterJetBrand == "dadi"){
        this.saveUserMdWaterJetYiFeng();
      }
    },
    ////////////////
    delMdImgClick(id, type, index) {
      console.log("测试id===", id);
      var delParama = { userMdID: 0, userMdName: "" };
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      var myURLToJson = base + "/getData/delMdData.php";
      var token = Cookies.get("token");
      var dataName = JSON.parse(token);
      console.log("token.username==", dataName.username);
      delParama.userMdName = dataName.username;
      delParama.userMdID = id;
      console.log("delParama==", delParama);
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.axios
            .post(myURLToJson, delParama, {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            })
            .then((res) => {
              console.log("res==", res);
              if (res.data.flag == "1") {
                console.log("测试删除成功！");
                this.$message({
                  message: "删除成功",
                  type: "success",
                });
                if (this.activeImg == index) {
                  console.log("测试是当前选中模板");
                  // this.getMdDataDraw.splice([index],1);
                  console.log("this.inputLoadParam", this.inputLoadParam);
                  console.log("this.activeImg", this.activeImg);
                  var num = this.getMdDataDraw.length,
                    indexs = index * 1 + 1;
                  console.log("num==", num);
                  console.log("index==", index);
                  this.getMdDataDraw.splice([index], 1);
                  this.getDrawOp.splice([index], 1);
                  if (num == indexs) {
                    this.mdImgClick(index - 1);
                  } else {
                    this.mdImgClick(this.activeImg);
                  }
                } else {
                  console.log("非选中模板&&&&&&");
                  var num = this.getMdDataDraw.length;
                  console.log("num==", num);
                  console.log("index==", index);
                  this.getMdDataDraw.splice([index], 1);
                  this.getDrawOp.splice([index], 1);
                }
                // this.downMdData();
              } else if (res.data.flag == "2") {
                this.$message.error(res.data.info);
              }
              // console.log("res.data22==",JSON.parse(datas));
            })
            .catch((error) => {
              // 处理错误
              console.error("error=", error);
            });

          // this.$message({
          //   type: 'success',
          //   message: '删除成功!'
          // });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //自用模板库精锐打孔机
    saveHolesUserMdJingrui() {
      var count = this.objHasOwnProperty(this.inputLoadParam);
      if (count <= 1) {
        this.myOpenMsg("没有图形，请先画图。", "提示：");
      } else {
        console.log("自用模板库精锐打孔机");
        var arrH = [];
        var rectW = this.activeBigSize.X,
          rectH = this.activeBigSize.Y;
        var arrH = [];
        var activeParam = [];
        activeParam = this.getDrawOp[this.activeImg];
        console.log("activeParam", activeParam);
        var exOprationParam = _.cloneDeep(this.inputLoadParam);
        console.log("exOprationParam", exOprationParam);
        // getMdDataDraw
        // inputLoadParam
        for (let key in activeParam) {
          if (activeParam.hasOwnProperty(key)) {
            // 确保key是对象自身的属性
            let value = activeParam[key];
            console.log("key", key);
            console.log("value", value);
            console.log("value.type", value.type);
            console.log("value.area", value.area);
            console.log("value.shape", value.shape);
            console.log("exOprationParam[key]", exOprationParam[key]);
            // var propName=this.activeParam[key].shape+"-"+key;
            exOprationParam[key]["type"] = value.type;
            exOprationParam[key]["area"] = value.area;
            exOprationParam[key]["shape"] = value.shape;
          }
        }
        delete exOprationParam["Rectangle"];
        console.log("exOprationParam=", exOprationParam);
        console.log("exOprationParam.length=", exOprationParam.length);
        console.log("this.getMdDataDraw=", this.getMdDataDraw);
        console.log("this.getDrawOp.length=", this.getDrawOp.length);
        for (let key in exOprationParam) {
          if (exOprationParam.hasOwnProperty(key)) {
            // 确保key是对象自身的属性
            let value = exOprationParam[key];
            console.log(value.type + "*******: *****" + value.type);
            if (value.type == "Hole") {
              /** 孔*/
              if (value.shape == "SingleHole") {
                /**
                 * 单孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy = (this.form.glassH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hx = ((this.form.glassW * 1) / 2).toFixed(0);
                  var Hy = (this.form.glassH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 5) {
                  var Hx = ((rectW * 1) / 2).toFixed(0);
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx = ((rectW * 1) / 2).toFixed(0);
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 单孔
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleTwo") {
                console.log("吊轮孔2");
                /**
                 * 吊轮孔2
                 *
                 */
                if (value.area * 1 == 4) {
                  console.log("吊轮孔22222");
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  console.log("吊轮孔22222");
                  var Hx = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 吊轮孔2
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleThree") {
                /**
                 * 吊轮孔3
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = ((rectH * 1) / 2).toFixed(0);
                  var Hy3 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy3 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 吊轮孔3
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleTwoCol") {
                /**
                 * 4、双吊轮孔列
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.H * 1 + value.X * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(0);

                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(0);

                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 4、双吊轮孔列
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleTwoRow") {
                /**
                 * 5、双吊轮孔排
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (+(value.W * 1) + value.Y * 1).toFixed(0);
                  var Hy3 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy4 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy3 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy4 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 5、双吊轮孔排
                 *
                 *
                 */
              } else if (value.shape == "HangHole") {
                /**
                 * 6、晾物孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(0);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    0
                  );
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(0);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(0);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    0
                  );
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(0);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 6、晾物孔
                 *
                 *
                 */
              } else if (value.shape == "HandleHoleTShaped") {
                /**
                 * 7、拉手孔T字
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(0);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    0
                  );
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(0);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(0);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    0
                  );
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(0);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 7、拉手孔T字
                 *
                 *
                 */
              } else if (value.shape == "DoubleFixHoles") {
                /**
                 * 8、双固定孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 5) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 8、双固定孔
                 *
                 *
                 */
              } else if (value.shape == "DoubleFixHolesCol") {
                /**
                 * 8、双固定孔列
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 8、双固定孔
                 *
                 *
                 */
              } else if (value.shape == "RelSuWheelHole") {
                /**
                 * 9、相对吊轮孔
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(0);
                  var Hy3 = (value.Y * 1 + value.W * 1 + value.W * 1).toFixed(
                    0
                  );
                  var Hy4 = (
                    rectH * 1 -
                    value.Y * 1 -
                    value.W * 1 -
                    value.W * 1
                  ).toFixed(0);
                  var Hy5 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(0);
                  var Hy6 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hx = (value.X * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy3 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy4 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy5 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy6 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 9、相对吊轮孔
                 *
                 *
                 */
              } else if (value.shape == "HandleHole") {
                /**
                 * 10、拉手孔
                 *
                 */
                if (value.area * 1 == 2) {
                  var Hy1 = ((rectH * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hy2 = ((rectH * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hx = ((rectW * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(0);
                  var Hy1 = ((rectH * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy2 = ((rectH * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hy1 = ((rectH * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy2 = ((rectH * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy1 = ((rectH * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hy2 = ((rectH * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hx = ((rectW * 1) / 2).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 10、拉手孔
                 *
                 *
                 */
              } else if (value.shape == "RotatLockHole") {
                /**
                 * 11、旋转锁孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy1 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy2 +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 11、旋转锁孔
                 *
                 *
                 */
              } else if (value.shape == "HandleHole3") {
                /**
                 * 12、拉手孔3
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(0);
                  var Hx3 = (value.X * 1 + value.H * 1 + value.H * 1).toFixed(
                    0
                  );
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.H * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H * 1).toFixed(0);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H * 1 -
                    value.H * 1
                  ).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hx1 = (value.X * 1 + value.H * 1 + value.H * 1).toFixed(
                    0
                  );
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(0);
                  var Hx3 = (value.X * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.H * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H * 1).toFixed(0);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H * 1 -
                    value.H * 1
                  ).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx3 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 12、拉手孔3
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleCol") {
                /**
                 * 13、吊轮孔列
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hy = ((rectH * 1) / 2).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy = (value.Y * 1).toFixed(0);
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(0);
                  var Hd = (value.D * 1).toFixed(0);
                  var holesDatas =
                    "HoleX=" +
                    Hx1 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n" +
                    "HoleX=" +
                    Hx2 +
                    "mm\r\n" +
                    "HoleY=" +
                    Hy +
                    "mm\r\n" +
                    "HoleD=" +
                    Hd +
                    "mm\r\n" +
                    "P=0\r\n";
                }

                /**
                 * 13、吊轮孔列
                 *
                 *
                 */
              } else if (value.shape == "Shaped7HandleHole") {
                /**
                 * 14、7字拉手孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(0);
                } else if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(0);
                } else if (value.area * 1 == 3) {
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(0);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(0);
                } else if (value.area * 1 == 7) {
                  var Hx1 = (value.X * 1).toFixed(0);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(0);
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(0);
                } else if (value.area * 1 == 9) {
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(0);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(0);
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(0);
                }

                var Hd = (value.D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";

                /**
                 * 14、7字拉手孔
                 *
                 *
                 */
              } else if (value.shape == "KeyHole") {
                /**
                 * 15、锁孔
                 *
                 */
                if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(0);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.W * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.W * 1).toFixed(0);
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(0);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(0);
                  var Hx1 = ((rectW * 1) / 2 - value.W * 1).toFixed(0);
                  var Hx2 = ((rectW * 1) / 2).toFixed(0);
                  var Hx3 = ((rectW * 1) / 2 + value.W * 1).toFixed(0);
                }

                var Hd1 = (value.D1 * 1).toFixed(0);
                var Hd2 = (value.D2 * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd1 +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd2 +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd1 +
                  "mm\r\n" +
                  "P=0\r\n";

                /**
                 * 15、锁孔
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles") {
                /**
                 * 16、三孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";

                /**
                 * 16、三孔
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles2") {
                /**
                 * 17、三孔2
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";

                /**
                 * 17、三孔2
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles3") {
                /**
                 * 18、三孔3
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";

                /**
                 * 18、三孔3
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles4") {
                /**
                 * 19、三孔4
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";

                /**
                 * 19、三孔4
                 *
                 *
                 */
              }
              arrH.push(holesDatas);
              /** */
            }
          }
        }
        this.holeUserMdD = arrH.join("");
        console.log("arrH===", arrH);
        console.log("arrH.length", arrH.length);
        console.log("this.holeUserMdD.length", this.holeUserMdD.length);
        console.log("this.holeUserMdD", this.holeUserMdD);
        var arr = this.holeUserMdD.split("P=0\r\n");
        arr = arr.slice(0, arr.length - 1);
        console.log("arr", arr);
        console.log("arr.length", arr.length);
        var arrHole = [];
        for (let i = 0; i < arr.length; i++) {
          var j = i * 1 + 1;
          const targetString = "Hole";
          const replacementString = "Hole" + j;
          const regex = new RegExp(targetString, "g");
          const arrs = arr[i];
          var str = arrs.replace(regex, replacementString);
          console.log("j=", j);
          arrHole.push(str);
        }
        //this.holeD=
        // console.log("arrDate", arr);
        console.log("arrHole=", arrHole);
        this.holeUserMdD = arrHole.join("");
        if (arrHole.length == 0) {
          this.myOpenMsg("您画的图中无孔，导出无效，请确认！", "提示：");
        } else {
          this.thicknessUserMdSetVisible = true;
        }
      }
    },
    //自用模板库博亮打孔机
    saveHolesUserMdBoliang() {
      console.log("****模板导出博亮打孔机格式。");
      var count = this.objHasOwnProperty(this.inputLoadParam);
      if (count <= 1) {
        this.myOpenMsg("没有图形，请先画图。", "提示：");
      } else {
        var rectW = this.activeBigSize.X,
          rectH = this.activeBigSize.Y;
        var arrH = [];
        var activeParam = [];
        activeParam = this.getDrawOp[this.activeImg];
        console.log("activeParam", activeParam);
        var exOprationParam = _.cloneDeep(this.inputLoadParam);
        console.log("exOprationParam", exOprationParam);
        // getMdDataDraw
        // inputLoadParam
        for (let key in activeParam) {
          if (activeParam.hasOwnProperty(key)) {
            // 确保key是对象自身的属性
            let value = activeParam[key];
            console.log("key", key);
            console.log("value", value);
            console.log("value.type", value.type);
            console.log("value.area", value.area);
            console.log("value.shape", value.shape);
            console.log("exOprationParam[key]", exOprationParam[key]);
            // var propName=this.activeParam[key].shape+"-"+key;
            exOprationParam[key]["type"] = value.type;
            exOprationParam[key]["area"] = value.area;
            exOprationParam[key]["shape"] = value.shape;
          }
        }
        delete exOprationParam["Rectangle"];
        console.log("exOprationParam=", exOprationParam);
        console.log("exOprationParam.length=", exOprationParam.length);
        console.log("this.getMdDataDraw=", this.getMdDataDraw);
        console.log("this.getDrawOp.length=", this.getDrawOp.length);
        for (let key in exOprationParam) {
          if (exOprationParam.hasOwnProperty(key)) {
            // 确保key是对象自身的属性
            let value = exOprationParam[key];
            console.log(value.type + "*******: *****" + value.type);
            if (value.type == "Hole") {
              if (value.shape == "SingleHole") {
                /**
                 * 单孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 5) {
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 单孔
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleTwo") {
                console.log("吊轮孔2");
                /**
                 * 吊轮孔2
                 *
                 */
                if (value.area * 1 == 4) {
                  console.log("吊轮孔22222");
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  console.log("吊轮孔22222");
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 吊轮孔2
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleThree") {
                /**
                 * 吊轮孔3
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2).toFixed(1);
                  var Hy3 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy3 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 吊轮孔3
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleTwoCol") {
                /**
                 * 4、双吊轮孔列
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.H * 1 + value.X * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);

                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 4、双吊轮孔列
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleTwoRow") {
                /**
                 * 5、双吊轮孔排
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (+(value.W * 1) + value.Y * 1).toFixed(1);
                  var Hy3 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy4 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy3 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy4 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 5、双吊轮孔排
                 *
                 *
                 */
              } else if (value.shape == "HangHole") {
                /**
                 * 6、晾物孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(1);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    1
                  );
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(1);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(1);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    1
                  );
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(1);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 6、晾物孔
                 *
                 *
                 */
              } else if (value.shape == "HandleHoleTShaped") {
                /**
                 * 7、拉手孔T字
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(1);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    1
                  );
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(1);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H1 * 1).toFixed(1);
                  var Hx3 = (value.X * 1 + value.H1 * 1 + value.H2 * 1).toFixed(
                    1
                  );
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.H1 * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.H2 * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H1 * 1).toFixed(1);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H1 * 1 -
                    value.H2 * 1
                  ).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 7、拉手孔T字
                 *
                 *
                 */
              } else if (value.shape == "DoubleFixHoles") {
                /**
                 * 8、双固定孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 5) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 8、双固定孔
                 *
                 *
                 */
              } else if (value.shape == "DoubleFixHolesCol") {
                /**
                 * 8、双固定孔列
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx = ((rectW * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 8、双固定孔
                 *
                 *
                 */
              } else if (value.shape == "RelSuWheelHole") {
                /**
                 * 9、相对吊轮孔
                 *
                 */
                if (value.area * 1 == 4) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.W * 1).toFixed(1);
                  var Hy3 = (value.Y * 1 + value.W * 1 + value.W * 1).toFixed(
                    1
                  );
                  var Hy4 = (
                    rectH * 1 -
                    value.Y * 1 -
                    value.W * 1 -
                    value.W * 1
                  ).toFixed(1);
                  var Hy5 = (rectH * 1 - value.Y * 1 - value.W * 1).toFixed(1);
                  var Hy6 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy3 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy4 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy5 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy6 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 9、相对吊轮孔
                 *
                 *
                 */
              } else if (value.shape == "HandleHole") {
                /**
                 * 10、拉手孔
                 *
                 */
                if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy = ((rectH * 1)-(value.Y * 1)).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hx = (value.X * 1).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 6) {
                  var Hx = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 10、拉手孔
                 *
                 *
                 */
              } else if (value.shape == "RotatLockHole") {
                /**
                 * 11、旋转锁孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy1 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy2 +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 11、旋转锁孔
                 *
                 *
                 */
              } else if (value.shape == "HandleHole3") {
                /**
                 * 12、拉手孔3
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(1);
                  var Hx3 = (value.X * 1 + value.H * 1 + value.H * 1).toFixed(
                    1
                  );
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 2) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 3) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H * 1).toFixed(1);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H * 1 -
                    value.H * 1
                  ).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.H * 1 + value.H * 1).toFixed(
                    1
                  );
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(1);
                  var Hx3 = (value.X * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 8) {
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 9) {
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.H * 1).toFixed(1);
                  var Hx3 = (
                    rectW * 1 -
                    value.X * 1 -
                    value.H * 1 -
                    value.H * 1
                  ).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx3 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 12、拉手孔3
                 *
                 *
                 */
              } else if (value.shape == "HangWheelHoleCol") {
                /**
                 * 13、吊轮孔列
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 4) {
                  var Hy = ((rectH * 1) / 2).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                } else if (value.area * 1 == 7) {
                  var Hy = (value.Y * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.H * 1).toFixed(1);
                  var Hd = (value.D * 1).toFixed(1);
                  var holesDatas =
                    "X=" +
                    Hx1 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n" +
                    "X=" +
                    Hx2 +
                    " " +
                    "Y=" +
                    Hy +
                    " " +
                    "D=" +
                    Hd +
                    " " +
                    "P=0\r\n";
                }

                /**
                 * 13、吊轮孔列
                 *
                 *
                 */
              } else if (value.shape == "Shaped7HandleHole") {
                /**
                 * 14、7字拉手孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";

                /**
                 * 14、7字拉手孔
                 *
                 *
                 */
              } else if (value.shape == "KeyHole") {
                /**
                 * 15、锁孔
                 *
                 */
                if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.W * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - value.W * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2).toFixed(1);
                  var Hx3 = ((rectW * 1) / 2 + value.W * 1).toFixed(1);
                }

                var Hd1 = (value.D1 * 1).toFixed(1);
                var Hd2 = (value.D2 * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd1 +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd2 +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd1 +
                  " " +
                  "P=0\r\n";

                /**
                 * 15、锁孔
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles") {
                /**
                 * 16、三孔
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";

                /**
                 * 16、三孔
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles2") {
                /**
                 * 17、三孔2
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (value.X * 1).toFixed(1);
                  var Hx2 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }
                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";

                /**
                 * 17、三孔2
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles3") {
                /**
                 * 18、三孔3
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy1 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy2 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy2 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy1 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy1 = (value.Y * 1).toFixed(1);
                  var Hy2 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";

                /**
                 * 18、三孔3
                 *
                 *
                 */
              } else if (value.shape == "ThreeHoles4") {
                /**
                 * 19、三孔4
                 *
                 */
                if (value.area * 1 == 1) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 2) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 3) {
                  var Hy2 = (rectH * 1 - value.Y * 1).toFixed(1);
                  var Hy1 = (rectH * 1 - value.Y * 1 - value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 4) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 5) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 6) {
                  var Hy1 = ((rectH * 1) / 2 + (value.H * 1) / 2).toFixed(1);
                  var Hy2 = ((rectH * 1) / 2 - (value.H * 1) / 2).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                } else if (value.area * 1 == 7) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (value.X * 1).toFixed(1);
                  var Hx1 = (value.X * 1 + value.W * 1).toFixed(1);
                } else if (value.area * 1 == 8) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = ((rectW * 1) / 2 - (value.W * 1) / 2).toFixed(1);
                  var Hx1 = ((rectW * 1) / 2 + (value.W * 1) / 2).toFixed(1);
                } else if (value.area * 1 == 9) {
                  var Hy2 = (value.Y * 1).toFixed(1);
                  var Hy1 = (value.Y * 1 + value.H * 1).toFixed(1);
                  var Hx2 = (rectW * 1 - value.X * 1).toFixed(1);
                  var Hx1 = (rectW * 1 - value.X * 1 - value.W * 1).toFixed(1);
                }

                var Hd = (value.D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";

                /**
                 * 19、三孔4
                 *
                 *
                 */
              }
              //console.log("i=", i);
              arrH.push(holesDatas);
            }
          }
        }

        this.holeUserMdD = arrH.join("");
        console.log("arrH===", arrH);
        console.log("arrH.length", arrH.length);
        console.log("this.holeUserMdD.length", this.holeUserMdD.length);
        if (arrH.length == 0) {
          this.myOpenMsg("您画的图中无孔，导出无效，请确认！", "提示：");
        } else {
          this.thicknessUserMdSetVisible = true;
        }
      }
    },
    // 自用模板库使用函数生成.holes文件
    changSetUserMdThickness() {
      // var rectW=this.activeBigSize.X,rectH=this.activeBigSize.Y;
      console.log("this.inputLoadParam typeof=", typeof this.inputLoadParam);
      console.log(
        "this.inputLoadParam.objHasOwnProperty=",
        this.objHasOwnProperty(this.inputLoadParam)
      );
      var count = this.objHasOwnProperty(this.inputLoadParam);
      if (count == 1) {
        this.thicknessUserMdSetVisible = false;
      } else if (count > 1) {
        this.thicknessUserMdSetVisible = false;
        if (this.userMdHolesBrand == "boliang") {
          var headData = "[Glassspec]\r\n";
          var headID = "GlasslD=" + this.GlasslD + "\r\n";
          var headNThick =
            "GlassThickness=" +
            this.GlassThickness +
            "\r\n" +
            "Pieces=" +
            this.Pieces +
            "\r\n";
          //var rectL=`WID=${this.form.glassW}\nLEN=${this.form.glassH}\n[Holes]\n`;
          //var rectL="WID="+(this.form.glassW*1).toFixed(1)+"\nLEN="+(this.form.glassH*1).toFixed(1)+"\n[Holes]\n";
          var rectL =
            "WID=" +
            (this.activeBigSize.Y * 1).toFixed(1) +
            "\r\nLEN=" +
            (this.activeBigSize.X * 1).toFixed(1) +
            "\r\n[Holes]\r\n";
          //var holesData=`X=100.0 Y=200.0 D=10.0 P=0\n`; // 这里应该是你的.holes文件的内容
          var holesData = `${headData}${headID}${headNThick}${rectL}${this.holeUserMdD}`;
          console.log("holesData=", holesData);
          if(this.setOUtFileName=="B"){
            this.downloadHoles(
            this.GlasslD +
              "_" +
              this.GlassThickness.padStart(2, "0") +
              ".holes",
            holesData
          );
          }else if(this.setOUtFileName=="A"){
            this.downloadHoles(
            this.GlasslD +
              ".holes",
            holesData
          );
          }
      
        } else if (this.userMdHolesBrand == "jingrui") {
          var headData = "[PicName]\n";
          var headID = "Name=001\n\n";
          var rectL =
            "[GlassWide]\r\nValue=" +
            (this.activeBigSize.X * 1).toFixed(1) +
            "\r\n\r\n[GlassHeight]\nValue=" +
            (this.activeBigSize.Y * 1).toFixed(1) +
            "\r\n\r\n[Holes]\r\n";
          var Depth = "[Depth]\r\nValue=\r\n";
          //var holesData=`X=100.0 Y=200.0 D=10.0 P=0\n`; // 这里应该是你的.holes文件的内容
          var holesData = `${headData}${headID}${rectL}${this.holeUserMdD}${Depth}`;
          console.log("holesData=", holesData);
          if(this.setOUtFileName=="B"){
            this.downloadHoles(
            this.GlasslD +
              "_" +
              this.GlassThickness.padStart(2, "0") +
              ".ini",
            holesData
          );
          }else if(this.setOUtFileName=="A"){
            this.downloadHoles(
            this.GlasslD +
              ".ini",
            holesData
          );
          }
          
        }
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    handleHolesUserMdCommand(command) {
      //this.$message('click on item ' + command);
      this.userMdHolesBrand = command;
      if (command == "boliang") {
        this.saveHolesUserMdBoliang();
      } else if (command == "jingrui") {
        this.saveHolesUserMdJingrui();
      }
     },
    loadMdPng(base64srcFile) {
      if(this.setOUtFileName=="A"){
      var fileNames = this.GlasslD;  
      
        }else if(this.setOUtFileName=="B"){
      var fileNames =this.GlasslD + "_" + _this.GlassThickness.padStart(2, "0");
       }
        // var fileNames = this.creatDate();
       //     var svg = document.getElementById("myDrawing");
        //     console.log("svg=", svg.setAttribute.viewBox);
      const _this = this;
      // export2Base64ImgUserMd(path,rect,MIMEType, option)
      var img = _this.export2Base64ImgUserMd(
        base64srcFile,
        this.activeBigSize,
        null,
        {
          //watermark: 'copyright reserved 2020 版权所有',
          background: "#fff",
        }
      );
       img.then(function (base64src) {
        // console.log("路径:::", base64src);
        // console.log("this1=", _this);
        _this.downLoad(base64src, fileNames + ".png");
        // console.log("this2=", _this);
       });
    },
    creatUserMDImg(plate, w, h) {
      var x = document.getElementById("svgToImg");
      x.innerHTML = "";
      /*** 20250406*/
      console.log("this.markShiftThree==", this.markShiftThree);
      console.log("this.BorderScaleMd==//////////////=", this.BorderScaleMd);
      if (this.BorderScaleMd < 1) {
        var bordwd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var bordhd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var hd = h * 1 - this.myScaleMdHAll * 1;
        var wd = 0;
        console.log("h*this.BorderScaleMd*1===", h * this.BorderScaleMd * 1);
        console.log("bordhd*1===", bordhd * 1);
        console.log("markShiftThree===", this.markShiftThree);
        console.log("hd===", hd);
        console.log("wd===", wd);
        console.log("bordhd===", bordhd);
      } else if (this.BorderScaleMd > 1) {
        var bordwd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var bordhd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var hd = h * 1 - this.myScaleMdHAll * 1;
        var wd = 0;
        console.log("h*this.BorderScaleMd*1===", h * this.BorderScaleMd * 1);
        console.log("bordhd*1===", bordhd * 1);
        console.log("markShiftThree===", this.markShiftThree);
        console.log("hd===", hd);
        console.log("wd===", wd);
        console.log("bordhd===", bordhd);
      } else if (this.BorderScaleMd == 1) {
        if (this.myScaleMdHAll < h) {
          var hd = h * 1 - this.myScaleMdHAll * 1,
            wd = 0;
          var bordwd = -((this.markShiftThree * 5) / 2),
            bordhd = -((this.markShiftThree * 5) / 2);
        } else if (this.myScaleMdHAll > h) {
          var hd = h * 1 - this.myScaleMdHAll * 1,
            wd = 0;
          var bordwd = -((this.markShiftThree * 5) / 2),
            bordhd = -((this.markShiftThree * 5) / 2);
        } else {
          console.log("this.markShiftThree=", this.markShiftThree);
          console.log(
            "this.markShiftThree*1/2=",
            (this.markShiftThree * 1) / 2
          );
          var hd = 0,
            wd = 0;
          var bordwd = -((this.markShiftThree * 5) / 2),
            bordhd = -((this.markShiftThree * 5) / 2);
        }
      }
      makerjs.model.move(plate, [-wd, -hd]);

      /**20250406 */
      var svg = makerjs.exporter.toSVG(plate, this.renderOptionsImg);
      document.getElementById("svgToImg").innerHTML = svg;
      //重写SVG
      var myImgs = document.getElementById("myImgs").innerHTML;
      // console.log("myImgs===", myImgs);
      // var w=this.form.glassW,h=this.form.glassH
      var html =
        '<svg width="' +
        (w * 1 + this.markShiftThree * 5) +
        '" height="' +
        (h * 1 + this.markShiftThree * 5) +
        '" viewBox="' +
        bordwd +
        " " +
        bordhd +
        " " +
        (w * 1 + this.markShiftThree * 5) +
        " " +
        (h * 1 + this.markShiftThree * 5) +
        '" xmlns="http://www.w3.org/2000/svg" id="myImgs">';
      var mySVGHtml = html + myImgs + "</svg>";
      // console.log("html==",html);
      // console.log("svg==",svg);
      // console.log("mySVGHtml==",mySVGHtml);
      document.getElementById("svgToImg").innerHTML = "";
      document.getElementById("svgToImg").innerHTML = mySVGHtml;
      var svgs = document.getElementById("myImgs");
      // var svgs = document.getElementById("myDrawing");
      var data = new XMLSerializer().serializeToString(svgs);
      // "data:image/svg+xml;base64," + window.btoa(this.reEncode(source));
      // console.log("data",data);
      var showBigImgURL =
        "data:image/svg+xml;base64," + window.btoa(this.reEncode(data));
      // console.log("upLoadImgURL",this.upLoadImgURL);
      return showBigImgURL;
    },
    creatMdDraw(frame, shape, operation) {
      console.log("creatMdDraw==shape", shape);
      console.log("operation==shape", operation);
      console.log("frame==shape", frame);
      console.log("frame.shapeName==shape", frame.shapeName);
      this.userMdPlate = {};
      this.userMdHolesNum = 0;
      if (frame.shapeName == "Rectangle") {
        var form = { glassW: "", glassH: "" };
        form.glassW = frame.X;
        form.glassH = frame.Y;
      } else {
        var form = _.cloneDeep(frame);
      }
      console.log("form", form);
      var model = {
        plate: this.userMdPlate,
        markers: this.userMdmarkers,
        cutPlate: this.userMdcutPlate,
      };
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };

      var myobj = this.$myutils[shape](
        operation,
        model,
        this.userMdHolesNum,
        form,
        fixedParam,
        this.zoomM,
        this.θCut,
        this.rCut,
        this.cutLine,
        this.cutFilletRadius
      );

      console.log("shape=111111=", shape);

      return myobj;
    },
    //点击图片切换图
    mdImgClick(data) {
      var x = document.getElementById("svgToImg");
      x.innerHTML = "";
      //this.visitMdNum=0;
      console.log("****123123", data);
      this.activeParam = [];
      this.inputLoadParam = {};
      this.activeImg = data;
      console.log("this.getDrawOp点击==", this.getDrawOp);
      console.log("this.getMdDataDraw==", this.getMdDataDraw);
      this.activeBigImgUrl = this.getMdDataDraw[data].userMdUrl;
      this.activeBigSize.Y = this.getMdDataDraw[data].userHeight;
      this.activeBigSize.X = this.getMdDataDraw[data].userWide;
      // this.activeParam=this.getMdDataDraw[data].operation;
      this.activeParam = _.cloneDeep(this.getDrawOp[data]);
      // console.log("this.getMdDataDraw[data].operation**==length==",this.getMdDataDraw[data].operation);
      console.log("tthis.activeParam**==length==", this.activeParam);
      for (let key in this.activeParam) {
        if (this.activeParam.hasOwnProperty(key)) {
          // 确保key是对象自身的属性
          let value = this.activeParam[key];
          // var propName=this.activeParam[key].shape+"-"+key;
          this.inputLoadParam[key] = value;
        }
        delete this.activeParam[key].type;
        delete this.activeParam[key].area;
        delete this.activeParam[key].shape;
      }
      this.inputLoadParam["Rectangle"] = this.activeBigSize;
      console.log("this.inputLoadParam**==length==", this.inputLoadParam);
    },
    changeMdUpdataMsg() {
      this.$forceUpdate();
      setTimeout(() => {
        this.submitUserMdForm(this.inputLoadParam);
      }, 500);
    },
    //修改参数
    submitUserMdForm(fromData) {
      console.log(
        "submitUserMdForm===this.visitMdNum访问次****=",
        this.visitMdNum
      );
      if (this.visitMdNum == 0) {
        this.myScaleMdWAll = this.getMdDataDraw[this.activeImg].userWide;
        this.myScaleMdHAll = this.getMdDataDraw[this.activeImg].userHeight;
      }

      console.log("submitUserMdForm===this.myScaleMdWAll=", this.myScaleMdWAll);
      console.log("submitUserMdForm==this.myScaleMdHAll=", this.myScaleMdHAll);
      var fromDatas = _.cloneDeep(fromData);
      console.log("fromDatas", fromDatas);

      this.userMdPlate = {};
      var model = {
        plate: this.userMdPlate,
        markers: this.userMdmarkers,
        cutPlate: this.userMdcutPlate,
      };
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };

      //var inputParam = { X: this.activeBigSize.X, Y: this.activeBigSize.Y };20241220
      console.log("this.glassMDFrameParam=", this.glassMDFrameParam);
      console.log(
        "this.getDrawOp.frame.shapeName=",
        this.glassMDFrameParam.shapeName
      );
      console.log("typeof(fromDatas)=", typeof(fromDatas));
      // console.log("this.fromDatas[this.getDrawOp.frame.shapeName]=",fromDatas[this.glassMDFrameParam.shapeName]);
      var inputParam = fromDatas[this.glassMDFrameParam.shapeName];
      console.log("inputParam=", inputParam);
      var frame = _.cloneDeep(this.glassMDFrameParam);
      frame = { ...frame, ...inputParam };
      console.log("+++++++++++++frame", frame);
      //console.log("this.glassMDFrameParam.shapeName=",this.glassMDFrameParam.shapeName);
      var myRectObj = this.$myutils[this.glassMDFrameParam.shapeName](
        inputParam,
        model,
        fixedParam,
        this.zoomM
      );
      var arr = [];
      var data = this.activeImg;
      var arr = _.cloneDeep(this.getDrawOp[data]);
      console.log("///////////submitUserMdForm修改参数///////////=", arr);
      console.log(
        "///////////submitUserMdForm修改参数this.getDrawOp///////////=",
        this.getDrawOp
      );
      console.log(
        "///////////submitUserMdForm修改参数this.getDrawOp.frame///////////=",
        this.getDrawOp.frame
      );
      console.log(
        "fromDatas******************、、、、、、、///////",
        fromDatas
      );
      for (let key in arr) {
        console.log("key===", key);
        if (arr.hasOwnProperty(key)) {
          // 确保key是对象自身的属性
          let value = arr[key];
          fromDatas[key]["type"] = value.type;
          fromDatas[key]["area"] = value.area;
          fromDatas[key]["shape"] = value.shape;
        }
      }
      console.log("fromDatas===+++", fromDatas);
      // var creatlengths=this.objHasOwnProperty(fromDatas);
      var arrB = { models: {} };
      // console.log("creatlengths===",creatlengths);
      for (let key in fromDatas) {
        if (fromDatas.hasOwnProperty(key)) {
          console.log("测试fromDatas=", fromDatas);
          console.log("测试key=", key);
          console.log("测试fromDatas[key].ttpe=", fromDatas[key].type);
          console.log("测试fromDatas[key].shape=", fromDatas[key].shape);
          console.log("测试fromDatas[key]=", fromDatas[key]);
          /**20250406 */
          this.activeBigSize.X = fromDatas[key].X;
          this.activeBigSize.Y = fromDatas[key].Y;
          console.log("$$$$$$$$$$$$$fromDatas[key].X=", fromDatas[key].X);
          console.log("$$$$$$$$$$$$$fromDatas[key].Y=", fromDatas[key].Y);
          /**20250406 */
          //if (fromDatas[key].shape == undefined)
          //if (key !== "Rectangle")
          if (fromDatas[key].shape !== undefined) {
            if (fromDatas[key].type == "Corner") {
              var obj = this.creatMdDraw(
                frame,
                fromDatas[key].shape,
                fromDatas
              );
              console.log("返回角画图数据*****objobjobj=", obj);
              arrB.models = obj.plate.models;
            } else {
              console.log("测试key else  ***********///////=", key);
              console.log("测试key else  frame  ***********///////=", frame);
              console.log(
                "测试key elsethis.getDrawOp.frame  ***********///////=",
                this.getDrawOp.frame
              );
              var obj = this.creatMdDraw(
                frame,
                fromDatas[key].shape,
                fromDatas[key]
              );
              for (let key in obj.plate.models) {
                if (obj.plate.models.hasOwnProperty(key)) {
                  // 确保key是对象自身的属性
                  let value = obj.plate.models[key];
                  arrB.models[key] = value;
                }
              }
            }
            console.log("测试修改角角角角测试*****objobjobj=", obj);
          }
          console.log("测试修改角画出图20241130*****obj=", obj);
        }
      }
      console.log("fromDatas角角*******", fromDatas);
      console.log(
        "getMdDataDraw角角角角角角角角角角*******",
        this.getMdDataDraw
      );
      console.log("arrB=角角角角=", arrB);
      console.log(
        "this.mdParma.mdTpye==3*********+&&&&&&&",
        this.mdParma.mdTpye
      );
      console.log("myRectObj*********%%%%%%%%%%%%%%%%%+&&&&&&&", myRectObj);

      if (this.mdParma.mdTpye == 3) {
      } else {
        arrB.models["Rectangle"] = myRectObj.plate.models.Rectangle;
      }

      console.log("arrB==", arrB);
      this.setMdCanvas();
      this.activeBigImgUrl = this.creatUserMDImg(
        arrB,
        this.activeBigSize.X,
        this.activeBigSize.Y
      );
      console.log("this.activeBigImgUrl==", this.activeBigImgUrl);
      console.log("this.activeBigSize.X==", this.activeBigSize.X);
      console.log("this.activeBigSize.Y==", this.activeBigSize.Y);
      //this.mdImgClick(this.activeImg);
      this.visitMdNum++;
    },
    //重置
    resetUserMdForm(fromData) {
      this.activeParam = [];
      this.inputLoadParam = {};
      var data = this.activeImg;
      console.log("this.getMdDataDraw重置==", this.getMdDataDraw);
      console.log("this.getDrawOp重置==", this.getDrawOp);
      this.activeBigImgUrl = this.getMdDataDraw[data].userMdUrl;
      this.activeBigSize.Y = this.getMdDataDraw[data].userHeight;
      this.activeBigSize.X = this.getMdDataDraw[data].userWide;
      this.activeParam = _.cloneDeep(this.getDrawOp[data]);
      console.log("tthis.activeParam*重置*==length==", this.activeParam);
      for (let key in this.activeParam) {
        if (this.activeParam.hasOwnProperty(key)) {
          // 确保key是对象自身的属性
          let value = this.activeParam[key];
          this.inputLoadParam[key] = value;
        }
        delete this.activeParam[key].type;
        delete this.activeParam[key].area;
        delete this.activeParam[key].shape;
      }
      this.inputLoadParam["Rectangle"] = this.activeBigSize;
      console.log("this.inputLoadParam**=重置=length==", this.inputLoadParam);
      this.$forceUpdate();
      this.submitUserMdForm(this.inputLoadParam);
      // console.log("resetUserMdForm---fromData***==",fromData);
    },
    ////20250406自用模板库根据矩形的大小设置画面的大小及缩放比例
    setMdCanvas() {
      console.log("setMdCanvas===this.visitMdNum访问次****=", this.visitMdNum);
      var w = this.activeBigSize.X * 1, //1200  51vw
        h = this.activeBigSize.Y * 1; //600   75vh
      var myScaleW = (1200 / w).toFixed(1);
      var myScaleH = (600 / h).toFixed(1);
      //this.myScaleH=myScaleH;
      //this.BorderScaleMd=myScaleW*1;
      console.log("wwwwwww=", w, "HHHH====", h);
      console.log("myScaleW=", myScaleW, "myScaleH====", myScaleH);
      var drawCanvas = document.getElementById("svgToImg");
      drawCanvas.style.display = "flex";
      drawCanvas.style.justifyContent = "center";
      drawCanvas.style.alignItems = "center";
      drawCanvas.style.height = 75 + "vh";
      drawCanvas.style.width = 51 + "vw";

      this.renderOptionsImg.fontSize = "16px";
      this.renderOptionsImg.strokeWidth = "0.3mm";

      this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）

      if (this.visitMdNum == 0) {
        this.myScaleMdWAll = w;
        this.myScaleMdHAll = h;
        ///////////////////////////////////////////
        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            // this.BorderScale=myScaleW*1;
            this.renderOptionsImg.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.renderOptionsImg.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          }
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例

          this.renderOptionsImg.fontSize = "16px";
          this.renderOptionsImg.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        }
        //////////////////////////////////////
        this.BorderScaleMd = 1;
      } else {
        //this.myScaleHAll=myScaleH
        console.log("this.myScaleHAll===", this.myScaleHAll);
        console.log("myScaleH===", myScaleH);

        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            this.BorderScaleMd = myScaleW * 1;
            this.renderOptionsImg.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.BorderScaleMd = myScaleH * 1;
            this.renderOptionsImg.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          }
        } else if (myScaleH > 1 && myScaleW > 1) {
          console.log("myScaleW>1||myScaleH>1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScaleMd = myScaleH * 1;
          this.renderOptionsImg.fontSize = "16px";
          this.renderOptionsImg.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScaleMd = 1;
          this.renderOptionsImg.fontSize = "16px";
          this.renderOptionsImg.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        }
      }
    },
    //打开模板窗口，初始化下载数据
    downMdData(type) {
      //this.activeUserMD="1";
      this.inputLoadParam = {};
      this.getDrawOp = [];
      this.activeParam = [];
      this.getMdDataDraw = [];
      this.mdName = [];
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      var myURLToJson = base + "/getData/getMdData.php";
      var token = Cookies.get("token");
      var dataName = JSON.parse(token);
      console.log("token.username==", dataName.username);
      this.mdParma.userName = dataName.username;
      this.mdParma.mdTpye = type;
      /**POST */
      console.log("this.mdParma==", this.mdParma);
      this.axios
        .post(myURLToJson, this.mdParma, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("res==", res);
          if (res.data.flag == "1") {
            var getData = _.cloneDeep(res.data.datas);
            var getDatalength = getData.length;
            console.log("getDatalength==", getDatalength);
            if (getDatalength == 0) {
              if (this.activeUserMD == "1") {
                this.holesMdShow = false;
              } else if (this.activeUserMD == "2") {
                this.gapsMdShow = false;
              } else if (this.activeUserMD == "3") {
                this.cornersMdShow = false;
              }
            } else {
              if (this.activeUserMD == "1") {
                this.holesMdShow = true;
              } else if (this.activeUserMD == "2") {
                this.gapsMdShow = true;
              } else if (this.activeUserMD == "3") {
                this.cornersMdShow = true;
              }
              for (var i = 0; i < getData.length; i++) {
                var obj = {
                  plate: "",
                  cutPlate: "",
                  userMdID: "",
                  userMdName: "",
                  userMdType: "",
                  userMdUrl: "",
                  userHeight: "",
                  userWide: "",
                  operation: "",
                  frame: "",
                };
                this.mdName.push(_.cloneDeep(getData[i].MdObjName));
                console.log("测试返回数据10.21***=", JSON.parse(getData[i].MdObjJsons));
                obj.plate = JSON.parse(getData[i].MdObjJsons).plate;
                obj.cutPlate = JSON.parse(getData[i].MdObjJsons).cutPlate;
                obj.operation = JSON.parse(
                  getData[i].MdObjJsons
                ).operationHistory;
                obj.userMdID = getData[i].MdUserID;
                obj.userMdName = getData[i].MdObjName;
                obj.userMdType = getData[i].MdObjType;
                obj.userMdUrl = getData[i].MdObjUrl;
                obj.userHeight = JSON.parse(getData[i].MdObjJsons).Rect.glassH;
                obj.userWide = JSON.parse(getData[i].MdObjJsons).Rect.glassW;
                obj.frame = JSON.parse(getData[i].MdObjJsons).frame;
                console.log("getData[i].MdObjUrl==", getData[i].MdObjUrl);
                //operationHistory
                //  this.activeParam.push(JSON.parse(getData[i].MdObjJsons).operationHistory);
                this.getMdDataDraw.push(_.cloneDeep(obj));
                this.getDrawOp.push(
                  JSON.parse(getData[i].MdObjJsons).operationHistory
                );
              }
              this.activeBigImgUrl = this.getMdDataDraw[0].userMdUrl;
              this.activeImg = 0;
              console.log("this.activeImg==", this.activeImg);
              this.activeBigSize.Y = JSON.parse(
                getData[0].MdObjJsons
              ).Rect.glassH;
              this.activeBigSize.X = JSON.parse(
                getData[0].MdObjJsons
              ).Rect.glassW;
              this.activeParam = JSON.parse(
                getData[0].MdObjJsons
              ).operationHistory;
              console.log(
                "this.activeParam****///////|||||||",
                JSON.parse(getData[0].MdObjJsons).operationHistory
              );
              console.log(
                "this.activeParam****///////|||||||",
                this.activeParam
              );
              for (let key in this.activeParam) {
                if (this.activeParam.hasOwnProperty(key)) {
                  // 确保key是对象自身的属性
                  let value = this.activeParam[key];
                  console.log(key + "*******: *****" + value);
                  //var propName = this.activeParam[key].shape + "-" +key;
                  var propName =
                    this.activeParam[key].shape +
                    "-" +
                    this.changeArea(this.activeParam[key].area);
                  //var propName = this.activeParam[key].shape + this.changeArea(this.activeParam[key].area);
                  console.log("propName*******=", propName);
                  this.inputLoadParam[propName] = value;
                }
                delete this.activeParam[key].type;
                delete this.activeParam[key].area;
                delete this.activeParam[key].shape;
              }
              this.inputLoadParam[
                JSON.parse(getData[0].MdObjJsons).frame.shapeName
              ] = JSON.parse(getData[0].MdObjJsons).frame;
              delete this.inputLoadParam[
                JSON.parse(getData[0].MdObjJsons).frame.shapeName
              ].shapeName;
              console.log("this.inputLoadParam20241114==", this.inputLoadParam);
              console.log(
                "this.getMdDataDrawinputLoadParam20241114==",
                this.getMdDataDraw
              );
              console.log(
                "this.getDrawOp20241114==000000000000000000",
                this.getDrawOp
              );
              for (var i = 0; i < this.getDrawOp.length; i++) {
                // 修改属性名称
                for (let key in this.getDrawOp[i]) {
                  if (this.getDrawOp[i].hasOwnProperty(key)) {
                    // 确保key是对象自身的属性
                    let value = this.getDrawOp[i][key];
                    console.log(key + "*******: *****" + value);
                    console.log(key + "*******: **下***" + value.shape);
                    //var propName = value.shape + "-" + key;
                    var propName =
                      value.shape + "-" + this.changeArea(value.area);
                    // var propName = value.shape + this.changeArea(value.area);
                    console.log("propName******下*=", propName);
                    this.getDrawOp[i][propName] = this.getDrawOp[i][key];
                    delete this.getDrawOp[i][key];
                  }
                }
              }
              this.glassMDFrameParam = JSON.parse(getData[0].MdObjJsons).frame;
              console.log(
                "this.getDrawOp20241114==11111111111111111",
                this.getDrawOp
              );
            }
          } else if (res.data.flag == "2") {
            this.$message.error(res.data.info);
          } else if (res.data.flag == "3") {
            this.$message.error(res.data.info);
          }
          // console.log("res.data22==",JSON.parse(datas));
        })
        .catch((error) => {
          // 处理错误
          console.error("error=", error);
        });
      /**POST */
    },
    openMdWin(type) {
      this.downMdData(type);
      this.MdWin = true;
    },
    holesLoad() {
      this.loading = true;
      setTimeout(() => {
        this.count += 2;
        this.loading = false;
      }, 2000);
    },
    /**模板窗口 */
    handleClick(command) {
      if (command === "logOut") {
        console.log("logout");

        //清除token
        Cookies.remove("token");
        // Cookies.remove("menu");
        this.$router.push({ path: "login" }).catch((e) => {});
      } else if (command === "sysSet") {
        this.systemSetVisible = true;
      }
    },
    fetchData() {
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      this.axios({
        method: "get",
        url: base + "/test.php",
        headers: {
          "Content-type": "application/json;charset=UTF-8",
        },
        credentials: "include",
        headers: {
          "Content-type": "application/json;charset=UTF-8",
        },
      })
        .then((res) => {
          this.success = true;
          console.log(res);

          console.log("test==", res.data);
        })
        .catch((error) => {
          this.error = true;
          console.log("error:" + error);
        });
    },
    sendData() {
      const base = process.env.NODE_ENV === "development" ? "/api" : "";
      console.log("base=", base);
      this.axios({
        method: "post",
        url: base + "/test.php",
        headers: {
          "Content-type": "application/x-www-form-urlencoded",
        },
        data: {
          autor: "autor",
          name: "name",
          data: "20241014",
        },
        //credentials:'include'
      })
        .then((res) => {
          this.success = true;
          console.log("post==", res.data);
        })
        .catch((error) => {
          this.error = true;
          console.log("error:" + error);
        });
    },
    /**上传模板Json信息 */

    sendDataToPHP() {
      if (this.jsonForm.MdObjName == "") {
        this.myOpenMsg("模板名称不能为空。", "贵友提示您：");
      } else {
        const base = process.env.NODE_ENV === "development" ? "/api" : "";
        var myURLToJson = base + "/getData/upJson.php";
        console.log(
          "this.operationHistory.length=",
          this.operationHistory.length
        );
        console.log(
          "this.this.glassFrameParam|||||||||||||||||||||||||+++++++++++++++++++++",
          this.glassFrameParam
        );
        this.MyJSON.MdObjJsons.plate = _.cloneDeep(this.plate);
        this.MyJSON.MdObjJsons.cutPlate = _.cloneDeep(this.cutPlate);
        this.MyJSON.MdObjJsons.markers = _.cloneDeep(this.markers);
        this.MyJSON.MdObjJsons.Rect = _.cloneDeep(this.form);
        this.MyJSON.MdObjJsons.frame = _.cloneDeep(this.glassFrameParam);
        this.MyJSON.MdObjJsons.operationHistory = _.cloneDeep(this.operationHistory);
        this.MyJSON.MdObjUrl = this.upLoadImgURL;

        //var datass= localStorage.getItem('token');
        //console.log("localStorage.length==",localStorage.length);
        //console.log("datass==",localStorage.getItem('token'));
        var token = Cookies.get("token");
        console.log("token==", typeof token);
        var dataName = JSON.parse(token);
        console.log("token.username==", dataName.username);
        this.MyJSON.MdUserName = dataName.username;
        this.MyJSON.MdObjName = this.jsonForm.MdObjName;
        this.MyJSON.MdObjType = this.jsonForm.MdObjType;
        console.log("this.plate==", _.cloneDeep(this.plate));
        console.log("this.MyJSON.MdObjJsons==", _.cloneDeep(this.MyJSON.MdObjJsons));
        console.log("this.MyJSON.MdObjUrl==", this.MyJSON.MdObjUrl);
        console.log("this.MyJSON==", this.MyJSON);
        var upJsonStr=JSON.parse(JSON.stringify(this.MyJSON));
        
        console.log("upJsonStr==", upJsonStr);
        /**POST */
        this.axios
          .post(myURLToJson, upJsonStr, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            console.log("res==", res);
            console.log("res.data.info==", res.data.info);
            console.log("res.flag==", res.data.flag);
            console.log("res.data.mdobj==", _.cloneDeep(res.data.mdobj));
            if (res.data.flag == "1") {
              console.log(res.data.info);
              this.$message({
                message: res.data.info,
                type: "success",
              });
              this.saveJsonDataVisible = false;
            } else if (res.data.flag == "2") {
              this.$message.error(res.data.info);
            } else if (res.data.flag == "3") {
              this.$message.error(res.data.info);
            }
            // console.log("res.data22==",JSON.parse(datas));
          })
          .catch((error) => {
            // 处理错误
            console.error("error=", error);
          });
        /**POST */
      }
    },
    /**svg 生成 图片文件 并显示在界面当 */
    creatbase64Img(plate, w, h) {
      if (plate == "") {
        this.myOpenMsg("图形为空", "贵友提示您：");
      } else {
        var x = document.getElementById("svgToImg");
        x.innerHTML = "";
        var svg = makerjs.exporter.toSVG(plate, this.renderOptionsImg);
        // console.log("svg00==",svg);
        console.log("plate==", plate);
        document.getElementById("svgToImg").innerHTML = svg;
        //重写SVG
        var myImgs = document.getElementById("myImgs").innerHTML;
        // console.log("myImgs===", myImgs);
        // var w=this.form.glassW,h=this.form.glassH
        var html =
          '<svg width="' +
          (w * 1 + 100) +
          '" height="' +
          (h * 1 + 100) +
          '" viewBox="-50 -50 ' +
          (w * 1 + 100) +
          " " +
          (h * 1 + 100) +
          '" xmlns="http://www.w3.org/2000/svg" id="myImgs">';
        var mySVGHtml = html + myImgs + "</svg>";
        // console.log("html==",html);
        // console.log("svg==",svg);
        // console.log("mySVGHtml==",mySVGHtml);
        document.getElementById("svgToImg").innerHTML = "";
        document.getElementById("svgToImg").innerHTML = mySVGHtml;
        var svgs = document.getElementById("myImgs");
        // var svgs = document.getElementById("myDrawing");
        var data = new XMLSerializer().serializeToString(svgs);
        // "data:image/svg+xml;base64," + window.btoa(this.reEncode(source));
        // console.log("data",data);
        var base64ImgURL =
          "data:image/svg+xml;base64," + window.btoa(this.reEncode(data));
        // console.log("upLoadImgURL",this.upLoadImgURL);
        return base64ImgURL;
      }
    },
    creatImg() {
      if (this.plate == "") {
        this.myOpenMsg("图形为空，请先画图。", "贵友提示您：");
      } else {
        this.saveJsonDataVisible = true;
        // this.showImg=true;
        console.log("this==", this);
        console.log(
          "document.getElementById('svgToImg')==",
          document.getElementById("svgToImg")
        );
        var x = document.getElementById("svgToImg");
        x.innerHTML = "";
        var svg = makerjs.exporter.toSVG(this.plate, this.renderOptionsImg);
        // console.log("svg00==",svg);
        console.log("this.plate==", this.plate);
        document.getElementById("svgToImg").innerHTML = svg;
        //重写SVG
        var myImgs = document.getElementById("myImgs").innerHTML;
        // console.log("myImgs===", myImgs);
        var w = this.form.glassW,
          h = this.form.glassH;
        var html =
          '<svg width="' +
          (w * 1 + 100) +
          '" height="' +
          (h * 1 + 100) +
          '" viewBox="-50 -50 ' +
          (w * 1 + 100) +
          " " +
          (h * 1 + 100) +
          '" xmlns="http://www.w3.org/2000/svg" id="myImgs">';
        var mySVGHtml = html + myImgs + "</svg>";
        // console.log("html==",html);
        // console.log("svg==",svg);
        // console.log("mySVGHtml==",mySVGHtml);
        document.getElementById("svgToImg").innerHTML = "";
        document.getElementById("svgToImg").innerHTML = mySVGHtml;
        var svgs = document.getElementById("myImgs");
        // var svgs = document.getElementById("myDrawing");
        var data = new XMLSerializer().serializeToString(svgs);
        // "data:image/svg+xml;base64," + window.btoa(this.reEncode(source));
        // console.log("data",data);
        this.upLoadImgURL =
          "data:image/svg+xml;base64," + window.btoa(this.reEncode(data));
        // console.log("upLoadImgURL",this.upLoadImgURL);
      }
    },
    /** */
    /**上传模板Json信息 */
    //创建外框形状 Create border shape
    creatShapeBorder(type, frame) {
      console.log("创建外框形状=frame=type=", frame, type);
      /***异形外框尺寸放大变小20250328 */
      switch (frame) {
        case "IsoscelesTrapezoid":
          this.form.glassW = this.W;
          this.form.glassH = this.H;
          break;
        case "RightAngledTrapezoid":
          this.form.glassW = this.W;
          this.form.glassH = this.H;
          break;
        case "OtherTrapezoidsA":
          this.form.glassW = this.W;
          this.form.glassH = this.H1;
          break;
        case "OtherTrapezoidsB":
          this.form.glassW = this.W;
          this.form.glassH = this.H;
          break;
        case "ParallelogramA":
          this.form.glassW = this.W;
          this.form.glassH = this.H;
          break;
        case "ParallelogramB":
          this.form.glassW = this.W;
          this.form.glassH = this.H;
          break;
      }
      /***异形外框尺寸放大变小20250328 */
      this.myPost = true; //开启向父组件向子组件传数据。
      setTimeout(() => {
        /**延时操作 */
        this.creatBorder("special-shaped", frame);
        /**延时操作 */
      }, 500);
    },

    //外框形状
    creatBorder(type, frame) {
      this.dialogFormVisible = false;
      this.setCanvas();
      this.plate = { models: {} };
      this.cutPlate = { models: {} };
      this.markers = { models: {} };
      this.history = []; // 存储历史记录
      this.future = []; // 存储未来的操作记录
      this.currentState = {}; // 当前状态  Initial state 初始状态
      this.operationCurrent = {}; // 当前状态  Initial state 初始参数状态
      this.operationHistory = []; // 存储历史记录的参数记录
      this.operationFuture = []; // 存储未来的参数记录
      this.myHolesNum = 0;

      var model = {
        plate: { models: {} },
        markers: { models: {} },
      };
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };
      console.log("20240830shape=", frame);
      console.log("20240914shape=", this.myPost);
      console.log("20240830this.glassFrameParam=", this.glassFrameParam);
      var myobj = this.$myutils[frame](
        this.glassFrameParam,
        model,
        fixedParam,
        this.zoomM
      );

      console.log("myobj******=", _.cloneDeep(myobj));
      console.log("myobj.plate******=", _.cloneDeep(myobj.plate));
      this.plate = myobj.plate;
      this.markers = myobj.markers;
      var myMarkers = myobj.markers;
      var svg = makerjs.exporter.toSVG(myMarkers, this.renderOptions);
      document.getElementById("drawCanvas").innerHTML = svg;
      console.log("this.form.glassW=", this.form.glassW);
      console.log("this.form.glassH=", this.form.glassH);
      if (frame == "Rectangle") {
        var glassW = this.form.glassW;
        var glassH = this.form.glassH;
      } else {
        var glassW = myobj.glassW;
        var glassH = myobj.glassH;
        this.form.glassW = glassW;
        this.form.glassH = glassH;
      }
      this.creatSvg(glassW, glassH, myMarkers);
      this.frame = frame;
    },

    //接收子组件数据
    recieveMsg(rel) {
      console.log("rel=||||||******", rel);
      this.shapeName = rel.shapeName;
      if (rel.shapeName == "Rectangle") {
        //this.X=rel.X;
        //this.Y=rel.Y;
        this.form.glassW = rel.X;
        this.form.glassH = rel.Y;
        this.glassFrameOptions[0].inputParam.W = rel.X;
        this.glassFrameOptions[0].inputParam.H = rel.Y;
        console.log("this.form.glassW=", this.form.glassW);
        console.log("this.form.glassH=", this.form.glassH);
        this.glassFrameParam = rel;
      } else if (rel.shapeName == "IsoscelesTrapezoid") {
        this.H = rel.H;
        this.W = rel.W;
        this.W1 = rel.W1;
        this.glassFrameOptions[1].children[0].inputParam.H = rel.H;
        this.glassFrameOptions[1].children[0].inputParam.W = rel.W;
        this.glassFrameOptions[1].children[0].inputParam.W1 = rel.W1;
        this.glassFrameParam = rel;

        console.log(
          "IsoscelesTrapezoid====this.form.glassW=",
          this.form.glassW
        );
        console.log(
          "IsoscelesTrapezoid====this.form.glassH=",
          this.form.glassH
        );
      } else if (rel.shapeName == "RightAngledTrapezoid") {
        this.H = rel.H;
        this.H1 = rel.H1;
        this.W = rel.W;
        this.W1 = rel.W1;
        this.glassFrameOptions[1].children[1].inputParam.H = rel.H;
        this.glassFrameOptions[1].children[1].inputParam.H1 = rel.H1;
        this.glassFrameOptions[1].children[1].inputParam.W = rel.W;
        this.glassFrameOptions[1].children[1].inputParam.W1 = rel.W1;
        this.glassFrameParam = rel;
        console.log("rel|||||||||=", rel);
      } else if (rel.shapeName == "OtherTrapezoidsA") {
        this.H1 = rel.H1;
        this.H2 = rel.H2;
        this.W = rel.W;
        this.W1 = rel.W1;
        this.W2 = rel.W2;
        this.glassFrameOptions[1].children[2].inputParam.H1 = rel.H1;
        this.glassFrameOptions[1].children[2].inputParam.H2 = rel.H2;
        this.glassFrameOptions[1].children[2].inputParam.W = rel.W;
        this.glassFrameOptions[1].children[2].inputParam.W1 = rel.W1;
        this.glassFrameOptions[1].children[2].inputParam.W2 = rel.W2;
        this.glassFrameParam = rel;
      } else if (rel.shapeName == "OtherTrapezoidsB") {
        this.H = rel.H;
        this.W = rel.W;
        this.W1 = rel.W1;
        this.W2 = rel.W2;
        this.glassFrameOptions[1].children[3].inputParam.H = rel.H;
        this.glassFrameOptions[1].children[3].inputParam.W = rel.W;
        this.glassFrameOptions[1].children[3].inputParam.W1 = rel.W1;
        this.glassFrameOptions[1].children[3].inputParam.W2 = rel.W2;
        this.glassFrameParam = rel;
      } else if (rel.shapeName == "ParallelogramA") {
        this.H = rel.H;
        this.W = rel.W;
        this.W1 = rel.W1;
        this.glassFrameOptions[2].children[0].inputParam.H = rel.H;
        this.glassFrameOptions[2].children[0].inputParam.W = rel.W;
        this.glassFrameOptions[2].children[0].inputParam.W1 = rel.W1;
        this.glassFrameParam = rel;
        console.log("ParallelogramA=", rel);
      } else if (rel.shapeName == "ParallelogramB") {
        this.H = rel.H;
        this.W = rel.W;
        this.W1 = rel.W1;
        this.W2 = rel.W2;
        this.glassFrameOptions[2].children[1].inputParam.H = rel.H;
        this.glassFrameOptions[2].children[1].inputParam.W = rel.W;
        this.glassFrameOptions[2].children[1].inputParam.W1 = rel.W1;
        this.glassFrameOptions[2].children[1].inputParam.W2 = rel.W2;
        this.glassFrameParam = rel;

        console.log(
          "this.glassFrameOptions|||||||||||=",
          this.glassFrameOptions
        );
        console.log("ParallelogramB=rel||||", rel);
      }
    },
    //切割机格式DXF文件
    glassCut() {
      
      console.log("this.plate==", this.plate);
      // console.log("this.plate.models==",this.plate.models);
      if(this.ComIsCutMS=="1"){

         var count = this.objHasOwnProperty(this.plate);
         console.log("count==", count);
        if (count == 0) {
           this.myOpenMsg("请先画图。", "提示：");
         } else {
           console.log("glassCut()||this.plate.models==", this.plate.models);
           var num = this.objHasOwnProperty(this.plate.models);
           console.log("num==", num);
           if (num <= 1) {
            this.myOpenMsg("请添加图形。", "提示：");
            } else {
             //     var objData = this.plate.models;
             // console.log("objData==",objData);
             // console.log("this.cutPlate.models==",this.plate);
             // var arrs = [];
             // for (let key in objData) {
             //   if (objData.hasOwnProperty(key)) {
             //     console.log(key); // 输出每个属性的名称
             //     var result = key.split("Area");
             //     console.log("result=", result);
             //     arrs.push(result[1]);
             //   }
             // }
             //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
           console.log("******************");
           var mirrorPlate=makerjs.model.mirror(this.plate, true, false);
           //德法水刀 坐标需要镜像处理  mirrorDxf
           this.mirrorDxf = makerjs.exporter.toDXF(mirrorPlate,this.dxfOption);
           this.dxf = makerjs.exporter.toDXF(this.plate,this.dxfOption);
           console.log("******************");
           console.log("**********this.dxf==********", this.dxf);

           //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
           var strings =
            "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
            this.form.glassW +
            "\n20\n" +
            this.form.glassH +
            "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
           var splitStr = "0\nSECTION\n2\nENTITIES\n";
          if (this.benchMark == "G") {
            var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
          } else if (this.benchMark == "I") {
            var splitStrP =
              "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
          }else{
             var splitStrP ="";
          }
          var arrs = this.dxf.split(splitStr);
          var arrStr = splitStr + splitStrP;
          console.log("arrStr=", arrStr);
          console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
          this.dxf = strings + arrStr + arrs[1];
          console.log("this.dxf******=", this.dxf);
          //this.saveMyDXF();
           if(this.setOUtFileName=="B"){
             this.downloadHoles(
             this.GlasslD +
              "_" +
              this.GlassThickness.padStart(2, "0") +
              ".dxf",
             this.dxf
            );
          }else if(this.setOUtFileName=="A"){
            this.downloadHoles(
            this.GlasslD +
              ".dxf",
            this.dxf
          );
          }        
       
         this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
         }
         }
        }
      }else if(this.ComIsCutMS=="0"){
        this.$message({
          message: '此功能试用到期，如需要继续使用，请联系贵友客服！',
          type: 'warning'
        });
      }
    },
    //切割机格式DXF文件
    glassAbCut() {
      //console.log("this.plate==",this.abPlate);
      var datas = _.cloneDeep(this.abPlate);
      // console.log("this.plate.models==",this.plate.models);
      var count = this.objHasOwnProperty(datas);
      console.log("count==", count);
      if (count == 0) {
        this.myOpenMsg("请先画图。", "提示：");
      } else {
        console.log("******************");
        
        this.abDxf = makerjs.exporter.toDXF(datas,this.dxfOption);
        console.log("******************");
        console.log("**********this.abDxf==********", this.abDxf);

        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          this.abForm.glassW +
          "\n20\n" +
          this.abForm.glassH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP =
            "0\nPOINT\n8\n0\n10\n" + this.abForm.glassW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = this.abDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.abDxf = strings + arrStr + arrs[1];
        console.log("this.abDxf******=", this.abDxf);
        //this.saveMyabDXF();
        if(this.setOUtFileName=="B"){
            this.downloadHoles(
            this.GlasslD +
              "_" +
              this.GlassThickness.padStart(2, "0") +
              ".dxf",
            this.abDxf
          );
          }else if(this.setOUtFileName=="A"){
            this.downloadHoles(
            this.GlasslD +
              ".dxf",
            this.abDxf
          );
          }        
       
        this.loadMdPng(this.activeBigImgUrl);
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },

    /**抽屉组件 用到的事件*/

    /**玻璃外框类型 */
    selGlassFrameChanged(value) {
      console.log("glassFrameChanged  value=", value);
      console.log("this.glassFrameOptionsValue=", this.glassFrameOptionsValue);
      //this.spacelTrapezoidOptionsValue
      if (value.length == 1) {
        console.log(
          "this.glassFrameOptions[value[0]]=",
          this.glassFrameOptions[value[0]].inputParam
        );
        this.glassFrameParamLeg =
          this.glassFrameOptions[value[0]].inputParam.length;
        this.selectObjectParam = this.glassFrameOptions[value[0]].inputParam; //参数对象

        let arr = Object.keys(this.selectObjectParam);

        console.log("arr==", arr);

        this.imgGlassFrameName = this.glassFrameOptions[value[0]].Name;
        this.currenGlassFrameComponent = this.glassFrameOptions[value[0]].Name;
        console.log(
          "this.currenGlassFrameComponent===",
          this.currenGlassFrameComponent
        );
      } else if (value.length == 2) {
        this.imgGlassFrameName =
          this.glassFrameOptions[value[0]].children[value[1]].Name;
        this.selectObjectParam =
          this.glassFrameOptions[value[0]].children[value[1]].inputParam; //参数对象
        this.currenGlassFrameComponent =
          this.glassFrameOptions[value[0]].children[value[1]].Name;

        console.log(
          "this.currenGlassFrameComponent===",
          this.currenGlassFrameComponent
        );
      }
    },
    /**梯形类型选择 */
    selTrapezoidChanged(value) {
      console.log("selTrapezoidChanged  value=", value);
      console.log(
        "this.spacelTrapezoidOptionsValue=",
        this.spacelTrapezoidOptionsValue
      );
      //this.spacelTrapezoidOptionsValue
      this.imgTrapezoidName = this.spacelTrapezoidOptions[value].Name;
      this.currenTrapezoidComponent = this.spacelTrapezoidOptions[value].Name;
    },
    /**梯形类型选择 */
    /**平形四边形类型选择 */
    selParallelogramChanged(value) {
      console.log("selParallelogramChanged  value=", value);
      console.log(
        "this.spacelParallelogramOptionsValue=",
        this.spacelParallelogramOptionsValue
      );
      //this.spacelParallelogramOptionsValue
      this.imgParallelogramName = this.spacelParallelogramOptions[value].Name;
      this.currenParallelogramComponent =
        this.spacelParallelogramOptions[value].Name;
    },

    /**平形四边形类型选择 */
    //不足两位用0补足两位
    //如果没有孔弹出消息提示框
    myOpenMsg(cont, title) {
      this.$alert(cont, title, {
        confirmButtonText: "确定",
        type: "warning",
      }).catch(() => {});
    },

    /**上传数据到ERP当中 */
    sendDataToERP() {
      var _this = this;
      //const data = this.gyErpParam;// 要传递给后端的数据
      //http://localhost:8082/?id=e0fcdd1afc0e4b5786140b2fa800d91f&gyLen=900&gyWid=800&gyThick=6&gyName=%E6%B5%8B%E8%AF%95&gySer=9_y
      _this.gyErpParam.OrderChildId = _this.GlasslD;
      _this.gyErpParam.Name = _this.gyName;
      _this.gyErpParam.Thick = _this.GlassThickness;
      //const strOk = _this.gyErpParam;// 要传递给后端的数据 ;// 要传递给后端的数据
      const mystrOk = JSON.stringify(_this.gyErpParam); // 要传递给后端的数据 ;// 要传递给后端的数据
      //console.log("strOk==", mystrOk);
      //console.log("upUrl==0621.000", _this.upUrl);

      _this
        .axios({
          url: _this.upUrl,
          method: "POST",
          data: { strOk: mystrOk },
          headers: {
            "content-type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          console.log(res);
          console.log(res.data);
          var mystringArr = res.data.split(">");
          console.log("test_mystringArr0" + mystringArr[0]);
          console.log("test_mystringArr1" + mystringArr[1]);
          var mystringArrs = mystringArr[2].split("<");
          var mydata = mystringArrs[0];
          console.log("mydata" + mydata);
        })
        .catch((err) => {
          console.log("*****0621.1345=", err);
        });
    },

     /*
    和打孔机对接
    */
    /**
     * 保存模板内容到数据库
     * 1、图片保存路径
     * 2、参数以json数据保存
     * 3、保存时间
     */
    downloadHoles(filename, text) {
      // 创建一个临时的<a>标签
      var element = document.createElement("a");
      element.setAttribute(
        "href",
        "data:text/plain;charset=utf-8," + encodeURIComponent(text)
      );
      element.setAttribute("download", filename);

      // 触发下载
      element.style.display = "none";
      document.body.appendChild(element);
      element.click();
      document.body.removeChild(element);
    },
    // 使用函数生成.holes文件
    changSetThickness() {
      //   isType(null);//'[object null]'
      // const isType =(value)=>0bject,prototype,toString.call(value).toLowerCase();
      // isType(undefined);//'[object null]'isType([]);//'[object array]'
      // isType({});//'[object object]
      // isType(1);//'[object number]'
      // isType("1");//'[object string]'isType(true);//[object boolean]'

      if (this.operationHistory.length == 1) {
        this.thicknessSetVisible = false;
      } else if (this.operationHistory.length > 1) {
        this.thicknessSetVisible = false;
        if (this.HolesBrand == "boliang") {
          var headData = "[Glassspec]\r\n";
          var headID = "GlasslD=" + this.GlasslD + "\r\n";
          var headNThick =
            "GlassThickness=" +
            this.GlassThickness +
            "\r\n" +
            "Pieces=" +
            this.Pieces +
            "\r\n";
          //var rectL=`WID=${this.form.glassW}\nLEN=${this.form.glassH}\n[Holes]\n`;
          //var rectL="WID="+(this.form.glassW*1).toFixed(1)+"\nLEN="+(this.form.glassH*1).toFixed(1)+"\n[Holes]\n";
          var rectL =
            "WID=" +
            (this.form.glassH * 1).toFixed(1) +
            "\r\nLEN=" +
            (this.form.glassW * 1).toFixed(1) +
            "\r\n[Holes]\r\n";
          //var holesData=`X=100.0 Y=200.0 D=10.0 P=0\n`; // 这里应该是你的.holes文件的内容
          var holesData = `${headData}${headID}${headNThick}${rectL}${this.holeD}`;
          console.log("holesData=", holesData);
          if(this.setOUtFileName=="A"){
            
          this.downloadHoles(
            this.GlasslD +
              ".holes",
            holesData
          ); 
          }else if(this.setOUtFileName=="B"){
           
          this.downloadHoles(
            this.GlasslD +
              "_" +
              this.GlassThickness.padStart(2, "0") +
              ".holes",
            holesData
          );
          }
        } else if (this.HolesBrand == "jingrui") {
          var headData = "[PicName]\r\n";
          var headID = "Name=001\r\n\r\n";
          var rectL =
            "[GlassWide]\r\nValue=" +
            (this.form.glassW * 1).toFixed(1) +
            "\r\n\r\n[GlassHeight]\nValue=" +
            (this.form.glassH * 1).toFixed(1) +
            "\r\n\r\n[Holes]\r\n";
          var Depth = "[Depth]\r\nValue=\r\n";
          //var holesData=`X=100.0 Y=200.0 D=10.0 P=0\n`; // 这里应该是你的.holes文件的内容
          var holesData = `${headData}${headID}${rectL}${this.holeD}${Depth}`;
          console.log("holesData=", holesData);
          if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".ini",
            holesData
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".ini",
            holesData
          );
          }
        }

        this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    //系统设置
    saveSystemSet() {
      // renderOptions.fontSize
      // renderOptions.strokeWidth
      // zoomM
      /*
     setSysStorage:{
        fontSize:'16px',
        strokeWidth:'0.3mm',
        zoomM:1
      },//需要缓存数据
      */
      this.setSysStorage.fontSize = this.renderOptions.fontSize;
      this.setSysStorage.strokeWidth = this.renderOptions.strokeWidth;
      this.setSysStorage.zoomM = this.zoomM;//缩放外框
      this.setSysStorage.changeXYAxis = this.changeXYAxis;//是否转换坐标，主要是针对天津洪鸿伊达
      this.setSysStorage.waterCutSetPram = this.waterCutSetPram;//是否包含孔文件
      this.setSysStorage.waterCutSetPramMd = this.waterCutSetPramMd;//是否包含孔文件

      global.localStorage.setItem(
        "sysStorage",
        JSON.stringify(this.setSysStorage)
      );
      const syStorData = JSON.parse(global.localStorage.getItem("sysStorage"));
      console.log("storage=", global.localStorage.getItem("sysStorage"));
      this.renderOptions.fontSize = syStorData.fontSize;
      this.renderOptions.strokeWidth = syStorData.strokeWidth;
      this.zoomM = syStorData.zoomM;
      this.waterCutSetPram = syStorData.waterCutSetPram;
      this.changeXYAxis = syStorData.changeXYAxis;
      this.waterCutSetPramMD = syStorData.waterCutSetPramMD;
      this.systemSetVisible = false;
      console.log("this.zoomM=", this.zoomM);
    },
    handleHolesCommand(command) {
      //this.$message('click on item ' + command);
      // if(this.ComIsHoles=="1"){          
         this.HolesBrand = command;
        if (command == "boliang") {
          this.saveHolesBoliang();
        } else if (command == "jingrui") {
         this.saveHolesJingrui();
       }      
      // }else if(this.ComIsHoles=="0"){
      //   this.$message({
      //     message: '此功能试用到期，如需要继续使用，请联系贵友客服！',
      //     type: 'warning'
      //   });
      // }
    },
    //精锐打孔机
    saveHolesJingrui() {
      console.log(
        "this.operationHistory.length=",
        this.operationHistory.length
      );
      if (this.operationHistory.length <= 1) {
        this.myOpenMsg("没有图形，请先画图。", "提示：");
      } else {
        var arrH = [];
        console.log("this.operationHistory=", this.operationHistory);
        //console.log("typeOfthis.operationHistory=",typeof(this.operationHistory));
        console.log(
          "this.operationHistory.length=",
          this.operationHistory.length
        );
        for (let i = 1; i < this.operationHistory.length; i++) {
          if (this.operationHistory[i].type == "Hole") {
            /** 孔*/
            if (this.operationHistory[i].shape == "SingleHole") {
              /**
               * 单孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hx = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 单孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangWheelHoleTwo") {
              console.log("吊轮孔2");
              /**
               * 吊轮孔2
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                console.log("吊轮孔22222");
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                console.log("吊轮孔22222");
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 吊轮孔2
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangWheelHoleThree") {
              /**
               * 吊轮孔3
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hy3 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy3 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 吊轮孔3
               *
               *
               */
            } else if (
              this.operationHistory[i].shape == "HangWheelHoleTwoCol"
            ) {
              /**
               * 4、双吊轮孔列
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].H * 1 +
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);

                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);

                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 4、双吊轮孔列
               *
               *
               */
            } else if (
              this.operationHistory[i].shape == "HangWheelHoleTwoRow"
            ) {
              /**
               * 5、双吊轮孔排
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  +(this.operationHistory[i].W * 1) +
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy3 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy4 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy3 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy4 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 5、双吊轮孔排
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangHole") {
              /**
               * 6、晾物孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 6、晾物孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HandleHoleTShaped") {
              /**
               * 7、拉手孔T字
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(0);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 7、拉手孔T字
               *
               *
               */
            } else if (this.operationHistory[i].shape == "DoubleFixHoles") {
              /**
               * 8、双固定孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 8、双固定孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "DoubleFixHolesCol") {
              /**
               * 8、双固定孔列
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 8、双固定孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "RelSuWheelHole") {
              /**
               * 9、相对吊轮孔
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy3 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy4 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy5 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy6 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy3 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy4 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy5 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy6 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 9、相对吊轮孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HandleHole") {
              /**
               * 10、拉手孔
               *
               */
              if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(0);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 10、拉手孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "RotatLockHole") {
              /**
               * 11、旋转锁孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy1 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy2 +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 11、旋转锁孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HandleHole3") {
              /**
               * 12、拉手孔3
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx3 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx3 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 12、拉手孔3
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangWheelHoleCol") {
              /**
               * 13、吊轮孔列
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy = ((this.form.glassH * 1) / 2).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hd = (this.operationHistory[i].D * 1).toFixed(0);
                var holesDatas =
                  "HoleX=" +
                  Hx1 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n" +
                  "HoleX=" +
                  Hx2 +
                  "mm\r\n" +
                  "HoleY=" +
                  Hy +
                  "mm\r\n" +
                  "HoleD=" +
                  Hd +
                  "mm\r\n" +
                  "P=0\r\n";
              }

              /**
               * 13、吊轮孔列
               *
               *
               */
            } else if (this.operationHistory[i].shape == "Shaped7HandleHole") {
              /**
               * 14、7字拉手孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(0);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(0);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(0);
              var holesDatas =
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy2 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n";

              /**
               * 14、7字拉手孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "KeyHole") {
              /**
               * 15、锁孔
               *
               */
              if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(0);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(0);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(0);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].W * 1
                ).toFixed(0);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(0);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].W * 1
                ).toFixed(0);
              }

              var Hd1 = (this.operationHistory[i].D1 * 1).toFixed(0);
              var Hd2 = (this.operationHistory[i].D2 * 1).toFixed(0);
              var holesDatas =
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd1 +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy2 +
                "mm\r\n" +
                "HoleD=" +
                Hd2 +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx3 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd1 +
                "mm\r\n" +
                "P=0\r\n";

              /**
               * 15、锁孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles") {
              /**
               * 16、三孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy2 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n";

              /**
               * 16、三孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles2") {
              /**
               * 17、三孔2
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy2 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n";

              /**
               * 17、三孔2
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles3") {
              /**
               * 18、三孔3
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy2 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n";

              /**
               * 18、三孔3
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles4") {
              /**
               * 19、三孔4
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx1 +
                "mm\r\n" +
                "HoleY=" +
                Hy2 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n" +
                "HoleX=" +
                Hx2 +
                "mm\r\n" +
                "HoleY=" +
                Hy1 +
                "mm\r\n" +
                "HoleD=" +
                Hd +
                "mm\r\n" +
                "P=0\r\n";

              /**
               * 19、三孔4
               *
               *
               */
            }
            console.log("i=", i);
            arrH.push(holesDatas);
            /** */
          }
        }
        this.holeD = arrH.join("");
        console.log("arrH===", arrH);
        console.log("arrH.length", arrH.length);
        console.log("this.holeD.length", this.holeD.length);
        console.log("this.holeD===", this.holeD);
        var arr = this.holeD.split("P=0\r\n");
        arr = arr.slice(0, arr.length - 1);
        console.log("arr", arr);
        console.log("arr.length", arr.length);
        var arrHole = [];
        for (let i = 0; i < arr.length; i++) {
          var j = i * 1 + 1;
          const targetString = "Hole";
          const replacementString = "Hole" + j;
          const regex = new RegExp(targetString, "g");
          const arrs = arr[i];
          var str = arrs.replace(regex, replacementString);
          console.log("j=", j);
          arrHole.push(str);
        }
        //this.holeD=
        // console.log("arrDate", arr);
        console.log("arrHole=", arrHole);
        this.holeD = arrHole.join("");
        if (arrHole.length == 0) {
          this.myOpenMsg("您画的图中无孔，导出无效，请确认！", "提示：");
        } else {
          this.thicknessSetVisible = true;
        }
      }
    },
    //博亮打孔机
    saveHolesBoliang() {
      console.log(
        "this.operationHistory.length=",
        this.operationHistory.length
      );
      if (this.operationHistory.length <= 1) {
        this.myOpenMsg("没有图形，请先画图。", "提示：");
      } else {
        var arrH = [];
        console.log("this.operationHistory=", this.operationHistory);
        //console.log("typeOfthis.operationHistory=",typeof(this.operationHistory));
        console.log(
          "this.operationHistory.length=",
          this.operationHistory.length
        );
        for (let i = 1; i < this.operationHistory.length; i++) {
          if (this.operationHistory[i].type == "Hole") {
            /** 孔*/

            if (this.operationHistory[i].shape == "SingleHole") {
              /**
               * 单孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" + Hx + " " + "Y=" + Hy + " " + "D=" + Hd + " " + "P=0\r\n";
              }

              /**
               * 单孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangWheelHoleTwo") {
              console.log("吊轮孔2");
              /**
               * 吊轮孔2
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                console.log("吊轮孔22222");
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                console.log("吊轮孔22222");
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 吊轮孔2
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangWheelHoleThree") {
              /**
               * 吊轮孔3
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hy3 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy3 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 吊轮孔3
               *
               *
               */
            } else if (
              this.operationHistory[i].shape == "HangWheelHoleTwoCol"
            ) {
              /**
               * 4、双吊轮孔列
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].H * 1 +
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);

                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 4、双吊轮孔列
               *
               *
               */
            } else if (
              this.operationHistory[i].shape == "HangWheelHoleTwoRow"
            ) {
              /**
               * 5、双吊轮孔排
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  +(this.operationHistory[i].W * 1) +
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy3 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy4 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy3 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy4 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 5、双吊轮孔排
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangHole") {
              /**
               * 6、晾物孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 6、晾物孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HandleHoleTShaped") {
              /**
               * 7、拉手孔T字
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H1 * 1 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1
                ).toFixed(1);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H1 * 1 -
                  this.operationHistory[i].H2 * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 7、拉手孔T字
               *
               *
               */
            } else if (this.operationHistory[i].shape == "DoubleFixHoles") {
              /**
               * 8、双固定孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 8、双固定孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "DoubleFixHolesCol") {
              /**
               * 8、双固定孔列
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 8、双固定孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "RelSuWheelHole") {
              /**
               * 9、相对吊轮孔
               *
               */
              if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy3 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].W * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy4 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy5 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy6 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy3 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy4 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy5 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy6 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 9、相对吊轮孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HandleHole") {
              /**
               * 10、拉手孔
               *
               */
              if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hx = (this.operationHistory[i].X * 1).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hx = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 10、拉手孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "RotatLockHole") {
              /**
               * 11、旋转锁孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy1 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy2 +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 11、旋转锁孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HandleHole3") {
              /**
               * 12、拉手孔3
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx3 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx3 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx3 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].H * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx3 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 12、拉手孔3
               *
               *
               */
            } else if (this.operationHistory[i].shape == "HangWheelHoleCol") {
              /**
               * 13、吊轮孔列
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy = ((this.form.glassH * 1) / 2).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hd = (this.operationHistory[i].D * 1).toFixed(1);
                var holesDatas =
                  "X=" +
                  Hx1 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n" +
                  "X=" +
                  Hx2 +
                  " " +
                  "Y=" +
                  Hy +
                  " " +
                  "D=" +
                  Hd +
                  " " +
                  "P=0\r\n";
              }

              /**
               * 13、吊轮孔列
               *
               *
               */
            } else if (this.operationHistory[i].shape == "Shaped7HandleHole") {
              /**
               * 14、7字拉手孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy2 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n";

              /**
               * 14、7字拉手孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "KeyHole") {
              /**
               * 15、锁孔
               *
               */
              if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
                var Hx2 = ((this.form.glassW * 1) / 2).toFixed(1);
                var Hx3 = (
                  (this.form.glassW * 1) / 2 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd1 = (this.operationHistory[i].D1 * 1).toFixed(1);
              var Hd2 = (this.operationHistory[i].D2 * 1).toFixed(1);
              var holesDatas =
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd1 +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy2 +
                " " +
                "D=" +
                Hd2 +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx3 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd1 +
                " " +
                "P=0\r\n";

              /**
               * 15、锁孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles") {
              /**
               * 16、三孔
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy2 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n";

              /**
               * 16、三孔
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles2") {
              /**
               * 17、三孔2
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx2 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }
              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy2 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n";

              /**
               * 17、三孔2
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles3") {
              /**
               * 18、三孔3
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy2 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy1 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy1 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy2 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy2 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n";

              /**
               * 18、三孔3
               *
               *
               */
            } else if (this.operationHistory[i].shape == "ThreeHoles4") {
              /**
               * 19、三孔4
               *
               */
              if (this.operationHistory[i].area * 1 == 1) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 2) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 3) {
                var Hy2 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1
                ).toFixed(1);
                var Hy1 = (
                  this.form.glassH * 1 -
                  this.operationHistory[i].Y * 1 -
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 4) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 5) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 6) {
                var Hy1 = (
                  (this.form.glassH * 1) / 2 +
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hy2 = (
                  (this.form.glassH * 1) / 2 -
                  (this.operationHistory[i].H * 1) / 2
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 7) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (this.operationHistory[i].X * 1).toFixed(1);
                var Hx1 = (
                  this.operationHistory[i].X * 1 +
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 8) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  (this.form.glassW * 1) / 2 -
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
                var Hx1 = (
                  (this.form.glassW * 1) / 2 +
                  (this.operationHistory[i].W * 1) / 2
                ).toFixed(1);
              } else if (this.operationHistory[i].area * 1 == 9) {
                var Hy2 = (this.operationHistory[i].Y * 1).toFixed(1);
                var Hy1 = (
                  this.operationHistory[i].Y * 1 +
                  this.operationHistory[i].H * 1
                ).toFixed(1);
                var Hx2 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1
                ).toFixed(1);
                var Hx1 = (
                  this.form.glassW * 1 -
                  this.operationHistory[i].X * 1 -
                  this.operationHistory[i].W * 1
                ).toFixed(1);
              }

              var Hd = (this.operationHistory[i].D * 1).toFixed(1);
              var holesDatas =
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx1 +
                " " +
                "Y=" +
                Hy2 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n" +
                "X=" +
                Hx2 +
                " " +
                "Y=" +
                Hy1 +
                " " +
                "D=" +
                Hd +
                " " +
                "P=0\r\n";

              /**
               * 19、三孔4
               *
               *
               */
            }
            console.log("i=", i);
            arrH.push(holesDatas);
            /** */
          }
        }
        this.holeD = arrH.join("");
        console.log("arrH===", arrH);
        console.log("arrH.length", arrH.length);
        console.log("this.holeD.length", this.holeD.length);
        if (arrH.length == 0) {
          this.myOpenMsg("您画的图中无孔，导出无效，请确认！", "提示：");
        } else {
          this.thicknessSetVisible = true;
        }
      }
    },
    saveHolesPng() {
      var svg = document.getElementById("myDrawing");
      console.log("svg=", svg.setAttribute.viewBox);
      const _this = this;
      var img = _this.export2Base64Img(svg, null, {
        //watermark: 'copyright reserved 2020 版权所有',
        background: "#fff",
      });
      if(_this.setOUtFileName=="B"){

      img.then(function (base64src) {
        //console.log('路径:::', base64src)
        // console.log("this1=",_this)
        _this.downLoad(
          base64src,
          _this.GlasslD + "_" + _this.GlassThickness.padStart(2, "0") + ".png"
        );
        //console.log("this2=",_this)
      });
      }else if(_this.setOUtFileName=="A"){

      img.then(function (base64src) {
        //console.log('路径:::', base64src)
        // console.log("this1=",_this)
        _this.downLoad(
          base64src,
          _this.GlasslD+ ".png"
        );
        //console.log("this2=",_this)
      });
      }
    },
    /*和打孔机对接*/
    // maker/js.exporter.toDXF
    //根据矩形的大小设置画面的大小及缩放比例
    setCanvas() {
      /**记录新建外框的次数20250401 */
      console.log("this.visitNum访问次****=", this.visitNum);

      /**记录新建外框的次数20250401 */
      var w = this.form.glassW * 1, //1200  68vw
        h = this.form.glassH * 1; //600   75vh
      var myScaleW = (1200 / w).toFixed(1);
      var myScaleH = (600 / h).toFixed(1);
      //this.myScaleH=myScaleH;
      console.log("wwwwwww=", w, "HHHH====", h);
      console.log("myScaleW=", myScaleW, "myScaleH====", myScaleH);
      var drawCanvas = document.getElementById("drawCanvas");
      drawCanvas.style.display = "flex";
      drawCanvas.style.justifyContent = "center";
      drawCanvas.style.alignItems = "center";
      drawCanvas.style.height = 75 + "vh";
      drawCanvas.style.width = 68 + "vw";

      this.renderOptions.fontSize = "16px";
      this.renderOptions.strokeWidth = "0.3mm";
      this.markShift = 10; //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
      this.markShiftTwo = 15; //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
      this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
      this.markShiftFour = 25; //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
      this.markHolesOneD = 30; //圆形直径标注线加长设置 孔

      if (this.visitNum == 0) {
        this.myScaleWAll = w;
        this.myScaleHAll = h;
        ///////////////////////////////////////////
        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            // this.BorderScale=myScaleW*1;
            this.renderOptions.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptions.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShift = (((this.markShift * 1) / myScaleW) * 1).toFixed(1); //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
            this.markShiftTwo = (
              ((this.markShiftTwo * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
            this.markShiftFour = (
              ((this.markShiftFour * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
            this.markHolesOneD = (
              ((this.markHolesOneD * 1) / myScaleW) *
              1
            ).toFixed(1); //圆形直径标注线加长设置 孔
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            // this.BorderScale=myScaleH*1;
            this.renderOptions.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptions.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";

            this.markShift = (((this.markShift * 1) / myScaleH) * 1).toFixed(1); //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
            this.markShiftTwo = (
              ((this.markShiftTwo * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
            this.markShiftFour = (
              ((this.markShiftFour * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
            this.markHolesOneD = (
              ((this.markHolesOneD * 1) / myScaleH) *
              1
            ).toFixed(1); //圆形直径标注线加长设置 孔
          }
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例

          this.renderOptions.fontSize = "16px";
          this.renderOptions.strokeWidth = "0.3mm";
          this.markShift = 10; //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
          this.markShiftTwo = 15; //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          this.markShiftFour = 25; //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
          this.markHolesOneD = 30; //圆形直径标注线加长设置 孔
        }
        //////////////////////////////////////
        this.BorderScale = 1;
      } else {
        //this.myScaleHAll=myScaleH
        console.log("this.myScaleHAll===", this.myScaleHAll);
        console.log("myScaleH===", myScaleH);

        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            this.BorderScale = myScaleW * 1;
            this.renderOptions.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptions.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShift = (((this.markShift * 1) / myScaleW) * 1).toFixed(1); //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
            this.markShiftTwo = (
              ((this.markShiftTwo * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
            this.markShiftFour = (
              ((this.markShiftFour * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
            this.markHolesOneD = (
              ((this.markHolesOneD * 1) / myScaleW) *
              1
            ).toFixed(1); //圆形直径标注线加长设置 孔
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.BorderScale = myScaleH * 1;
            this.renderOptions.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptions.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";

            this.markShift = (((this.markShift * 1) / myScaleH) * 1).toFixed(1); //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
            this.markShiftTwo = (
              ((this.markShiftTwo * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
            this.markShiftFour = (
              ((this.markShiftFour * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
            this.markHolesOneD = (
              ((this.markHolesOneD * 1) / myScaleH) *
              1
            ).toFixed(1); //圆形直径标注线加长设置 孔
          }
        } else if (myScaleH > 1 && myScaleW > 1) {
          console.log("myScaleW>1||myScaleH>1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScale = myScaleH * 1;
          this.renderOptions.fontSize = "16px";
          this.renderOptions.strokeWidth = "0.3mm";
          this.markShift = 10; //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
          this.markShiftTwo = 15; //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          this.markShiftFour = 25; //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
          this.markHolesOneD = 30; //圆形直径标注线加长设置 孔
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScale = 1;
          this.renderOptions.fontSize = "16px";
          this.renderOptions.strokeWidth = "0.3mm";
          this.markShift = 10; //矩形偏移量 第一层偏移量（最靠近矩形框的里层）
          this.markShiftTwo = 15; //矩形偏移量 第二层偏移量（最靠近矩形框的里层）
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          this.markShiftFour = 25; //矩形偏移量 第四层偏移量（最靠近矩形框的里层）
          this.markHolesOneD = 30; //圆形直径标注线加长设置 孔
        }
      }
      console.log("w==h==", w, h);
      if (w == 0 || h == 0) {
        console.log("w==h=///////////////////////////=", w, h);
      } else {
        this.visitNum++;
      }
    },
    //画出入刀线 出三（3mm）进五(5mm)  角度θ计算  S  出入刀线弧长 r0(弧度代表的圆坐标)
    /**
     * 孔坐标:(x0,y0) 半径 r
     * 1、和孔的交点:交点坐标(x1,y1); x1:孔的圆心X坐标值x0-r;y1:孔的圆心X坐标值y0;
     * 2、进刀线:s=Math.sqrt(2*r*r)  起点X坐标(x0-r+r0)起点Y坐标(y0-r0); 终点坐标  X坐标(x0-r)Y坐标(y0)
     * 3、出刀线:s=Math.sqrt(2*r*r)  起点X坐标(x0-r)起点Y坐标(y0); 终点坐标  X坐标(x0-r+r0)Y坐标(y0+r0)
     * 4、new Arc(pointA: IPoint, pointB: IPoint, radius: number, largeArc: boolean, clockwise: boolean): Arc
     * 5、计算三个点的坐标
     */
    //判断对象属性是否存在
    objIsEmpty(obj) {
      return Object.keys(obj).length === 0;
    },
    //判断对象属性值是否为0
    objIsZero(obj) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          console.log("obj[key]=", obj[key]);
          if (obj[key] == 0) {
            return true;
          } else {
            return false;
          }
          // 对属性值进行操作
        }
      }
    },
    /**
     * 只修改玻璃外框
     */
    changeRect() {
      this.changeGlassVisible = true;
    },
    //只修改玻璃尺寸，重新画图
    changeSetRect() {
      this.changeGlassVisible = false;
      console.log("this.markers=", this.markers);
      console.log(
        "this.markers宽（Y）=",
        this.markers.models.myWidthMark.caption.text
      );
      console.log(
        "this.markers高（X）=",
        this.markers.models.myHeightMark.caption.text
      );
      this.markers.models.myWidthMark.caption.text = "长（X）=" + this.form.glassW;
      this.markers.models.myHeightMark.caption.text = "宽（Y）=" + this.form.glassH;
      //console.log("this.operationHistory=", this.operationHistory);
      // this.setCanvas();
      // this.CreatSvg(this.form.glassW, this.form.glassH, this.markers);
      this.changOuterCreatSvg(this.form.glassW, this.form.glassH);
    },
    //修改外框尺寸
    changOuterCreatSvg(w, h) {
      console.log("修改外框尺寸|this.operationHistory=", this.operationHistory);
      var fromDatas = _.cloneDeep(this.operationHistory);
      console.log("修改外框尺寸|fromDatas", fromDatas);

      this.userOuterPlate = {};
      var model = {
        plate: this.userOuterPlate,
        markers: this.userOutermarkers,
        cutPlate: this.userOutercutPlate,
      };
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };

      var inputParam = { X: this.form.glassW, Y: this.form.glassH };
      console.log("inputParam=", inputParam);
      var frame = { shapeName: this.shapeName };
      frame = { ...frame, ...inputParam };
      console.log("+++++++++++++frame", frame);
      console.log("|||||||this.shapeName========", this.shapeName);
      console.log("|||||||this.form========", this.form);
      //console.log("this.glassMDFrameParam.shapeName=",this.glassMDFrameParam.shapeName);
      var myRectObj = this.$myutils[this.shapeName](
        inputParam,
        model,
        fixedParam,
        this.zoomM
      );
      var arr = [];
      var fromDatas = _.cloneDeep(this.operationHistory);
      fromDatas.shift();
      console.log("fromDatas===", fromDatas);
      // console.log("修改外框尺寸|fromDatas",fromDatas)
      //var data = this.activeImg;
      // var arr = _.cloneDeep(this.getDrawOp[data]);
      console.log("///////////submitUserMdForm修改参数///////////arr===", arr);
      // for (let key in arr) {
      //   console.log("key===", key);
      //   if (arr.hasOwnProperty(key)) {
      //     // 确保key是对象自身的属性
      //     let value = arr[key];
      //     fromDatas[key]["type"] = value.type;
      //     fromDatas[key]["area"] = value.area;
      //     fromDatas[key]["shape"] = value.shape;
      //   }
      // }
      console.log("fromDatas===+++", fromDatas);
      // var creatlengths=this.objHasOwnProperty(fromDatas);
      var arrMarkers = { models: {} }; //  markers
      var arrPlate = { models: {} }; //  plate
      var arrCutPlate = { models: {} }; //  cutPlate

      // console.log("creatlengths===",creatlengths);
      for (let key in fromDatas) {
        if (fromDatas.hasOwnProperty(key)) {
          console.log("测试fromDatas=", fromDatas);

          //if (key !== "Rectangle")
          if (fromDatas[key].shape !== undefined) {
            if (fromDatas[key].type == "Corner") {
              var obj = this.creatMdDraw(
                frame,
                fromDatas[key].shape,
                fromDatas
              );
              console.log("返回角画图数据*****objobjobj=", obj);
              arrMarkers.models = obj.markers.models;
              arrPlate.models = obj.plate.models;
              arrCutPlate.models = obj.cutPlate.models;
            } else {
              console.log("测试key else  ***********///////=", key);
              console.log("测试key else  frame  ***********///////=", frame);
              console.log(
                "测试key elsethis.getDrawOp.frame  ***********///////=",
                this.getDrawOp.frame
              );
              var obj = this.creatMdDraw(
                frame,
                fromDatas[key].shape,
                fromDatas[key]
              );
              for (let key in obj.markers.models) {
                if (obj.markers.models.hasOwnProperty(key)) {
                  // 确保key是对象自身的属性
                  let value = obj.markers.models[key];
                  arrMarkers.models[key] = value;
                }
              }
              for (let key in obj.plate.models) {
                if (obj.plate.models.hasOwnProperty(key)) {
                  // 确保key是对象自身的属性
                  let value = obj.plate.models[key];
                  arrPlate.models[key] = value;
                }
              }
              for (let key in obj.cutPlate.models) {
                if (obj.cutPlate.models.hasOwnProperty(key)) {
                  // 确保key是对象自身的属性
                  let value = obj.cutPlate.models[key];
                  arrCutPlate.models[key] = value;
                }
              }
            }
            console.log("测试修改角角角角测试*****objobjobj=", obj);
          }
          console.log("测试修改角画出图20241130*****obj=", obj);
        }
      }
      console.log("fromDatas角角*******", fromDatas);
      console.log("arrMarkers=角角角角=", arrMarkers);
      console.log("arrPlate=角角角角=", arrPlate);
      console.log("arrCutPlate=角角角角=", arrCutPlate);
      console.log("myRectObj*********%%%%%%%%%%%%%%%%%+&&&&&&&", myRectObj);

      if (this.mdParma.mdTpye == 3) {
      } else {
        arrMarkers.models["myWidthMark"] = myRectObj.markers.models.myWidthMark;
        arrMarkers.models["myHeightMark"] = myRectObj.markers.models.myHeightMark;
        arrMarkers.models["Rectangle"] = myRectObj.markers.models.Rectangle;
        arrPlate.models["Rectangle"] = myRectObj.plate.models.Rectangle;
        arrCutPlate.models["Rectangle"] = myRectObj.cutPlate.models.Rectangle;
      }
      console.log("arrMarkers==", arrMarkers);
      console.log("arrPlate==", arrPlate);
      console.log("arrCutPlate==", arrCutPlate);
      this.setOuterCanvas();
      this.creatSvg(this.form.glassW, this.form.glassH, arrMarkers);
      this.markers = arrMarkers;
      this.plate = arrPlate;
      this.cutPlate = arrCutPlate;
    },
    setOuterCanvas() {
      console.log("setMdCanvas===this.visitMdNum访问次****=", this.visitMdNum);
      var w = this.form.GlassW * 1, //1200  51vw
        h = this.form.GlassH * 1; //600   75vh
      var myScaleW = (1200 / w).toFixed(1);
      var myScaleH = (600 / h).toFixed(1);
      //this.myScaleH=myScaleH;
      //this.BorderScaleMd=myScaleW*1;
      console.log("wwwwwww=", w, "HHHH====", h);
      console.log("myScaleW=", myScaleW, "myScaleH====", myScaleH);
      var drawCanvas = document.getElementById("svgToImg");
      drawCanvas.style.display = "flex";
      drawCanvas.style.justifyContent = "center";
      drawCanvas.style.alignItems = "center";
      drawCanvas.style.height = 75 + "vh";
      drawCanvas.style.width = 51 + "vw";

      this.renderOptionsImg.fontSize = "16px";
      this.renderOptionsImg.strokeWidth = "0.3mm";

      this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）

      if (this.visitMdNum == 0) {
        this.myScaleMdWAll = w;
        this.myScaleMdHAll = h;
        ///////////////////////////////////////////
        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            // this.BorderScale=myScaleW*1;
            this.renderOptionsImg.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.renderOptionsImg.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";
            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          }
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例

          this.renderOptionsImg.fontSize = "16px";
          this.renderOptionsImg.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        }
        //////////////////////////////////////
        this.BorderScaleMd = 1;
      } else {
        //this.myScaleHAll=myScaleH
        console.log("this.myScaleHAll===", this.myScaleHAll);
        console.log("myScaleH===", myScaleH);

        if (myScaleW < 1 || myScaleH < 1) {
          console.log("myScaleW<1||myScaleH<1");
          if (myScaleW <= myScaleH) {
            console.log("myScaleW<=myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleW + ")"; // 设置缩小比例
            this.BorderScaleMd = myScaleW * 1;
            this.renderOptionsImg.fontSize =
              ((16 / myScaleW) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleW) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleW) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          } else if (myScaleW > myScaleH) {
            console.log("myScaleW>myScaleH");
            drawCanvas.style.transform = "scale(" + myScaleH + ")"; // 设置缩小比例

            this.BorderScaleMd = myScaleH * 1;
            this.renderOptionsImg.fontSize =
              ((16 / myScaleH) * 1).toFixed() + "px";
            this.renderOptionsImg.strokeWidth =
              ((0.3 / myScaleH) * 1).toFixed(2) + "mm";

            this.markShiftThree = (
              ((this.markShiftThree * 1) / myScaleH) *
              1
            ).toFixed(1); //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
          }
        } else if (myScaleH > 1 && myScaleW > 1) {
          console.log("myScaleW>1||myScaleH>1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScaleMd = myScaleH * 1;
          this.renderOptionsImg.fontSize = "16px";
          this.renderOptionsImg.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        } else {
          console.log("myScaleW>=1||myScaleH>=1");
          drawCanvas.style.transform = "scale(1)"; // 设置缩小比例
          this.BorderScaleMd = 1;
          this.renderOptionsImg.fontSize = "16px";
          this.renderOptionsImg.strokeWidth = "0.3mm";
          this.markShiftThree = 20; //矩形偏移量 第三层偏移量（最靠近矩形框的里层）
        }
      }
    },
    /**
     * 只修改玻璃外框
     */
    myTest0724() {
      console.log("myTest0724(this.plate=", this.plate);
      console.log("myTest0724(this.plate.models=", this.plate.models);
      console.log("myTest0724(this.cutPlate.models=", this.cutPlate.models);
      console.log("myTest0724(this.plate.models=", this.objIsEmpty(this.plate.models)); //如果返回true则表明为空，如果为false则不空。
      console.log("myTest0724(this.dxf=", this.dxf);
      /**
       * 20240724 展示图的位置，手动调整图的切割顺序
       *
       */
      //导出DXF之前把画图的示意图显示出来

      console.log("myTest0724(this.plate.models=", this.cutPlate.models);
      var objData = this.cutPlate.models;
      //var objData = this.plate.models;
      var arrs = [];
      for (let key in objData) {
        if (objData.hasOwnProperty(key)) {
          console.log(key); // 输出每个属性的名称
          var result = key.split("Area");
          console.log("result=", result);
          arrs.push(result[1]);
        }
      }
      console.log("arrs=", arrs);

      //this.dxf=makerjs.exporter.toDXF(this.model);
      // this.dxf=makerjs.exporter.toDXF(model);

      if (this.objIsEmpty(this.cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          this.form.glassW +
          "\n20\n" +
          this.form.glassW +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP =
            "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
        }
        var arrs = this.dxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.dxf = strings + arrStr + arrs[1];
        console.log("this.dxf******=", this.dxf);
        this.saveMyDXF();
      }
    },
    // 导出水刀格式20250811
    exWaterJet20250811(plate) {
      console.log("exWaterJet20250811(plate)this.plate=", this.plate);
      console.log("exWaterJet20250811(plate)this.plate.models=", this.plate.models);
      console.log("exWaterJet20250811(plate)this.cutPlate.models=", this.cutPlate.models);
      console.log("exWaterJet20250811(plate)this.plate.models=", this.objIsEmpty(this.plate.models)); //如果返回true则表明为空，如果为false则不空。
      console.log("exWaterJet20250811(plate)this.dxf=", this.dxf);
      /**
       * 20240724 展示图的位置，手动调整图的切割顺序
       *
       */
      //导出DXF之前把画图的示意图显示出来
      var objData = this.cutPlate.models;
      //var objData = this.plate.models;
      var arrs = [];
      for (let key in objData) {
        if (objData.hasOwnProperty(key)) {
          console.log(key); // 输出每个属性的名称
          var result = key.split("Area");
          console.log("result=", result);
          arrs.push(result[1]);
        }
      }
      console.log("arrs=", arrs);

      //this.dxf=makerjs.exporter.toDXF(this.model);
      // this.dxf=makerjs.exporter.toDXF(model);

      if (this.objIsEmpty(this.cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          this.form.glassW +
          "\n20\n" +
          this.form.glassH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP =
            "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
        }
        var arrs = this.dxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.dxf = strings + arrStr + arrs[1];
        console.log("this.dxf******=", this.dxf);
        //this.saveMyDXF();
        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.dxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.dxf
          );
          }
       
        this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    //设置水刀格式
       ////////////////************* 在导航菜单中增加是否包含孔选项*/
       // changSetWaterCut(){
      //  console.log("this.WaterJetBrand=2025.10.11=",this.WaterJetBrand);
      //   if (this.WaterJetBrand == "defa") {
      //     this.exWaterJetToDeFa();
      //   } else if (this.WaterJetBrand == "aotuofu") {
      //     this.exWaterJet();
      //   } else if (this.WaterJetBrand == "yifeng") {
      //     this.exWaterJet();
      //   }else if(this.WaterJetBrand == "jinbo"){
      //     this.exWaterJet();
      //   }else if(this.WaterJetBrand == "dadi"){
      //     this.exWaterJetToDaDi();
      //   }
      // },
      // waterCutSetChange(e){     
      //    console.log("waterCutSetChange(e)==e==",e);     
      //    console.log("waterCutSetChange(e)==typeof(e)==",typeof(e));  
      //    this.waterCutSetPram=e;
       
      //   console.log("waterCutSetChange(e)==exWaterJetToDeFa|||this.cutPlate=", this.cutPlate);
      //    console.log("waterCutSetChange(e)==this.waterCutSetPram==",this.waterCutSetPram);
       // },
       
       ////////////////************* 在导航菜单中增加是否包含孔选项*/
    // 导出水刀格式（去掉基准点坐标）
    exWaterJet() {
      console.log("exWaterJet()==this.plate=", this.plate);
      console.log("exWaterJet()==this.plate.models=", this.plate.models);
      console.log("exWaterJet()==this.cutPlate.models=", this.cutPlate.models);
      console.log("exWaterJet()==this.plate.models=", this.objIsEmpty(this.plate.models)); //如果返回true则表明为空，如果为false则不空。
      console.log("exWaterJet()==this.dxf=", this.dxf);
      /**
       * 20240724 展示图的位置，手动调整图的切割顺序
       *
       */
      // var mirrorPlate=makerjs.model.mirror(this.cutPlate, true, false);
      //导出DXF之前把画图的示意图显示出来
      // var objData = mirrorPlate.models;
      var objData = this.plate.models;
      var arrs = [];
      for (let key in objData) {
        if (objData.hasOwnProperty(key)) {
          console.log(key); // 输出每个属性的名称
          var result = key.split("Area");
          console.log("result=", result);
          arrs.push(result[1]);
        }
      }
      console.log("arrs=", arrs);

      //this.dxf=makerjs.exporter.toDXF(this.model);
      // this.dxf=makerjs.exporter.toDXF(model);

      if (this.objIsEmpty(this.cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          this.form.glassW +
          "\n20\n" +
          this.form.glassH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP =
            "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
      
        var arrs = this.dxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.dxf = strings + arrStr + arrs[1];
        console.log("this.dxf******=", this.dxf);

        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.dxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.dxf
          );
          }
       
        this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
          
        
       
      }
    },
    // 导出大地水刀格式（基准点坐标在右上角）
    exWaterJetToDaDi() {
      console.log("exWaterJetToDaDi()==this.plate=", this.plate);
      console.log("exWaterJetToDaDi()==this.plate.models=", this.plate.models);
      console.log("exWaterJetToDaDi()==this.cutPlate.models=", this.cutPlate.models);
      console.log("exWaterJetToDaDi()==this.plate.models=", this.objIsEmpty(this.plate.models)); //如果返回true则表明为空，如果为false则不空。
      console.log("exWaterJetToDaDi()==this.dxf=", this.dxf);
      var toDxfModesplate=makerjs.model.move(this.cutPlate,[-this.form.glassW,-this.form.glassH]);
      var dadiDxf= makerjs.exporter.toDXF(toDxfModesplate,this.dxfOption);
      /**
       * 20240724 展示图的位置，手动调整图的切割顺序
       *
       */
      // var mirrorPlate=makerjs.model.mirror(this.cutPlate, true, false);
      //导出DXF之前把画图的示意图显示出来
      // var objData = mirrorPlate.models;
      var objData = this.plate.models;
      var arrs = [];
      for (let key in objData) {
        if (objData.hasOwnProperty(key)) {
          console.log(key); // 输出每个属性的名称
          var result = key.split("Area");
          console.log("result=", result);
          arrs.push(result[1]);
        }
      }
      console.log("arrs=", arrs);

      //this.dxf=makerjs.exporter.toDXF(this.model);
      // this.dxf=makerjs.exporter.toDXF(model);

      if (this.objIsEmpty(this.cutPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          this.form.glassW +
          "\n20\n" +
          this.form.glassH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        
        // if (this.benchMark == "G") {
        //   var splitStrP = 
        //     "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        // } else if (this.benchMark == "I") {
        //   var splitStrP =
        //     "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
        // }else if (this.benchMark == "A") {
        //   var splitStrP =
        //     "0\nPOINT\n8\n0\n10\n0\n20\n"+this.form.glassH+"\n"; //加入基点坐标
        // }else if (this.benchMark == "C") {
          // var splitStrP =
          //   "0\nPOINT\n8\n0\n10\n" + this.form.glassW +"\n20\n"+this.form.glassH+"\n"; //加入基点坐标
        // }else{
          var splitStrP ="";
        // }
      
        var arrs = dadiDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        dadiDxf = strings + arrStr + arrs[1];
        console.log("this.dxf******=", this.dxf);

        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            dadiDxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            dadiDxf
          );
          }
       
        this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
          
        
       
      }
    },
    // 导出水刀格式（去掉基准点坐标）
    exWaterJetToDeFa() {
          console.log("changeXYAxis==",this.changeXYAxis);//是否转换坐标 
       if(this.changeXYAxis=="1"){
           console.log("changeXYAxis==不转换，不转换，不转换",this.changeXYAxis);//是否转换坐标 
           this.exWaterJetToDeFaFun(this.cutPlate);
         }else if(this.changeXYAxis=="2"){
           console.log("changeXYAxis==转换坐标，转换坐标，转换坐标",this.changeXYAxis);//是否转换坐标 
           this.changeXYRadioeExp();   
           console.log("toChangeXYCutplate==转换坐标，转换坐标，转换坐标",this.toChangeXYCutplate);//是否转换坐标     
           this.exWaterJetToDeFaFun(this.toChangeXYCutplate);
         }
       },
    //导出德法水刀 进行是否坐转换
    exWaterJetToDeFaFun(cutplate){
      console.log("exWaterJetToDeFa()|||cutplate=", cutplate);
     
      //如果返回true则表明为空，如果为false则不空。
      if(this.waterCutSetPram=="1"){
        console.log("exWaterJetToDeFa()||this.waterCutSetPram==1不包含孔||||==",this.waterCutSetPram);
        this.waterCutSetVisible=false;        //获取属性名称
        // let myCutPlate={...this.cutPlate};
        let obj = _.cloneDeep(cutplate.models);
        console.log("exWaterJetToDeFa()||obj0000==",obj);
        let propertyNames = Object.keys(obj); // 返回一个包含属性名称的数组 ['name', 'age']
        console.log("exWaterJetToDeFa()||获取属性名称==PPPPPPPPPPPP=20251008",propertyNames);
        var myObjs={models:{},};
        for(var i = 0; i < propertyNames.length; i++){
           var areaNames=propertyNames[i];
           //截取js字符串的前5位：;
            var substr = areaNames.substring(0, 9);
            console.log(substr); // 
            console.log(obj[areaNames]); // 
            var objModelsCut={models:{}};
            if(substr=="TypeCorne" || substr=="TypeGapes"){
             console.log("exWaterJetToDeFa()||删除属性！",areaNames);
                // delete obj[areaNames];
             myObjs.models[areaNames] = obj[areaNames];
             objModelsCut.models={...myObjs.models};
             }
        } 
         console.log("exWaterJetToDeFa()||obj==",obj);
         console.log("exWaterJetToDeFa()||objModels==",objModelsCut);
         console.log("exWaterJetToDeFa()||this.cutPlate.models==",cutplate.models);
         /**2025.10.13 */
         /**
           * 20240724 展示图的位置，手动调整图的切割顺序
           *
           */
          var mirrorPlate=makerjs.model.mirror(objModelsCut, true, false);
          var mirrorDaFaDxf=makerjs.exporter.toDXF(this.removeQuotesDeep(mirrorPlate),this.dxfOption);
         //导出DXF之前把画图的示意图显示出来   
               
         console.log("exWaterJetToDeFa()||mirrorPlate==",mirrorPlate);
          var objData = mirrorPlate.models;
          //var objData = this.plate.models;
          var arrs = [];
          for (let key in objData) {
                if (objData.hasOwnProperty(key)) {
                  // console.log(key); // 输出每个属性的名称
                  var result = key.split("Area");
                  //  console.log("result=", result);
                 arrs.push(result[1]);
               }
              }
              // console.log("arrs=", arrs);

                //this.dxf=makerjs.exporter.toDXF(this.model);
            // this.dxf=makerjs.exporter.toDXF(model);

             if (this.objIsEmpty(this.cutPlate.models)) {
              this.myOpenMsg("图形为空，请先画图。", "提示：");
                } else {
             //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
             console.log("******************");
             //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
             var strings =
              "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
              this.form.glassW +
              "\n20\n" +
              this.form.glassH +
              "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

              var splitStr = "0\nSECTION\n2\nENTITIES\n";
        
             if (this.benchMark == "G") {
                  var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
               } else if (this.benchMark == "I") {
                 var splitStrP =
                "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
                 }else{
                 var splitStrP ="";
                 }
      
             var arrs = mirrorDaFaDxf.split(splitStr);
             var arrStr = splitStr + splitStrP;
            console.log("arrStr=", arrStr);
            //  console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
             mirrorDaFaDxf = strings + arrStr + arrs[1];
            //  console.log("this.dxf******=", this.mirrorDxf);

              if(this.setOUtFileName=="A"){
                this.downloadHoles(
                this.GlasslD  + ".dxf",
                mirrorDaFaDxf
                 );
              }else if(this.setOUtFileName=="B"){

                   this.downloadHoles(
                     this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
                    mirrorDaFaDxf
                    );
               }
       
                      this.saveHolesPng();
                 if (this.toERPParams == true) {
                 this.sendDataToERP();
                  }
           }
      /**2025.10.13 */
      // this.removeHolesDxf = makerjs.exporter.toDXF(this.cutPlate,this.dxfOption);
      }else if(this.waterCutSetPram=="2"){        
        this.waterCutSetVisible=false;
        console.log("exWaterJetToDeFa()||this.waterCutSetPram==2包含孔||||==",this.waterCutSetPram);
        console.log("exWaterJetToDeFa()||this.waterCutSetPram==2包含孔||||==",this.cutPlate);
          /**
           * 20240724 展示图的位置，手动调整图的切割顺序
           *
           */
          var objs = _.cloneDeep(cutplate);
          console.log("objs===",objs);
          console.log("objs=typeof==",typeof(objs));
          var mirrorPlate=makerjs.model.mirror(objs, true, false);
          
               
         console.log("exWaterJetToDeFa()||mirrorPlate==",mirrorPlate);
         //导出DXF之前把画图的示意图显示出来
          var mirrorDaFaDxf2=makerjs.exporter.toDXF(this.removeQuotesDeep(mirrorPlate),this.dxfOption);
          var objData = mirrorPlate.models;
          //var objData = this.plate.models;
          var arrs = [];
          for (let key in objData) {
                if (objData.hasOwnProperty(key)) {
                  console.log(key); // 输出每个属性的名称
                  var result = key.split("Area");
                  //  console.log("result=", result);
                 arrs.push(result[1]);
               }
              }
              // console.log("arrs=", arrs);

                //this.dxf=makerjs.exporter.toDXF(this.model);
            // this.dxf=makerjs.exporter.toDXF(model);

             if (this.objIsEmpty(cutplate.models)) {
              this.myOpenMsg("图形为空，请先画图。", "提示：");
               } else {
                   //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
                   //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
                    var strings =
                   "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
                    this.form.glassW +
                    "\n20\n" +
                     this.form.glassH +
                      "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

                       var splitStr = "0\nSECTION\n2\nENTITIES\n";
        
                      if (this.benchMark == "G") {
                           var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
                      } else if (this.benchMark == "I") {
                           var splitStrP =
                           "0\nPOINT\n8\n0\n10\n" + this.form.glassW + "\n20\n0\n"; //加入基点坐标
                       }else{
                            var splitStrP ="";
                       }
      
                         var arrs = mirrorDaFaDxf2.split(splitStr);
                        var arrStr = splitStr + splitStrP;
                        //  console.log("arrStr=", arrStr);
                        //  console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
                         mirrorDaFaDxf2 = strings + arrStr + arrs[1];
                        //  console.log("this.dxf******=", this.mirrorDxf);

                         if(this.setOUtFileName=="A"){
                             this.downloadHoles(
                             this.GlasslD  + ".dxf",
                             mirrorDaFaDxf2
                                              );
                          }else if(this.setOUtFileName=="B"){

                               this.downloadHoles(
                               this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
                               mirrorDaFaDxf2
                                                );
                            }
       
                               this.saveHolesPng();
                            if (this.toERPParams == true) {
                              this.sendDataToERP();
                                 }
                        }



          }
      
   
    },
    handlExWaterJetCommand(command){
    // if(this.ComIsWaterCut=="1"){
      this.WaterJetBrand = command;
      //  this.waterCutSetVisible=true;
      console.log("this.WaterJetBrand=2025.10.11=",this.WaterJetBrand);
      if (this.WaterJetBrand == "defa") {
        this.exWaterJetToDeFa();
      } else if (this.WaterJetBrand == "aotuofu") {
        this.exWaterJet();
      } else if (this.WaterJetBrand == "yifeng") {
        this.exWaterJet();
      }else if(this.WaterJetBrand == "jinbo"){
        this.exWaterJet();
      }else if(this.WaterJetBrand == "dadi"){
        this.exWaterJetToDaDi();
      }
   //  }else if(this.ComIsWaterCut=="0"){
      //   this.$message({
      //     message: '此功能试用到期，如需要继续使用，请联系贵友客服！',
      //     type: 'warning'
      //   });
      // }
      
     
      
    },
    // 异形模板库导出水刀格式
    exAbWaterJet() {
      console.log("this.abPlate=", this.abPlate);
      console.log("this.abPlate.models=", this.abPlate.models);
      console.log("this.abPlate.models=", this.objIsEmpty(this.abPlate.models)); //如果返回true则表明为空，如果为false则不空。
      console.log("this.abDxf=", this.abDxf);

      /**
       * 20240724 展示图的位置，手动调整图的切割顺序
       *
       */
      var mirrorPlate=makerjs.model.mirror(this.cutPlate, true, false);
      //导出DXF之前把画图的示意图显示出来
      
      //导出DXF之前把画图的示意图显示出来
      var objData = _.cloneDeep(mirrorPlate.models);
      console.log("objData=", objData);
      //var objData = this.plate.models;
      var arrs = [];
      for (let key in objData) {
        if (objData.hasOwnProperty(key)) {
          console.log(key); // 输出每个属性的名称
          var result = key.split("Area");
          console.log("result=", result);
          arrs.push(result[1]);
        }
      }
      console.log("arrs=", arrs);

      //this.dxf=makerjs.exporter.toDXF(this.model);
      // this.dxf=makerjs.exporter.toDXF(model);

      if (this.objIsEmpty(this.abPlate.models)) {
        this.myOpenMsg("图形为空，请先画图。", "提示：");
      } else {
        //基准点（Benchmark）位置 四个角 A、C、G、I （可以和区域位置进行对照）默认在G位置
        console.log("******************");
        //var strings="0\nSECTION\n2\nHEADER\n9\n$ACADVER\n1\nAC1018\n9\n$ACADMAINTVER\n70\n104\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n"+this.form.glassW+"\n20\n"+this.form.glassW+"\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";
        var strings =
          "0\nSECTION\n2\nHEADER\n9\n$LUNITS\n70\n4\n9\n$LIMMIN\n10\n0\n20\n0\n9\n$LIMMAX\n10\n" +
          this.abForm.glassW +
          "\n20\n" +
          this.abForm.glassH +
          "\n9\n$INSUNITS\n70\n4\n0\nENDSEC\n";

        var splitStr = "0\nSECTION\n2\nENTITIES\n";
        if (this.benchMark == "G") {
          var splitStrP = "0\nPOINT\n8\n0\n10\n0\n20\n0\n"; //加入基点坐标
        } else if (this.benchMark == "I") {
          var splitStrP =
            "0\nPOINT\n8\n0\n10\n" + this.abForm.glassW + "\n20\n0\n"; //加入基点坐标
        }else{
          var splitStrP ="";
        }
        var arrs = this.abDxf.split(splitStr);
        var arrStr = splitStr + splitStrP;
        console.log("arrStr=", arrStr);
        console.log("arrs=", arrs);
        console.log("arrs[0]=", arrs[0], "arrs[1]=", arrs[1]);
        this.abDxf = strings + arrStr + arrs[1];
        console.log("this.abDxf******=", this.abDxf);
        //this.saveMyabDXF();
        if(this.setOUtFileName=="A"){

          this.downloadHoles(
            this.GlasslD  + ".dxf",
            this.dxf
          );
          }else if(this.setOUtFileName=="B"){

          this.downloadHoles(
            this.GlasslD + "_" + this.GlassThickness.padStart(2, "0") + ".dxf",
            this.dxf
          );
          }
       
        this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
      }
    },
    creatDraw(myMarkers, myPlate, cutPlate, glassW, glassH) {
      console.log("0000creatDraw*************cutPlate", cutPlate);
      console.log("1111creatDraw*************myPlate", myPlate);
      console.log("2222creatDraw*************myMarkers", myMarkers);
      console.log("测试添加是否调用0" + JSON.stringify(this.plate));
      console.log("测试添加是否调用0+this.stateIndex" + this.stateIndex);
      console.log("测试添加是否调用0+this.myStep" + this.myStep);
      document.getElementById("drawCanvas").innerHTML = "";
      console.log("测试添加是否调用*************" + JSON.stringify(myMarkers));
      console.log("测试添加是否调用*************myMarkers" + myMarkers);
      console.log(
        "测试添加是否调用*************this.renderOptions" + this.renderOptions
      );
      var svg = makerjs.exporter.toSVG(myMarkers, this.renderOptions);
      console.log("测试添加是否调用*************");
      console.log("creatDraw*************glassW", glassW);
      console.log("creatDraw*************glassH", glassH);
      console.log("creatDraw*************&&&&&&&&&&&!!!!!!!!!!!!!cutPlate删除前", cutPlate);
      console.log("creatDraw*************myPlate", myPlate);
      console.log("creatDraw*************myMarkers", myMarkers);      
      console.log("creatDraw*************&&&&&&&&&&&!!!!!!!!!!!!!cutPlate删除后", cutPlate);


      var mirrorPlate=makerjs.model.mirror(cutPlate, true, false);
        //德法水刀 坐标需要镜像处理  mirrorDxf
      this.mirrorDxf = makerjs.exporter.toDXF(mirrorPlate,this.dxfOption);
      this.dxf = makerjs.exporter.toDXF(cutPlate,this.dxfOption);


     //获取属性名称
      // const obj = cutPlate.models;
      // const propertyNames = Object.keys(obj); // 返回一个包含属性名称的数组 ['name', 'age']
      // console.log("获取属性名称==PPPPPPPPPPPP=20251008",propertyNames);
      //   for(var i = 0; i < propertyNames.length; i++){
      //   var areaNames=propertyNames[i];
      //   //截取js字符串的前5位：;
      //   var substr = areaNames.substring(0, 9);
      //   console.log(substr); // 
      //   console.log(cutPlate.models[areaNames]); // 
      //   if(substr=="TypeHoles"){
      //     console.log("删除属性！");
      //     delete cutPlate.models[areaNames];
      //   }
      
      // } 
      
      // this.removeHolesDxf = makerjs.exporter.toDXF(cutPlate,this.dxfOption);



      document.getElementById("drawCanvas").innerHTML = svg;
      //重写SVG
      var myDrawing = document.getElementById("myDrawing").innerHTML;
      // console.log("myDrawing===", myDrawing);
      var html =
        '<svg width="' +
        (glassW * 1 + 400) +
        '" height="' +
        (glassH * 1 + 400) +
        '" viewBox="-125 -150 ' +
        (glassW * 1 + 400) +
        " " +
        (glassH * 1 + 400) +
        '" xmlns="http://www.w3.org/2000/svg" id="myDrawing">';
      var mySVGHtml = html + myDrawing + "</svg>";
      // console.log("mySVGHtml===",mySVGHtml) ;
      document.getElementById("drawCanvas").innerHTML = "";
      document.getElementById("drawCanvas").innerHTML = mySVGHtml;
    },
    //删除画布中的所有内容，
    clearSvg() {
      document.getElementById("drawCanvas").innerHTML = "";
      this.plate = {}; //当前状态
      this.markers = {}; //当前状态
      this.history = []; // 存储历史记录
      this.future = []; // 存储未来的操作记录
      this.currentState = {}; // 当前状态  Initial state 初始状态
      this.operationCurrent = {}; // 当前状态  Initial state 初始参数状态
      this.operationHistory = []; // 存储历史记录的参数记录
      this.operationFuture = []; // 存储未来的参数记录
      this.myHolesNum = 0;
    },
    //单选位置事件
    pationChange(e) {
      console.log("e=", e);
      this.showX = false;
      this.showY = false;
      switch (e) {
        case "1":
          this.showX = false;
          this.showY = false;
          break;
        case "2":
          console.log("this.tabLabel======", this.tabLabel);
          if (this.tabLabel == "拉手孔") {
            this.showX = true;
            this.showY = false;
            this.X = 0;
            this.Y = 0;
          } else if (
            this.tabLabel == "吊轮孔2" ||
            this.tabLabel == "双吊轮孔列" ||
            this.tabLabel == "双吊轮孔排" ||
            this.tabLabel == "吊轮孔3" ||
            this.tabLabel == "相对吊轮孔" ||
            this.tabLabel == "锁孔"
          ) {
            console.log("this.tabLabel******", this.tabLabel);
            this.showX = false;
            this.showY = false;
          } else {
            console.log("this.tabLabel******", this.tabLabel);
            this.showX = true;
            this.showY = false;
            this.X = 0;
          }
          break;
        case "3":
          this.showX = false;
          this.showY = false;
          break;
        case "4":
          console.log("this.tabLabel======", this.tabLabel);
          if (
            this.tabLabel == "吊轮孔2" ||
            this.tabLabel == "双吊轮孔列" ||
            this.tabLabel == "双吊轮孔排" ||
            this.tabLabel == "锁孔"
          ) {
            this.showX = false;
            this.showY = false;
          } else {
            console.log("this.tabLabel******", this.tabLabel);
            this.showX = false;
            this.showY = true;
            this.Y = 0;
          }
          break;
        case "5":
          this.showX = true;
          this.showY = true;
          this.X = 0;
          this.Y = 0;
          break;
        case "6":
          console.log("this.tabLabel======", this.tabLabel);
          if (
            this.tabLabel == "吊轮孔2" ||
            this.tabLabel == "双吊轮孔列" ||
            this.tabLabel == "双吊轮孔排" ||
            this.tabLabel == "锁孔"
          ) {
            this.showX = false;
            this.showY = false;
          } else {
            console.log("this.tabLabel******", this.tabLabel);
            this.showX = false;
            this.showY = true;
            this.Y = 0;
          }
          break;
        case "7":
          this.showX = false;
          this.showY = false;
          break;
        case "8":
          if (this.tabLabel == "拉手孔") {
            this.showX = true;
            this.showY = false;
            this.X = 0;
            this.Y = 0;
          } else if (
            this.tabLabel == "吊轮孔2" ||
            this.tabLabel == "双吊轮孔列" ||
            this.tabLabel == "双吊轮孔排" ||
            this.tabLabel == "锁孔"
          ) {
            console.log("this.tabLabel******", this.tabLabel);
            this.showX = false;
            this.showY = false;
          } else {
            console.log("case8this.tabLabel******", this.tabLabel);
            this.showX = true;
            this.showY = false;
            this.X = 0;
          }
          break;
        case "9":
          this.showX = false;
          this.showY = false;
          break;
        default:
        // code block
      }
    },
    //初始状态
    initState() {
      this.dialogFormVisible = false;
      this.setCanvas();
      this.plate = {}; //当前状态
      this.markers = {}; //当前状态
      this.history = []; // 存储历史记录
      this.future = []; // 存储未来的操作记录
      this.currentState = {}; // 当前状态  Initial state 初始状态
      this.operationCurrent = {}; // 当前状态  Initial state 初始参数状态
      this.operationHistory = []; // 存储历史记录的参数记录
      this.operationFuture = []; // 存储未来的参数记录
      this.myHolesNum = 0;
      this.dialogFormVisible = true;
    },
    //深层拷贝
    deepCopy(obj) {
      if (obj === null || typeof obj !== "object") {
        return obj; // 基本类型，直接返回
      }

      if (obj instanceof Date) {
        return new Date(obj.getTime());
      }

      if (obj instanceof Array) {
        return obj.reduce((arr, item, i) => {
          arr[i] = this.deepCopy(item);
          return arr;
        }, []);
      }

      if (obj instanceof Object) {
        return Object.keys(obj).reduce((newObj, key) => {
          newObj[key] = this.deepCopy(obj[key]);
          return newObj;
        }, {});
      }
    },

    //清除对象中的空数据
    removeEmptyObjects(obj) {
      // const obj = this.obj; // 假设操作的是 Vue 数据中的 obj 对象
      Object.keys(obj).forEach((key) => {
        const value = obj[key];
        // 判断是否为普通对象且为空
        if (
          typeof value === "object" &&
          value !== null &&
          !Array.isArray(value) &&
          Object.keys(value).length === 0
        ) {
          this.$delete(obj, key); // 响应式删除属性
        }
      });
      console.log("removeEmptyObjects==obj==", obj);
      return obj;
    },
    // 判断两个对象是否
    /**20250409使用filter+findIndex遍历所有属性，严格判断是否完全一致**/
    filterObj(data) {
      //console.log("20250409=data",data);
      const uniqueData = data.filter((item, index, self) => {
        return (
          self.findIndex((obj) =>
            Object.keys(item).every((key) => obj[key] === item[key])
          ) === index
        );
      });
      var uniDatas = _.cloneDeep(uniqueData);
      var cleanedUniDatas = this.removeEmptyObjects(uniDatas);
      console.log("pps===", cleanedUniDatas);
      console.log("20250410=typeof=uniDatas", typeof uniDatas);
      console.log("20250410==uniDatas", uniDatas);
      console.log("20250409=uniqueData==", _.cloneDeep(cleanedUniDatas));
      return cleanedUniDatas;
    },

    // 用于更新状态并添加到历史记录中
    updataParam() {
      this.currentState = {
        showX: this.showX,
        showY: this.showY,
        activeName: this.activeName,
        form: {
          glassW: this.form.glassW,
          glassH: this.form.glassH,
        },
        
        //区域位置选择单选
        radio: this.radio,

        
        ///*******类型选择********///////
         //三孔不同类型选择单选
        threeHoleType: this.threeHoleType,
        //三孔示意图参数
        threeHolePic: this.threeHolePic,
        //三孔调用函数名称变化参数
        threeHoleFn: this.threeHoleFn,

        //蝴蝶缺不同类型选择单选
        ButterflyGapType: this.ButterflyGapType,
        //蝴蝶缺示意图参数
        ButterflyGapPic: this.ButterflyGapPic,
        //蝴蝶缺调用函数名称变化参数
        ButterflyGapFn: this.ButterflyGapFn,
        
        
        //蝴蝶缺2不同类型选择单选
        ButterflyGap2Type: this.ButterflyGap2Type,
        //蝴蝶缺2示意图参数
        ButterflyGap2Pic: this.ButterflyGap2Pic,
        //蝴蝶缺2调用函数名称变化参数
        ButterflyGap2Fn: this.ButterflyGap2Fn,
        
        //蝴蝶缺3不同类型选择单选
        ButterflyGap3Type: this.ButterflyGap3Type,
        //蝴蝶缺3示意图参数
        ButterflyGap3Pic: this.ButterflyGap3Pic,
        //蝴蝶缺3调用函数名称变化参数
        ButterflyGap3Fn: this.ButterflyGap3Fn,
        
        //蝴蝶缺4不同类型选择单选
        ButterflyGap4Type: this.ButterflyGap4Type,
        //蝴蝶缺4示意图参数
        ButterflyGap4Pic: this.ButterflyGap4Pic,
        //蝴蝶缺4调用函数名称变化参数
        ButterflyGap4Fn: this.ButterflyGap4Fn,
        
        //应力孔不同类型选择单选
        StressHoleGapType: this.StressHoleGapType,
        //应力孔示意图参数
        StressHoleGapPic: this.StressHoleGapPic,
        //应力孔调用函数名称变化参数
        StressHoleGapFn: this.StressHoleGapFn,
        
        //跑道缺不同类型选择单选
        RunwayGapType: this.RunwayGapType,
        //跑道缺示意图参数
        RunwayGapPic: this.RunwayGapPic,
        //跑道缺调用函数名称变化参数
        RunwayGapFn: this.RunwayGapFn,
        
        //方缺不同类型选择单选
        SquareGapType: this.SquareGapType,
        //方缺示意图参数
        SquareGapPic: this.SquareGapPic,
        //方缺调用函数名称变化参数
        SquareGapFn: this.SquareGapFn,
        
        //U型缺不同类型选择单选
        UShapeGapType: this.UShapeGapType,
        //U型缺示意图参数
        UShapeGapPic: this.UShapeGapPic,
        //U型缺调用函数名称变化参数
        UShapeGapFn: this.UShapeGapFn,
        
        //铜夹不同类型选择单选
        CopperClipGapType: this.CopperClipGapType,
        //铜夹示意图参数
        CopperClipGapPic: this.CopperClipGapPic,
        //铜夹调用函数名称变化参数
        CopperClipGapFn: this.CopperClipGapFn,
        
        //长条夹不同类型选择单选
        LongClipGapType: this.LongClipGapType,
        //长条夹示意图参数
        LongClipGapPic: this.LongClipGapPic,
        //长条夹调用函数名称变化参数
        LongClipGapFn: this.LongClipGapFn,
        
        //吊夹不同类型选择单选
        HangClipGapType: this.HangClipGapType,
        //吊夹示意图参数
        HangClipGapPic: this.HangClipGapPic,
        //吊夹调用函数名称变化参数
        HangClipGapFn: this.HangClipGapFn,
        
        
        //地弹簧不同类型选择单选
        FloorSpringType: this.FloorSpringType,
        //地弹簧示意图参数
        FloorSpringPic: this.FloorSpringPic,
        //地弹簧调用函数名称变化参数
        FloorSpringFn: this.FloorSpringFn,
        
        //地弹簧2不同类型选择单选
        FloorSpring2Type: this.FloorSpring2Type,
        //地弹簧2示意图参数
        FloorSpring2Pic: this.FloorSpring2Pic,
        //地弹簧2调用函数名称变化参数
        FloorSpring2Fn: this.FloorSpring2Fn,

        //地弹簧3不同类型选择单选
        FloorSpring3Type: this.FloorSpring3Type,
        //地弹簧3示意图参数
        FloorSpring3Pic: this.FloorSpring3Pic,
        //地弹簧3调用函数名称变化参数
        FloorSpring3Fn: this.FloorSpring3Fn,
        
        
        
        ///*******类型选择********///////

        //方角H参数类型选择单选
        CornerType: this.CornerType,

        //水刀是否选择
        checked: this.checked,
        //X、Y偏移值 初始值
        X: this.X,
        Y: this.Y,
        D: this.D,
        R: this.R,
        Rx: this.Rx,
        Ry: this.Ry,
        R1: this.R1,
        R2: this.R2,
        D1: this.D1,
        D2: this.D2,
        H: this.H,
        H1: this.H1,
        H2: this.H2,
        W: this.W,
        W1: this.W1,
        W2: this.W2,
        //画图相关参数
        myHolesNum: this.myHolesNum, //孔的数量
        plate: this.plate, //只有路径数据 供转换DXF格式使用
        cutPlate: this.cutPlate, //只有路径数据 供转换DXF格式使用
        markers: this.markers, //包含标记数据 给到SVG
        dxf: this.dxf,
      };
    },
    updateState() {
      this.currentState = {
        showX: this.showX,
        showY: this.showY,
        activeName: this.activeName,
        form: {
          glassW: this.form.glassW,
          glassH: this.form.glassH,
        },
        //区域位置选择单选
        radio: this.radio,


        
        
        
        ///*******类型选择********///////
         //三孔不同类型选择单选
        threeHoleType: this.threeHoleType,
        //三孔示意图参数
        threeHolePic: this.threeHolePic,
        //三孔调用函数名称变化参数
        threeHoleFn: this.threeHoleFn,

        //蝴蝶缺不同类型选择单选
        ButterflyGapType: this.ButterflyGapType,
        //蝴蝶缺示意图参数
        ButterflyGapPic: this.ButterflyGapPic,
        //蝴蝶缺调用函数名称变化参数
        ButterflyGapFn: this.ButterflyGapFn,
        
        
        //蝴蝶缺2不同类型选择单选
        ButterflyGap2Type: this.ButterflyGap2Type,
        //蝴蝶缺2示意图参数
        ButterflyGap2Pic: this.ButterflyGap2Pic,
        //蝴蝶缺2调用函数名称变化参数
        ButterflyGap2Fn: this.ButterflyGap2Fn,
        
        //蝴蝶缺3不同类型选择单选
        ButterflyGap3Type: this.ButterflyGap3Type,
        //蝴蝶缺3示意图参数
        ButterflyGap3Pic: this.ButterflyGap3Pic,
        //蝴蝶缺3调用函数名称变化参数
        ButterflyGap3Fn: this.ButterflyGap3Fn,
        
        //蝴蝶缺4不同类型选择单选
        ButterflyGap4Type: this.ButterflyGap4Type,
        //蝴蝶缺4示意图参数
        ButterflyGap4Pic: this.ButterflyGap4Pic,
        //蝴蝶缺4调用函数名称变化参数
        ButterflyGap4Fn: this.ButterflyGap4Fn,
        
        //应力孔不同类型选择单选
        StressHoleGapType: this.StressHoleGapType,
        //应力孔示意图参数
        StressHoleGapPic: this.StressHoleGapPic,
        //应力孔调用函数名称变化参数
        StressHoleGapFn: this.StressHoleGapFn,
        
        //跑道缺不同类型选择单选
        RunwayGapType: this.RunwayGapType,
        //跑道缺示意图参数
        RunwayGapPic: this.RunwayGapPic,
        //跑道缺调用函数名称变化参数
        RunwayGapFn: this.RunwayGapFn,
        
        //方缺不同类型选择单选
        SquareGapType: this.SquareGapType,
        //方缺示意图参数
        SquareGapPic: this.SquareGapPic,
        //方缺调用函数名称变化参数
        SquareGapFn: this.SquareGapFn,
        
        //U型缺不同类型选择单选
        UShapeGapType: this.UShapeGapType,
        //U型缺示意图参数
        UShapeGapPic: this.UShapeGapPic,
        //U型缺调用函数名称变化参数
        UShapeGapFn: this.UShapeGapFn,
        
        //铜夹不同类型选择单选
        CopperClipGapType: this.CopperClipGapType,
        //铜夹示意图参数
        CopperClipGapPic: this.CopperClipGapPic,
        //铜夹调用函数名称变化参数
        CopperClipGapFn: this.CopperClipGapFn,
        
        //长条夹不同类型选择单选
        LongClipGapType: this.LongClipGapType,
        //长条夹示意图参数
        LongClipGapPic: this.LongClipGapPic,
        //长条夹调用函数名称变化参数
        LongClipGapFn: this.LongClipGapFn,
        
        //吊夹不同类型选择单选
        HangClipGapType: this.HangClipGapType,
        //吊夹示意图参数
        HangClipGapPic: this.HangClipGapPic,
        //吊夹调用函数名称变化参数
        HangClipGapFn: this.HangClipGapFn,
        
        
        //地弹簧不同类型选择单选
        FloorSpringType: this.FloorSpringType,
        //地弹簧示意图参数
        FloorSpringPic: this.FloorSpringPic,
        //地弹簧调用函数名称变化参数
        FloorSpringFn: this.FloorSpringFn,
        
        //地弹簧2不同类型选择单选
        FloorSpring2Type: this.FloorSpring2Type,
        //地弹簧2示意图参数
        FloorSpring2Pic: this.FloorSpring2Pic,
        //地弹簧2调用函数名称变化参数
        FloorSpring2Fn: this.FloorSpring2Fn,

        //地弹簧3不同类型选择单选
        FloorSpring3Type: this.FloorSpring3Type,
        //地弹簧3示意图参数
        FloorSpring3Pic: this.FloorSpring3Pic,
        //地弹簧3调用函数名称变化参数
        FloorSpring3Fn: this.FloorSpring3Fn,
        
        
        
        ///*******类型选择********///////
       //方角H参数类型选择单选
        CornerType: this.CornerType,


        //水刀是否选择
        checked: this.checked,
        //X、Y偏移值 初始值
        X: this.X,
        Y: this.Y,
        D: this.D,
        R: this.R,
        Rx: this.Rx,
        Ry: this.Ry,
        R1: this.R1,
        R2: this.R2,
        D1: this.D1,
        D2: this.D2,
        H: this.H,
        H1: this.H1,
        H2: this.H2,
        W: this.W,
        W1: this.W1,
        W2: this.W2,
        //画图相关参数
        myHolesNum: this.myHolesNum, //孔的数量
        plate: this.plate, //只有路径数据 供转换DXF格式使用
        cutPlate: this.cutPlate, //只有路径数据 供转换DXF格式使用
        markers: this.markers, //包含标记数据 给到SVG
        dxf: this.dxf,
      };
      const cur = _.cloneDeep(this.currentState);
      const curOpt = _.cloneDeep(this.operationCurrent);
      const curOptHis = _.cloneDeep(this.operationHistory);
      const upHistory = _.cloneDeep(this.history);
      const upOperationHistory = _.cloneDeep(this.operationHistory);

      var remOptHis = this.removeEmptyObjects(curOptHis); //清空空数据
      var filterHis = this.filterObj(remOptHis);
      console.log("cur=", cur);
      console.log("curOpt=", curOpt);
      console.log("curOptHis=", curOptHis);
      if (curOptHis.length >= 1) {
        console.log(
          "curOptHis[this.curOptHis.length-1]=",
          curOptHis[curOptHis.length - 1]
        );
        var endOptHisStr = JSON.stringify(curOptHis[curOptHis.length - 1]);
        var curOptStr = JSON.stringify(curOpt);
        if (endOptHisStr === curOptStr) {
          console.log("相同同同同同");
          this.future = []; // 更新状态后，清空未来操作记录
          this.operationFuture = []; // 更新状态后，清空未来参数记录
          // console.log("this.history=", _.cloneDeep(this.history));
          // console.log("后this.history.length=", this.history.length);
          this.stateIndex = upHistory.length;
        } else {
          console.log("不不不不相同");
          upHistory.push(cur); //每次操作记录保存
          upOperationHistory.push(curOpt); //每次操作参数记录保存
          this.future = []; // 更新状态后，清空未来操作记录
          this.operationFuture = []; // 更新状态后，清空未来参数记录
          // console.log("this.history=", _.cloneDeep(this.history));
          // console.log("后this.history.length=", this.history.length);
          this.stateIndex = upHistory.length;
          this.myStep++;
          console.log("this.stateIndex=", this.stateIndex);
          console.log("this.myStep=", this.myStep);
        }
      } else {
        upHistory.push(cur); //每次操作记录保存
        upOperationHistory.push(curOpt); //每次操作参数记录保存
        this.future = []; // 更新状态后，清空未来操作记录
        this.operationFuture = []; // 更新状态后，清空未来参数记录
        // console.log("this.history=", _.cloneDeep(this.history));
        // console.log("后this.history.length=", this.history.length);
        this.stateIndex = upHistory.length;
        this.myStep++;
        console.log("this.stateIndex=", this.stateIndex);
        console.log("this.myStep=", this.myStep);
      }
      console.log(
        "remove 去空==curOptHis=",
        this.removeEmptyObjects(curOptHis)
      );
      console.log("去重==curOptHis=", filterHis);

      this.history = _.cloneDeep(upHistory);
      this.operationHistory = _.cloneDeep(upOperationHistory);

      console.log("updateState  this.history=", _.cloneDeep(this.history));
      console.log(
        "updateState  this.operationHistory=",
        _.cloneDeep(this.operationHistory)
      );
      //20250505增加 刷新
      // this.plate = upOperationHistory.plate;
      // this.markers = upOperationHistory.markers;
      // this.cutPlate =upOperationHistory.cutPlate;
    },
    //撤销操作 用于从历史记录中弹出状态，并将当前状态放入未来记录中。
    /*
      isDrawUndo:true,
      isDrawRedo:true,
      isClearSvg:true,
*/
    //撤销操作
    drawUndo(index) {
      console.log("drawUndo");

      console.log("drawUndo  this.history=", _.cloneDeep(this.history));
      console.log(
        "drawUndo  this.operationHistory=",
        _.cloneDeep(this.operationHistory)
      );
      this.stateIndex = index;
      const cur = _.cloneDeep(this.currentState);
      const curOpt = _.cloneDeep(this.operationCurrent);
      const undoFuture = _.cloneDeep(this.future);
      const undoOperationFuture = _.cloneDeep(this.operationFuture);
      const undoHistory = _.cloneDeep(this.history);
      const undoOperationHistory = _.cloneDeep(this.operationHistory);

      console.log("POP前drawUndo  undoFuture=", undoFuture);
      console.log("POP前drawUndo  undoOperationFuture=", undoOperationFuture);
      console.log("POP前drawUndo  undoHistory=", undoHistory);
      console.log("POP前drawUndo  undoOperationHistory=", undoOperationHistory);
      console.log("POP前drawUndo  undoHistory.length=", undoHistory.length);
      undoFuture.push(cur); // 当前状态放入未来记录
      undoOperationFuture.push(curOpt); //每次操作参数记录保存
      undoHistory.pop(); // 从历史记录中移除最后一项
      undoOperationHistory.pop(); // 从历史记录中移除最后一项参数

      console.log("POP后drawUndo  undoFuture=", undoFuture);
      console.log("POP后drawUndo  undoOperationFuture=", undoOperationFuture);
      console.log("POP后drawUndo  undoHistory=", undoHistory);
      console.log("POP后drawUndo  undoOperationHistory=", undoOperationHistory);
      console.log("POP后drawUndo  undoHistory.length=", undoHistory.length);
      console.log(
        "POP后drawUndo  undoHistory[undoHistory.length - 1]=",
        undoHistory[undoHistory.length - 1]
      );

      if (undoHistory.length === 0) {
        document.getElementById("drawCanvas").innerHTML = "";
        console.log("测试什么时候调用");
        this.currentState = {};
        this.operationCurrent = {};
        this.future = _.cloneDeep(undoFuture);
        this.operationFuture = _.cloneDeep(undoOperationFuture);
        this.history = [];
        this.operationHistory = [];
      } else {
        this.currentState = _.cloneDeep(undoHistory[undoHistory.length - 1]);
        this.operationCurrent = _.cloneDeep(
          undoOperationHistory[undoOperationHistory.length - 1]
        );
        this.future = _.cloneDeep(undoFuture);
        this.operationFuture = _.cloneDeep(undoOperationFuture);
        this.history = _.cloneDeep(undoHistory);
        this.operationHistory = _.cloneDeep(undoOperationHistory);

        var _this = _.cloneDeep(this.currentState);

        //20250505增加 刷新
        this.plate = _this.plate;
        this.markers = _this.markers;
        this.cutPlate = _this.cutPlate;

        console.log("******* _this=", _this);
        console.log("******* _this=", _this.cutPlate);
        this.creatDraw(
          _this.markers,
          _this.plate,
          _this.cutPlate,
          _this.form.glassW,
          _this.form.glassH
        );
      }
      console.log(
        "后drawUndo  this.currentState=",
        _.cloneDeep(this.currentState)
      );
      console.log(
        "drawUndo  this.operationCurrent=",
        _.cloneDeep(this.operationCurrent)
      );
      console.log("drawUndo  this.future=", _.cloneDeep(this.future));
      console.log(
        "drawUndo  this.operationFuture=",
        _.cloneDeep(this.operationFuture)
      );
      console.log("drawUndo  this.history=", _.cloneDeep(this.history));
      console.log(
        "drawUndo  this.operationHistory=",
        _.cloneDeep(this.operationHistory)
      );
    },
    //恢复操作 将未来记录中的状态弹出，并放入历史记录中。
    drawRedo(index) {
      console.log("恢复 drawRedo");
      this.stateIndex = index;
      const cur = _.cloneDeep(this.currentState);
      const curOpt = _.cloneDeep(this.operationCurrent);
      const redoFuture = _.cloneDeep(this.future);
      const redoOperationFuture = _.cloneDeep(this.operationFuture);
      const redoHistory = _.cloneDeep(this.history);
      const redoOperationHistory = _.cloneDeep(this.operationHistory);
      console.log("push前drawRedo   cur==", cur);
      console.log("push前drawRedo  redoHistory=", redoHistory);
      console.log("push前drawRedo  redoFuture=", redoFuture);
      console.log("push前drawRedo  redoOperationFuture=", redoOperationFuture);
      console.log(
        "push前drawRedo  redoOperationHistory=",
        redoOperationHistory
      );
      console.log("push前drawRedo  redoHistory.length=", redoHistory.length);

      const fut = redoFuture.pop();
      const oper = redoOperationFuture.pop();

      redoHistory.push(fut); // 当前状态放入历史记录
      redoOperationHistory.push(oper); // 当前参数放入历史记录

      console.log("push后drawRedo  fut=", fut);
      console.log("push后drawRedo  oper=", oper);
      console.log("push后drawRedo  redoFuture=", redoFuture);
      console.log("push后drawRedo  redoOperationFuture=", redoOperationFuture);
      console.log("push后drawRedo  redoHistory=", redoHistory);
      console.log(
        "push后drawRedo  redoOperationHistory=",
        redoOperationHistory
      );
      console.log("push后drawRedo  redoHistory.length=", redoHistory.length);

      this.currentState = _.cloneDeep(fut); // 从未来记录中弹出状态
      this.operationCurrent = _.cloneDeep(oper); // 从未来记录中弹出参数
      this.future = _.cloneDeep(redoFuture);
      this.operationFuture = _.cloneDeep(redoOperationFuture);
      this.history = _.cloneDeep(redoHistory);
      this.operationHistory = _.cloneDeep(redoOperationHistory);

      var _this = _.cloneDeep(this.currentState);
      console.log("drawRedo  _this==", _this);
      this.creatDraw(
        _this.markers,
        _this.plate,
        _this.cutPlate,
        _this.form.glassW,
        _this.form.glassH
      );
      console.log("drawRedo  this.history=", _.cloneDeep(this.history));
      console.log(
        "drawRedo  this.operationHistory=",
        _.cloneDeep(this.operationHistory)
      );
    },
    //单孔不同选项切换
    handleClickHole(tab, event) {
      console.log("tab, event");
      console.log("tab==", tab._props.name);
      console.log("tab.label=", tab.label);
      console.log(tab);
      console.log(event);
      this.tabLabel = tab.label;
      this.showX = false;
      this.showY = false;
      if (
        tab.label == "吊轮孔2" ||
        tab.label == "吊轮孔3" ||
        tab.label == "双吊轮孔列" ||
        tab.label == "拉手孔" ||
        tab.label == "双吊轮孔排" ||
        tab.label == "相对吊轮孔"
      ) {
        this.radio = "4";
        this.showX = false;
        this.showY = true;
        this.Y = 0;
        this.pationChange(2);
      } else if (
        tab.label == "锁孔"
        //   ||
        //  tab.label == "三孔" ||
        //   tab.label == "三孔2" ||
        //   tab.label == "三孔3" ||
        //  tab.label == "三孔4"
      ) {
        this.radio = "8";
        this.X = 0;
        this.pationChange(2);
      } else if (
        tab.label == "三孔"
        //   ||
        //  tab.label == "三孔" ||
        //   tab.label == "三孔2" ||
        //   tab.label == "三孔3" ||
        //  tab.label == "三孔4"
      ) {
        this.D = "14";
        this.H = "425";
        this.W = "225";
        this.X = "950";
        this.Y = "60";
        this.radio = "7";
        this.pationChange(7);
      } else {
        this.radio = "7";
        this.pationChange(7);
      }
    },
    //缺不同选项切换
    handleClickGap(tab, event) {
      console.log("tab, event");
      this.tabLabel = tab.label;
      this.showX = false;
      this.showY = true;
      this.Y = 0;
      if (
        tab.label == "矩形缺" ||
        tab.label == "椭圆" ||
        tab.label == "圆角矩形A" ||
        tab.label == "圆角矩形B"
      ) {
        this.radio = "7";
        this.showY = false;
        this.showX = false;
        this.R = "0";
        this.R1 = "0";
        this.R2 = "0";
        this.H = "0";
        this.H1 = "0";
        this.H2 = "0";
        this.W = "0";
        this.W1 = "0";
        this.W2 = "0";
        this.pationChange(7);
      } else if (tab.label == "蝴蝶") {
        this.R = "7";
        this.H = "58";
        this.W = "37.5";
        this.R1 = "5";
        this.showY = false;
        this.showX = false;
      } else if (tab.label == "蝴蝶2") {
        this.R = "8";
        this.W = "58";
        this.W1 = "61";
        this.H = "37.5";
        this.H1 = "40";
        this.R1 = "5";
        this.showY = false;
        this.showX = false;
      } else if (tab.label == "蝴蝶3") {
        this.R1 = "3";
        this.R2 = "7";
        this.W = "58";
        this.H = "28";
        this.H1 = "34";
        this.H2 = "37";
        this.showY = false;
        this.showX = false;
      } else if (tab.label == "蝴蝶4") {
        this.R1 = "5";
        this.R2 = "6.5";
        this.W = "55";
        this.W1 = "58";
        this.H = "37.5";
        this.showY = false;
        this.showX = false;
      } else if (tab.label == "吊夹") {
        this.D = "20";
        this.W = "60";
        this.W1 = "65";
        this.H = "25";
        this.H1 = "35";
        this.showY = false;
        this.showX = false;
      } else {
        this.R1 = "0";
        this.R2 = "0";
        this.H = "0";
        this.H1 = "0";
        this.H2 = "0";
        this.W = "0";
        this.W1 = "0";
        this.W2 = "0";
      }
    },
    //角不同选项切换
    handleClickCorner(tab, event) {
      this.tabLabel = tab.label;
      this.radio = "7";
      this.pationChange(1);
      if (tab.label == "地弹簧3") {
        this.D = "20";
        this.H = "36";
        this.H1 = "35";
        this.R = "75";
        this.W1 = "146";
        this.W2 = "125";
      } else if (tab.label == "地弹簧2") {
        this.D = "18";
        this.H = "37";
        this.W = "68";
        this.H1 = "36";
        this.R = "70";
        this.W1 = "148";
        this.W2 = "130";
      } else if (tab.label == "地弹簧") {
        this.D = "20";
        this.H = "37";
        this.W = "68";
        this.H1 = "36";
        this.R1 = "80";
        this.R2 = "55";
        this.W1 = "146";
        this.W2 = "161";
      } else {
        this.D = "0";
        this.H = "0";
        this.W = "0";
        this.H1 = "0";
        this.R1 = "0";
        this.R = "0";
        this.R2 = "0";
        this.W1 = "0";
        this.W2 = "0";
      }
      console.log("tab, event");
      console.log("tab==", tab);
      console.log("tab.label==", tab.label);
      console.log("tab._props.label==", tab._props.label);
      console.log("event==", event);
    },
    handleClickCard(tab, event) {
      this.tabLabel = tab.label;
      this.activeName = "first";
      this.radio = "7";
      if (tab.label == "缺") {
        this.R = "7";
        this.H = "58";
        this.W = "37.5";
        this.R1 = "5";
        this.Y = 0;
        this.showX = false;
        this.showY = true;
      } else if (tab.label == "孔") {
        this.R = "0";
        this.H = "0";
        this.W = "0";
        this.showX = false;
        this.showY = false;
      } else {
        this.R = "0";
        this.H = "0";
        this.W = "0";
        this.showX = true;
        this.showY = true;
        this.X = 0;
        this.Y = 0;
      }
    },
    /*****画图*****/
    // 矩形玻璃
    creatRect() {
      this.dialogFormVisible = false;
      this.setCanvas();
      this.plate = {};
      this.cutPlate = {};
      this.markers = {};
      this.history = []; // 存储历史记录
      this.future = []; // 存储未来的操作记录

      this.currentState = {}; // 当前状态  Initial state 初始状态
      this.operationCurrent = {}; // 当前状态  Initial state 初始参数状态
      this.operationHistory = []; // 存储历史记录的参数记录
      this.operationFuture = []; // 存储未来的参数记录
      this.myHolesNum = 0;
      var w = this.form.glassW * 1,
        TxtW = "长(X)=" + w.toString(),
        h = this.form.glassH * 1,
        TxtH = "宽(Y)=" + h.toString();
      console.log("w=", w, "h=", h);
      if (w == h) {
        var myRect = new makerjs.models.Square(w);
      } else {
        var myRect = new makerjs.models.Rectangle(w, h);
      }
      this.plate = {
        models: {
          //myRect:myRect
        },
      };
      this.cutPlate = {
        models: {
          //myRect:myRect
        },
      };
      var myWidthMark = new makerjs.models.Square(0);
      var myHeightMark = new makerjs.models.Square(0);

      makerjs.model.addPath(
        myWidthMark,
        new makerjs.paths.Line(
          [0, -this.markShift + 5],
          [0, -this.markShift - 5]
        )
      ); //长度左竖短标线
      makerjs.model.addPath(
        myWidthMark,
        new makerjs.paths.Line(
          [w, -this.markShift + 5],
          [w, -this.markShift - 5]
        )
      ); //长度右竖短标线
      makerjs.model.addPath(
        myWidthMark,
        new makerjs.paths.Line([0, -this.markShift], [w, -this.markShift])
      ); //长度标线
      makerjs.model.addCaption(
        myWidthMark,
        TxtW,
        [0, -this.markShift - 8],
        [w, -this.markShift - 8]
      ); //长度文字

      makerjs.model.addPath(
        myHeightMark,
        new makerjs.paths.Line(
          [-this.markShift + 5, 0],
          [-this.markShift - 5, 0]
        )
      ); //宽度标线
      makerjs.model.addPath(
        myHeightMark,
        new makerjs.paths.Line(
          [-this.markShift + 5, h],
          [-this.markShift - 5, h]
        )
      ); //宽度标线
      makerjs.model.addPath(
        myHeightMark,
        new makerjs.paths.Line([-this.markShift, 0], [-this.markShift, h])
      ); //宽度标线
      makerjs.model.addCaption(
        myHeightMark,
        TxtH,
        [-this.markShift - 8, 0],
        [-this.markShift - 8, h]
      ); //宽度文字
      this.markers = {
        models: {
          myWidthMark: myWidthMark,
          myHeightMark: myHeightMark,
          myRect: myRect,
        },
      };
      var svg = makerjs.exporter.toSVG(this.markers, this.renderOptions);
      //20240722 this.dxf = makerjs.exporter.toDXF(this.plate);
      console.log("this.cutPlate =typeof", typeof this.cutPlate);
      
      var mirrorPlate=makerjs.model.mirror(this.cutPlate, true, false);
        //德法水刀 坐标需要镜像处理  mirrorDxf
        this.mirrorDxf = makerjs.exporter.toDXF(mirrorPlate,this.dxfOption);
      this.dxf = makerjs.exporter.toDXF(this.cutPlate,this.dxfOption);
      document.getElementById("drawCanvas").innerHTML = svg;
      this.creatSvg(this.form.glassW, this.form.glassH, this.markers);
    },
    //重新画图
    creatSvg(w, h, maker) {
      var x = document.getElementById("drawCanvas");
      x.innerHTML = "";
      console.log("this.BorderScale===", this.BorderScale);
      if (this.BorderScale < 1) {
        var bordwd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var bordhd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var hd = h * 1 - this.myScaleHAll * 1;
        var wd = 0;
        console.log("h*this.BorderScale*1===", h * this.BorderScale * 1);
        console.log("bordhd*1===", bordhd * 1);
        console.log("markShiftThree===", this.markShiftThree);
        console.log("hd===", hd);
        console.log("wd===", wd);
        console.log("bordwd===", bordwd);
        console.log("bordhd===", bordhd);
      } else if (this.BorderScale > 1) {
        var bordwd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var bordhd = ((this.markShiftThree * 5) / 2) * (-1).toFixed();
        var hd = h * 1 - this.myScaleHAll * 1;
        var wd = 0;
        console.log("this.BorderScale*1===", this.BorderScale * 1);
        console.log("h*this.BorderScale*1===", h * this.BorderScale * 1);
        console.log("bordhd*1===", bordhd * 1);
        console.log("markShiftThree===", this.markShiftThree);
        console.log("hd===", hd);
        console.log("wd===", wd);
        console.log("bordwd===", bordwd);
        console.log("bordhd===", bordhd);
      } else if (this.BorderScale == 1) {
        if (this.myScaleHAll < h) {
          var hd = h * 1 - this.myScaleHAll * 1,
            wd = 0;
          var bordwd = -((this.markShiftThree * 5) / 2) * 2,
            bordhd = -((this.markShiftThree * 5) / 2) * 2;
        } else if (this.myScaleHAll > h) {
          var hd = h * 1 - this.myScaleHAll * 1,
            wd = 0;
          var bordwd = -((this.markShiftThree * 5) / 2) * 2,
            bordhd = -((this.markShiftThree * 5) / 2) * 2;
        } else {
          console.log("this.markShiftThree=", this.markShiftThree);
          console.log(
            "this.markShiftThree*1/2=",
            (this.markShiftThree * 1) / 2
          );
          var hd = 0,
            wd = 0;
          var bordwd = -((this.markShiftThree * 5) / 2) * 2,
            bordhd = -((this.markShiftThree * 5) / 2) * 2;
        }

        console.log("bordwd===", bordwd);
      }
      makerjs.model.move(maker, [-wd, -hd]);
      var svg = makerjs.exporter.toSVG(maker, this.renderOptions);
      document.getElementById("drawCanvas").innerHTML = svg;
      //重写SVG
      var myDrawing = document.getElementById("myDrawing").innerHTML;
      console.log("myDrawing=creatSvg=creatSvg==", myDrawing);
      var html =
        '<svg width="' +
        (w * 1 + this.markShiftThree * 6) +
        '" height="' +
        (h * 1 + this.markShiftThree * 6) +
        '" viewBox="' +
        bordwd +
        " " +
        bordhd +
        " " +
        (w * 1 + this.markShiftThree * 6) +
        " " +
        (h * 1 + this.markShiftThree * 6) +
        '"  xmlns="http://www.w3.org/2000/svg" id="myDrawing">';
      var mySVGHtml = html + myDrawing + "</svg>";
      document.getElementById("drawCanvas").innerHTML = "";
      document.getElementById("drawCanvas").innerHTML = mySVGHtml;
      this.updateState();
    },
    /***孔***/
    //一级调用，在页面中用
    drawLevelOne(type, shape) {
      /**
       *  shape:'SingleHole',
       *  type:'Hole'  'Gap'  'corner'
       *
       *
       *
       *
       */

      //调用判断参数是否为0的函数  不能为0的参数进行判断，参数除了XY和输入参数数量相同
      //var arr=this.isParamZero(type,shape);
      //console.log("arr[0]=",arr[0]);
      //console.log("arr[1]=",arr[1]);

      console.log(
        "this.isParamZero(type, shape)====",
        this.isParamZero(type, shape)
      );
      this.isParamZero(type, shape);
      console.log("this.operationParam=", this.operationParam);
      if (this.history.length === 0) {
        console.log("this.history.length === 0");
        this.initState();
      } else {
        if (this.plate) {
          console.log("this.plate*****测试是否返回内容");
          if (this.isParamZero(type, shape)) {
            this.$message({
              showClose: false,
              message: "贵友提示您：请输入孔的直径D！",
              type: "warning",
              offset: "200",
            });
            return;
          }
          this.operationCurrent = _.cloneDeep(this.operationParam);
          if (
            JSON.stringify(this.operationHistory).includes(
              JSON.stringify(this.operationParam)
            ) === false
          ) {
            this.callDrawFun(type, shape);
          } else {
            console.log("已存在");
            this.$message({
              showClose: false,
              message: "贵友提示您：不能重复添加相同图形，请检查参数！",
              type: "warning",
              offset: "200",
            });
          }
        } else {
          this.dialogFormVisible = true;
        }
      }
    },
    //判断参数是否为0
    isParamZero(type, shape) {
        /**
       *  shape:'SingleHole',
       *  type:'Hole'  'Gap'  'corner'
       */
      var ParamObj = {
        //1、 单孔
        SingleHole: {
          D: this.D,
        },
        //2、吊轮孔2
        HangWheelHoleTwo: {
          D: this.D,
        },
        //3、吊轮孔3
        HangWheelHoleThree: {
          D: this.D,
        },
        //4、双吊轮孔列
        HangWheelHoleTwoCol: {
          D: this.D,
          H: this.H,
        },
        //5、双吊轮孔排
        HangWheelHoleTwoRow: {
          D: this.D,
          W: this.W,
        },
        //6、晾物孔
        HangHole: {
          D: this.D,
          W: this.W,
          H1: this.H1,
          H2: this.H2,
        },
        //7、拉手孔T字
        HandleHoleTShaped: {
          D: this.D,
          W: this.W,
          H1: this.H1,
          H2: this.H2,
        },
        //8、双固定孔
        DoubleFixHoles: {
          D: this.D,
          W: this.W,
        },
        //8、双固定孔列
        DoubleFixHolesCol: {
          D: this.D,
          H: this.H,
        },
        //9、相对吊轮孔
        RelSuWheelHole: {
          D: this.D,
          W: this.W,
        },
        //10、拉手孔
        HandleHole: {
          D: this.D,
          W: this.W,
        },
        //11、旋转锁孔
        RotatLockHole: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //12、拉手孔3
        HandleHole3: {
          D: this.D,
          H: this.H,
        },
        //13、吊轮孔列
        HangWheelHoleCol: {
          D: this.D,
          H: this.H,
        },
        //14、7字拉手孔
        Shaped7HandleHole: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //15、锁孔
        KeyHole: {
          D1: this.D1,
          D2: this.D2,
          W: this.W,
          H: this.H,
        },
        //16、三孔
        ThreeHoles: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //17、三孔2
        ThreeHoles2: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //18、三孔3
        ThreeHoles3: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //19、三孔4
        ThreeHoles4: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        // *****缺*****
        //1、蝴蝶
        ButterflyGap: {
          R: this.R,
          W: this.W,
          H: this.H,
          // R1: this.R1,
        },//1、蝴蝶
        ButterflyGapH: {
          R: this.R,
          W: this.W,
          H: this.H,
          // R1: this.R1,
        },
        //1.2、蝴蝶2
        ButterflyGap2: {
          R: this.R,
          W: this.W,
          H: this.H,
          W1: this.W1,
          H1: this.H1,
          // R1: this.R1,
        },
        //1.2、蝴蝶2
        ButterflyGap2H: {
          R: this.R,
          W: this.W,
          H: this.H,
          W1: this.W1,
          H1: this.H1,
          // R1: this.R1,
        },
        //1.3、蝴蝶3
        ButterflyGap3: {
          R1: this.R1,
          R2: this.R2,
          W: this.W,
          H: this.H,
          H1: this.H1,
          H2: this.H2,
        },
        //1.3、蝴蝶3
        ButterflyGap3H: {
          R1: this.R1,
          R2: this.R2,
          W: this.W,
          H: this.H,
          H1: this.H1,
          H2: this.H2,
        },
        //1.4、蝴蝶4
        ButterflyGap4: {
          R1: this.R1,
          R2: this.R2,
          W: this.W,
          W1: this.W1,
          H: this.H,
        },
        //1.4、蝴蝶4H
        ButterflyGap4H: {
          R1: this.R1,
          R2: this.R2,
          W: this.W,
          W1: this.W1,
          H: this.H,
        },
        //2、U型
        UShapeGap: {
          D: this.D,
          H: this.H,
        },
        //2、U型2
        UShapeGapH: {
          D: this.D,
          H: this.H,
        },
        //3、应力孔
        StressHoleGap: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //3、应力孔
        StressHoleGapH: {
          D: this.D,
          W: this.W,
          H: this.H,
        },
        //4、跑道缺
        RunwayGap: {
          W: this.W,
          W1: this.W1,
          H: this.H,
          H1: this.H1,
        },
        //4、跑道缺
        RunwayGapH: {
          W: this.W,
          W1: this.W1,
          H: this.H,
          H1: this.H1,
        },
        //5、1方缺
        SquareGap: {
          W: this.W,
          H: this.H,
          R: this.R,
        },
        //5、1方缺
        SquareGapH: {
          W: this.W,
          H: this.H,
          R: this.R,
        },
        //5、2矩形缺
        RectAngleGap: {
          W: this.W,
          H: this.H,
          R: this.R,
        },
        //6、铜夹
        CopperClipGap: {
          D: this.D,
          W: this.W,
          H1: this.H1,
          H: this.H,
          R: this.R,
        },
        //6、铜夹
        CopperClipGapH: {
          D: this.D,
          W: this.W,
          H1: this.H1,
          H: this.H,
          R: this.R,
        },
        //7、长条夹
        LongClipGap: {
          D: this.D,
          D1: this.D1,
          H: this.H,
          H1: this.H1,
        },
        //7、长条夹
        LongClipGapH: {
          D: this.D,
          D1: this.D1,
          H: this.H,
          H1: this.H1,
        },
        //9、吊夹
        HangClipGap: {
          D : this.D,
          H: this.H,
          H1: this.H1,
          W: this.W,
          W1: this.W1,
        },
        //9、吊夹
        HangClipGapH: {
          D : this.D,
          H: this.H,
          H1: this.H1,
          W: this.W,
          W1: this.W1,
        },
        //8、椭圆
        EllipseGap: {
          Rx: this.Rx,
          Ry: this.Ry,
        },
        //9、圆角矩形A
        RectRoundGapA: {
          W: this.W,
          W1: this.W1,
          W2: this.W2,
          H: this.H,
          H1: this.H1,
          H2: this.H2,
          R: this.R,
          R1: this.R1,
          R2: this.R2,
        },
        //10、圆角矩形B
        RectRoundGapB: {
          W: this.W,
          W1: this.W1,
          W2: this.W2,
          R: this.R,
          R1: this.R1,
        },

        //********角*******
        //1、斜角 corner
        ObliqueAngle: {
          W: this.W,
          H: this.H,
        },
        //2、圆角
        Fillet: {
          R: this.R,
        },
        //3、方角
        Corner: {
          R: this.R,
          W: this.W,
          H: this.H,
        },
        //4、圆角2
        Fillet2: {
          R: this.R,
          W: this.W,
          H: this.H,
        },
        //5、地弹簧
        FloorSpring: {
          D: this.D,
          H: this.H,
          H1: this.H1,
          R1: this.R1,
          R2: this.R2,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
        //5、地弹簧
        FloorSpringH: {
          D: this.D,
          H: this.H,
          H1: this.H1,
          R1: this.R1,
          R2: this.R2,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
        //6、地弹簧2
        FloorSpring2: {
          D: this.D,
          H: this.H,
          H1: this.H1,
          R: this.R,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
        //6、地弹簧2
        FloorSpring2H: {
          D: this.D,
          H: this.H,
          H1: this.H1,
          R: this.R,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
        //7、地弹簧3
        FloorSpring3: {
          D: this.D,
          H: this.H,
          H1: this.H1,
          R: this.R,
          W1: this.W1,
          W2: this.W2,
        },
        //8、地弹簧3H
        FloorSpring3H: {
          D: this.D,
          H: this.H,
          H1: this.H1,
          R: this.R,
          W1: this.W1,
          W2: this.W2,
        },
        //********异形*******
        //1、梯形  LadderShaped
        //1.1 等腰梯形  IsoscelesTrapezoid
        IsoscelesTrapezoid: {
          H: this.H,
          W: this.W,
          W1: this.W1,
        },
        //1.2 等腰梯形  RightAngledTrapezoid
        RightAngledTrapezoid: {
          H: this.H,
          H1: this.H1,
          W: this.W,
          W1: this.W1,
        },
        //1.3 其它梯形A  OtherTrapezoidsA
        OtherTrapezoidsA: {
          H1: this.H1,
          H2: this.H2,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
        //1.4 其它梯形B  OtherTrapezoidsB
        OtherTrapezoidsB: {
          H: this.H,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
        //2、平形四边形  Parallelogram
        //2.1 平形四边形A
        ParallelogramA: {
          H: this.H,
          W: this.W,
          W1: this.W1,
        },
        //2.1 平形四边形B
        ParallelogramB: {
          H: this.H,
          W: this.W,
          W1: this.W1,
          W2: this.W2,
        },
      };
      var SameObj = {
        X: this.X,
        Y: this.Y,
        area: this.radio,
        shape: shape,
        type: type,
      };
      //this.objIsEmpty();
      console.log("ParamObj[shape]=", ParamObj[shape]);
      var obj = ParamObj[shape];
      //var arr=[];
      this.operationParam = { ...ParamObj[shape], ...SameObj };
      //arr[1]=this.objIsZero(obj);
      //console.log("this.objIsZero=",this.objIsZero(obj));
      console.log("obj=", obj);
      if (shape == "Corner") {
        delete obj.R;
        this.objIsZero(obj);
      } else {
        return this.objIsZero(obj);
      }
    
    },
    //根据实际情况调用基本图形函数
    callDrawFun(type, shape) {
      this.updataParam();

      //   console.log("callDrawFun########@@@@@@@@@@@@@@@@@@@@@@this.operationHistory==",this.operationHistory);
      //   console.log("this.operationHistory==",typeof(this.operationHistory));
      //   var objsss= this.filterObj(this.operationHistory);
      //  // this.operationHistory="";
      //   this.operationHistory=JSON.parse(JSON.stringify(objsss));
      //   console.log("callDrawFun查看去重后的效果########@@@@@@@@@@@@@@@@@@@@@@objsss==",objsss);
      //   console.log("callDrawFun查看去重后的效果########@@@@@@@@@@@@@@@@@@@@@@this.operationHistory==",JSON.parse(JSON.stringify(this.operationHistory)));
      console.log(
        "callDrawFun########@@@@@@@@@@@@@@@@@@@@@@==",
        JSON.parse(JSON.stringify(this.operationHistory))
      );
      const drawOperationHistory = _.cloneDeep(this.operationHistory);
      console.log("callDrawFun  this.plate=", _.cloneDeep(this.plate));
      console.log("callDrawFun  this.markers=", _.cloneDeep(this.markers));
      console.log("callDrawFun  this.cutPlate=", _.cloneDeep(this.cutPlate));
      var obj = {};
      for (var i = 1; i < drawOperationHistory; i++) {
        console.log("i====", i);
        console.log("drawOperationHistory====", drawOperationHistory);
        var shape = drawOperationHistory[i].shape;
        var area = this.changeArea(drawOperationHistory[i].area);
        obj[shape + area] = drawOperationHistory[i];
      }
      var model = {
        plate: _.cloneDeep(this.plate),
        markers: _.cloneDeep(this.markers),
        cutPlate: _.cloneDeep(this.cutPlate),
      };
      var fixedParam = {
        markShift: this.markShift,
        markShiftTwo: this.markShiftTwo,
        markShiftThree: this.markShiftThree,
        markShiftFour: this.markShiftFour,
        markHolesOneD: this.markHolesOneD,
      };
      console.log(
        "callDrawFun() myobj this.operationParam=",
        this.operationParam
      );
      console.log("callDrawFun() this.glassFrameParam=", this.glassFrameParam);
      this.glassFrameParam.shapeName = this.frame;
      //this.glassFrameParam.shapeName == "Rectangle"
      if (this.glassFrameParam.shapeName == "Rectangle") {
        console.log("type&&&&&&&&&&&&&&***********############", type);
        if (type == "Corner") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            model,
            this.myHolesNum,
            this.form,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
        this.cutLine,
        this.cutFilletRadius,        
            this.CornerType,
          );
        } else {
          console.log(
            "this.glassFrameParam.shapeName&&&&&&&&&&&&&&***********############",
            this.glassFrameParam.shapeName
          );
          var myobj = this.$myutils[shape](
            this.operationParam,
            model,
            this.myHolesNum,
            this.form,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius,            
            this.CornerType,          
            );
        }
      } else if (this.glassFrameParam.shapeName == "RightAngledTrapezoid") {
        if (shape == "ObliqueAngle") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else if (shape == "SingleHole") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else {
          this.myOpenMsg(
            "此外框下不能进行此图形操作，请修改为矩形框，如有其它疑问请联系贵友客服。",
            "贵友提示您："
          );
        }
      } else if (this.glassFrameParam.shapeName == "ParallelogramA") {
        if (shape == "ObliqueAngle") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else if (shape == "Corner") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius,
            this.CornerType
          );
        } else if (shape == "SingleHole") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else {
          this.myOpenMsg(
            "此外框下不能进行此图形操作，请修改为矩形框，如有其它疑问请联系贵友客服。",
            "贵友提示您："
          );
        }
      } else if (this.glassFrameParam.shapeName == "ParallelogramB") {
        if (shape == "ObliqueAngle") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else if (shape == "SingleHole") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else {
          this.myOpenMsg(
            "此外框下不能进行此图形操作，请修改为矩形框，如有其它疑问请联系贵友客服。",
            "贵友提示您："
          );
        }
      } else {
        console.log(
          "this.glassFrameParam.shapeName8888888888888888=",
          this.glassFrameParam.shapeName
        );
        console.log(
          "this.glassFrameParam.shapeName8888888888888888=",
          this.glassFrameParam
        );
        console.log("this.glassFrameParam.shapeName8888888888888888=obj", obj);
        if (shape == "ObliqueAngle") {
          var myobj = this.$myutils[shape](
            this.operationParam,
            //obj,
            model,
            this.myHolesNum,
            this.glassFrameParam,
            fixedParam,
            this.zoomM,
            this.θCut,
            this.rCut,
            this.cutLine,
            this.cutFilletRadius
          );
        } else {
          this.myOpenMsg(
            "此外框下不能进行此图形操作，请修改为矩形框，如有其它疑问请联系贵友客服。",
            "贵友提示您："
          );
        }
      }
      this.plate = _.cloneDeep(myobj.plate);
      this.markers = _.cloneDeep(myobj.markers);
      this.cutPlate = _.cloneDeep(myobj.cutPlate);
      this.myHolesNum = _.cloneDeep(myobj.myHolesNum);
      this.creatDraw(
        this.markers,
        this.plate,
        this.cutPlate,
        this.form.glassW,
        this.form.glassH
      );
      this.updateState();
    },
    
    ////////////////////////20251105增加横向图，选择类型///////////

    //三孔类型单选事件
    threeHolesChange(e) {
      console.log("e=", e);
      switch (e) {
        case "A":
          //三孔不同类型选择单选
          this.threeHoleType = "A";
          //三孔示意图参数
          this.threeHolePic = require("../assets/image/ThreeHoles.jpg");
          //三孔调用函数名称变化参数
          this.threeHoleFn = "drawLevelOne('Hole','ThreeHoles')";
          break;
        case "B":
          //三孔不同类型选择单选
          this.threeHoleType = "B";
          //三孔示意图参数
          this.threeHolePic = require("../assets/image/ThreeHoles2.jpg");
          //三孔调用函数名称变化参数
          this.threeHoleFn = "drawLevelOne('Hole','ThreeHoles2')";
          break;
        case "C":
          //三孔不同类型选择单选
          this.threeHoleType = "C";
          //三孔示意图参数
          this.threeHolePic = require("../assets/image/ThreeHoles3.jpg");
          //三孔调用函数名称变化参数
          this.threeHoleFn = "drawLevelOne('Hole','ThreeHoles3')";
          break;
        case "D":
          //三孔不同类型选择单选
          this.threeHoleType = "D";
          //三孔示意图参数
          this.threeHolePic = require("../assets/image/ThreeHoles4.jpg");
          //三孔调用函数名称变化参数
          this.threeHoleFn = "drawLevelOne('Hole','ThreeHoles4')";
          break;
        default:
        // code block
      }
    },
    threeHoleFnClick() {
      if (this.threeHoleType == "A") {
        this.drawLevelOne("Hole", "ThreeHoles");
      }
      if (this.threeHoleType == "B") {
        this.drawLevelOne("Hole", "ThreeHoles2");
      }
      if (this.threeHoleType == "C") {
        this.drawLevelOne("Hole", "ThreeHoles3");
      }
      if (this.threeHoleType == "D") {
        this.drawLevelOne("Hole", "ThreeHoles4");
      }
    },
    
    FloorSpring3Change(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.FloorSpring3Type = "A";
          //三孔示意图参数
          this.FloorSpring3Pic = require("../assets/image/FloorSpring3.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.FloorSpring3Fn = "drawLevelOne('Corner','FloorSpring3')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.FloorSpring3Type = "B";
          //三孔示意图参数
          this.FloorSpring3Pic = require("../assets/image/FloorSpring3H.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.FloorSpring3Fn = "drawLevelOne('Corner','FloorSpring3H')";
          break;
        default:
        // code block
      }
    },
    FloorSpring3FnClick() {
      if (this.FloorSpring3Type == "A") {
        this.drawLevelOne("Corner", "FloorSpring3");
      }
      if (this.FloorSpring3Type == "B") {
        this.drawLevelOne("Corner", "FloorSpring3H");
      }
    },
    
    FloorSpring2Change(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.FloorSpring2Type = "A";
          //三孔示意图参数
          this.FloorSpring2Pic = require("../assets/image/FloorSpring2.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.FloorSpring2Fn = "drawLevelOne('Corner','FloorSpring2')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.FloorSpring2Type = "B";
          //三孔示意图参数
          this.FloorSpring2Pic = require("../assets/image/FloorSpring2H.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.FloorSpring2Fn = "drawLevelOne('Corner','FloorSpring2H')";
          break;
        default:
        // code block
      }
    },
    FloorSpring2FnClick() {
      if (this.FloorSpring2Type == "A") {
        this.drawLevelOne("Corner", "FloorSpring2");
      }
      if (this.FloorSpring2Type == "B") {
        this.drawLevelOne("Corner", "FloorSpring2H");
      }
    },
    
    FloorSpringChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.FloorSpringType = "A";
          //三孔示意图参数
          this.FloorSpringPic = require("../assets/image/FloorSpring.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.FloorSpringFn = "drawLevelOne('Corner','FloorSpring')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.FloorSpringType = "B";
          //三孔示意图参数
          this.FloorSpringPic = require("../assets/image/FloorSpringH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.FloorSpringFn = "drawLevelOne('Corner','FloorSpringH')";
          break;
        default:
        // code block
      }
    },
    FloorSpringFnClick() {
      if (this.FloorSpringType == "A") {
        this.drawLevelOne("Corner", "FloorSpring");
      }
      if (this.FloorSpringType == "B") {
        this.drawLevelOne("Corner", "FloorSpringH");
      }
    },
    //HangClipGap: "吊夹",
    HangClipGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.HangClipGapType = "A";
          //三孔示意图参数
          this.HangClipGapPic = require("../assets/image/HangClipGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.HangClipGapFn = "drawLevelOne('Gap','HangClipGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.HangClipGapType = "B";
          //三孔示意图参数
          this.HangClipGapPic = require("../assets/image/HangClipGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.HangClipGapFn = "drawLevelOne('Gap','HangClipGapH')";
          break;
        default:
        // code block
      }
    },
    HangClipGapFnClick() {
      if (this.HangClipGapType == "A") {
        this.drawLevelOne("Corner", "HangClipGap");
      }
      if (this.HangClipGapType == "B") {
        this.drawLevelOne("Corner", "HangClipGapH");
      }
    },
    //LongClipGap: "长条夹",
    LongClipGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.LongClipGapType = "A";
          //三孔示意图参数
          this.LongClipGapPic = require("../assets/image/LongClipGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.LongClipGapFn = "drawLevelOne('Gap','LongClipGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.LongClipGapType = "B";
          //三孔示意图参数
          this.LongClipGapPic = require("../assets/image/LongClipGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.LongClipGapFn = "drawLevelOne('Gap','LongClipGapH')";
          break;
        default:
      }
    },
    LongClipGapFnClick() {
      if (this.LongClipGapType == "A") {
        this.drawLevelOne("Corner", "LongClipGap");
      }
      if (this.LongClipGapType == "B") {
        this.drawLevelOne("Corner", "LongClipGapH");
      }
    },
    //CopperClipGap: "铜夹",
    CopperClipGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.CopperClipGapType = "A";
          //三孔示意图参数
          this.CopperClipGapPic = require("../assets/image/CopperClipGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.CopperClipGapFn = "drawLevelOne('Gap','CopperClipGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.CopperClipGapType = "B";
          //三孔示意图参数
          this.CopperClipGapPic = require("../assets/image/CopperClipGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.CopperClipGapFn = "drawLevelOne('Gap','CopperClipGapH')";
          break;
        default:
      }
    },
    CopperClipGapFnClick() {
      if (this.CopperClipGapType == "A") {
        this.drawLevelOne("Corner", "CopperClipGap");
      }
      if (this.CopperClipGapType == "B") {
        this.drawLevelOne("Corner", "CopperClipGapH");
      }
    },
    //UShapeGap: "U型缺",
    UShapeGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.UShapeGapType = "A";
          //三孔示意图参数
          this.UShapeGapPic = require("../assets/image/UShapeGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.UShapeGapFn = "drawLevelOne('Gap','UShapeGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.UShapeGapType = "B";
          //三孔示意图参数
          this.UShapeGapPic = require("../assets/image/UShapeGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.UShapeGapFn = "drawLevelOne('Gap','UShapeGapH')";
          break;
        default:
      }
    },
    UShapeGapFnClick() {
      if (this.UShapeGapType == "A") {
        this.drawLevelOne("Corner", "UShapeGap");
      }
      if (this.UShapeGapType == "B") {
        this.drawLevelOne("Corner", "UShapeGapH");
      }
    },
    //SquareGap: "方缺",
    SquareGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.SquareGapType = "A";
          //三孔示意图参数
          this.SquareGapPic = require("../assets/image/SquareGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.SquareGapFn = "drawLevelOne('Gap','SquareGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.SquareGapType = "B";
          //三孔示意图参数
          this.SquareGapPic = require("../assets/image/SquareGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.SquareGapFn = "drawLevelOne('Gap','SquareGapH')";
          break;
        default:
      }
    },
    SquareGapFnClick() {
      if (this.SquareGapType == "A") {
        this.drawLevelOne("Corner", "SquareGap");
      }
      if (this.SquareGapType == "B") {
        this.drawLevelOne("Corner", "SquareGapH");
      }
    },
    //RunwayGap: "跑道缺",
    RunwayGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.RunwayGapType = "A";
          //三孔示意图参数
          this.RunwayGapPic = require("../assets/image/RunwayGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.RunwayGapFn = "drawLevelOne('Gap','RunwayGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.RunwayGapType = "B";
          //三孔示意图参数
          this.RunwayGapPic = require("../assets/image/RunwayGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.RunwayGapFn = "drawLevelOne('Gap','RunwayGapH')";
          break;
        default:
      }
    },
    RunwayGapFnClick() {
      if (this.RunwayGapType == "A") {
        this.drawLevelOne("Corner", "RunwayGap");
      }
      if (this.RunwayGapType == "B") {
        this.drawLevelOne("Corner", "RunwayGapH");
      }
    },
    //StressHoleGap: "应力孔",
    StressHoleGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.StressHoleGapType = "A";
          //三孔示意图参数
          this.StressHoleGapPic = require("../assets/image/StressHoleGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.StressHoleGapFn = "drawLevelOne('Gap','StressHoleGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.StressHoleGapType = "B";
          //三孔示意图参数
          this.StressHoleGapPic = require("../assets/image/StressHoleGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.StressHoleGapFn = "drawLevelOne('Gap','StressHoleGapH')";
          break;
        default:
      }
    },
    StressHoleGapFnClick() {
      if (this.StressHoleGapType == "A") {
        this.drawLevelOne("Corner", "StressHoleGap");
      }
      if (this.StressHoleGapType == "B") {
        this.drawLevelOne("Corner", "StressHoleGapH");
      }
    },
    //ButterflyGap4: "蝴蝶缺4",
    ButterflyGap4Change(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGap4Type = "A";
          //三孔示意图参数
          this.ButterflyGap4Pic = require("../assets/image/ButterflyGap4.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGap4Fn = "drawLevelOne('Gap','ButterflyGap4')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGap4Type = "B";
          //三孔示意图参数
          this.ButterflyGap4Pic = require("../assets/image/ButterflyGap4H.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGap4Fn = "drawLevelOne('Gap','ButterflyGap4H')";
          break;
        default:
      }
    },
    ButterflyGap4FnClick() {
      if (this.ButterflyGap4Type == "A") {
        this.drawLevelOne("Corner", "ButterflyGap4");
      }
      if (this.ButterflyGap4Type == "B") {
        this.drawLevelOne("Corner", "ButterflyGap4H");
      }
    },
    //ButterflyGap3: "蝴蝶缺3",
    ButterflyGap3Change(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGap3Type = "A";
          //三孔示意图参数
          this.ButterflyGap3Pic = require("../assets/image/ButterflyGap3.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGap3Fn = "drawLevelOne('Gap','ButterflyGap3')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGap3Type = "B";
          //三孔示意图参数
          this.ButterflyGap3Pic = require("../assets/image/ButterflyGap3H.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGap3Fn = "drawLevelOne('Gap','ButterflyGap3H')";
          break;
        default:
      }
    },
    ButterflyGap3FnClick() {
      if (this.ButterflyGap3Type == "A") {
        this.drawLevelOne("Corner", "ButterflyGap3");
      }
      if (this.ButterflyGap3Type == "B") {
        this.drawLevelOne("Corner", "ButterflyGap3H");
      }
    },
    //ButterflyGap2: "蝴蝶缺2",
    ButterflyGap2Change(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGap2Type = "A";
          //三孔示意图参数
          this.ButterflyGap2Pic = require("../assets/image/ButterflyGap2.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGap2Fn = "drawLevelOne('Gap','ButterflyGap2')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGap2Type = "B";
          //三孔示意图参数
          this.ButterflyGap2Pic = require("../assets/image/ButterflyGap2H.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGap2Fn = "drawLevelOne('Gap','ButterflyGap2H')";
          break;
        default:
      }
    },
    ButterflyGap2FnClick() {
      if (this.ButterflyGap2Type == "A") {
        this.drawLevelOne("Corner", "ButterflyGap2");
      }
      if (this.ButterflyGap2Type == "B") {
        this.drawLevelOne("Corner", "ButterflyGap2H");
      }
    },
    //ButterflyGap: "蝴蝶缺",
    ButterflyGapChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGapType = "A";
          //三孔示意图参数
          this.ButterflyGapPic = require("../assets/image/ButterflyGap.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGapFn = "drawLevelOne('Gap','ButterflyGap')";
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.ButterflyGapType = "B";
          //三孔示意图参数
          this.ButterflyGapPic = require("../assets/image/ButterflyGapH.jpg");
          //第三种地弹簧调用函数名称变化参数
          this.ButterflyGapFn = "drawLevelOne('Gap','ButterflyGapH')";
          break;
        default:
      }
    },
    ButterflyGapFnClick() {
      if (this.ButterflyGapType == "A") {
        this.drawLevelOne("Corner", "ButterflyGap");
      }
      if (this.ButterflyGapType == "B") {
        this.drawLevelOne("Corner", "ButterflyGapH");
      }
    },
   //方角H参数类型选择
   //Corner: "吊夹",
    CornerChange(e) {
      switch (e) {
        case "A":
          //第三种地弹簧不同类型选择单选
          this.CornerType = "A";
          //三孔示意图参数
          this.CornerPic = require("../assets/image/Corner.jpg");
          break;
        case "B":
          //第三种地弹簧不同类型选择单选
          this.CornerType = "B";
          //三孔示意图参数
          this.CornerPic = require("../assets/image/CornerH1.jpg");
          break;
        case "C":
          //第三种地弹簧不同类型选择单选
          this.CornerType = "C";
          //三孔示意图参数
          this.CornerPic = require("../assets/image/CornerH2.jpg");
          break;
        default:
        // code block
      }
    },

////////////////////////20251105增加横向图，选择类型///////////
    //***************异形*************/
    saveMySvg() {
      var fileNames = this.creatDate();
      var x = document.getElementById("drawCanvas").innerHTML;
      // 创建一个 Blob 对象并设置 MIME 类型为 image/svg+xml
      var blob = new Blob([x]);
      console.log("blob====", blob);
      // 创建一个 URL 对象来引用 Blob 数据
      var url = window.URL || window.webkitURL;
      var downloadUrl = url.createObjectURL(blob);
      // 创建一个链接元素并设置其属性
      var link = document.createElement("a");
      link.href = downloadUrl;
      link.download = fileNames + ".svg"; // 指定下载时的文件名
      // 模拟点击链接进行下载
      link.click();
      // 清除 URL 对象
      url.revokeObjectURL(downloadUrl);
    },
    saveMyDXF() {
      //var square = new makerjs.models.Square(100);
      //var svg = makerjs.exporter.toSVG(square);
      //this.dxf = makerjs.exporter.toDXF(square);
      // 创建一个 Blob 对象并设置 MIME 类型为 image/svg+xml
       if(this.gySer==""){
        var fileNames = this.creatDate(); 
       }  else {
      var fileNames = this.GlasslD;
            }
      
      //var fileNames = this.creatDate();
      console.log("this.cutPlate =typeof", typeof this.cutPlate);
      console.log("saveMyDXFthis.cutPlate =typeof", typeof this.cutPlate);
      console.log("saveMyDXFthis.dxf =typeof", typeof this.dxf);
      var blob = new Blob([this.dxf]);
      console.log("blob====", blob);
      // 创建一个 URL 对象来引用 Blob 数据
      var url = window.URL || window.webkitURL;
      var downloadUrl = url.createObjectURL(blob);

      // 创建一个链接元素并设置其属性
      var link = document.createElement("a");
      link.href = downloadUrl;
      link.download =
        fileNames  +
        ".dxf"; // 指定下载时的文件名
      // 模拟点击链接进行下载
      link.click();
      // 清除 URL 对象
      url.revokeObjectURL(downloadUrl);
       this.saveHolesPng();
        if (this.toERPParams == true) {
          this.sendDataToERP();
        }
    },
    saveMyabDXF() {
      //var square = new makerjs.models.Square(100);
      //var svg = makerjs.exporter.toSVG(square);
      //this.dxf = makerjs.exporter.toDXF(square);
      // 创建一个 Blob 对象并设置 MIME 类型为 image/svg+xml
      if(this.gySer==""){
        var fileNames = this.creatDate(); 
            }           
            else {
         var fileNames = this.GlasslD;
            }
      
      //var fileNames = this.creatDate();
      console.log("this.abPlate =typeof", typeof this.abPlate);
      console.log("saveMyabDXFthis.abPlate =typeof", typeof this.abPlate);
      console.log("saveMyabDXFthis.abDxf =typeof", typeof this.abDxf);
      var blob = new Blob([this.abDxf]);
      console.log("blob====", blob);
      // 创建一个 URL 对象来引用 Blob 数据
      var url = window.URL || window.webkitURL;
      var downloadUrl = url.createObjectURL(blob);

      // 创建一个链接元素并设置其属性
      var link = document.createElement("a");
      link.href = downloadUrl;
      link.download =
        fileNames +
        // this.GlasslD +
        // "_" +
        // this.GlassUserMdThickness.padStart(2, "0") +
        ".dxf"; // 指定下载时的文件名
      // 模拟点击链接进行下载
      link.click();
      // 清除 URL 对象
      url.revokeObjectURL(downloadUrl);
    },
    exMould() {
      console.log(
        "this.operationHistory.length=",
        this.operationHistory.length
      );
      if (this.operationHistory.length <= 1) {
        this.myOpenMsg("没有图形，请先画图。", "提示：");
      } else {
        //console.log("this.plate=", this.plate);
        //console.log("this.plate.models=", this.plate.models);
        this.MyJSON.plate = this.plate;
        this.MyJSON.cutPlate = this.cutPlate;
        this.MyJSON.markers = this.markers;
        this.MyJSON.Rect = this.form;
        this.MyJSON.operationHistory = this.operationHistory;
        this.MyJSON = JSON.stringify(this.MyJSON);
        console.log("this.MyJSON=", this.MyJSON);
        this.saveMyJSON();
        this.saveJsonPng();
      }
    },
    saveMyJSON() {
      //var square = new makerjs.models.Square(100);
      //var svg = makerjs.exporter.toSVG(square);
      //this.dxf = makerjs.exporter.toDXF(square);
      // 创建一个 Blob 对象并设置 MIME 类型为 image/svg+xml
      var fileNames = this.creatDate();
      var blob = new Blob([this.MyJSON]);
      console.log("blob====", blob);
      // 创建一个 URL 对象来引用 Blob 数据
      var url = window.URL || window.webkitURL;
      var downloadUrl = url.createObjectURL(blob);

      // 创建一个链接元素并设置其属性
      var link = document.createElement("a");
      link.href = downloadUrl;
      link.download =
        fileNames +
        this.GlasslD +
        "_" +
        this.GlassThickness.padStart(2, "0") +
        ".json"; // 指定下载时的文件名
      // 模拟点击链接进行下载
      link.click();
      // 清除 URL 对象
      url.revokeObjectURL(downloadUrl);
    },
    saveJsonPng() {
      var fileNames = this.creatDate();
      var svg = document.getElementById("myDrawing");
      console.log("svg=", svg.setAttribute.viewBox);
      const _this = this;
      var img = _this.export2Base64Img(svg, null, {
        //watermark: 'copyright reserved 2020 版权所有',
        background: "#fff",
      });
      img.then(function (base64src) {
        //console.log('路径:::', base64src)
        // console.log("this1=",_this)
        if(_this.setOUtFileName=="A"){

        _this.downLoad(
          base64src,
          fileNames +
            _this.GlasslD +
            ".png"
        );
        }else if(_this.setOUtFileName=="B"){

        _this.downLoad(
          base64src,
          fileNames +
            _this.GlasslD +
            "_" +
            _this.GlassThickness.padStart(2, "0") +
            ".png"
        );
        }
        //console.log("this2=",_this)
      });
    },
    saveMyPng() {
      var fileNames = this.creatDate();
      var svg = document.getElementById("myDrawing");
      console.log("svg=", svg);
      if (svg == null) {
        this.myOpenMsg("图形为空，请先画图。", "贵友提示您：");
      } else {
        console.log("svg=", svg.setAttribute.viewBox);
        const _this = this;
        var img = _this.export2Base64Img(svg, null, {
          background: "#fff",
        });
        img.then(function (base64src) {
          console.log("路径:::", base64src);
          console.log("this1=", _this);
          if(_this.setOUtFileName=="A"){

          _this.downLoad(
            base64src,
              _this.GlasslD +
              ".png"
          );
          }else if(_this.setOUtFileName=="B"){

          _this.downLoad(
            base64src,
              _this.GlasslD +
              "_" +
              _this.GlassThickness.padStart(2, "0") +
              ".png"
          );
          }
          console.log("this2=", _this);
        });
      }
    },
    saveAbMyPng() {
      console.log("****");
      var fileNames = this.creatDate();
      var svg = document.getElementById("myAbImgs");
      console.log("svg=", svg);
      if (svg == null) {
        this.myOpenMsg("图形为空，请先画图。", "贵友提示您：");
      } else {
        console.log("svg=", svg.setAttribute.viewBox);
        const _this = this;
        var img = _this.export2Base64Img(svg, null, {
          background: "#fff",
        });
        img.then(function (base64src) {
          console.log("路径:::", base64src);
          console.log("this1=", _this);
          if(_this.setOUtFileName=="A"){

          _this.downLoad(
            base64src,
              _this.GlasslD +
              ".png"
          );
          }else if(_this.setOUtFileName=="B"){

          _this.downLoad(
            base64src,
              _this.GlasslD +
              "_" +
              _this.GlassThickness.padStart(2, "0") +
              ".png"
          );
          }
          console.log("this2=", _this);
        });
      }
    },
    handleFileChange(event) {
      const file = event.target.files[0]; // 获取第一个选定的文件对象
      if (file) {
        this.readFileContent(file); // 调用自定义的读取文件内容的方法
      } else {
        console.log("未选择任何文件");
      }
    },
    readFileContent(file) {
      const reader = new FileReader();

      reader.onload = () => {
        const content = JSON.parse(reader.result); // 读取到的文件内容

        // 进行后续操作，比如打印或者保存文件内容等
        console.log("测试读取的内容" + content);
        //获取节点 插入读取的内容
        //innerHTML

        this.form.glassW = content.Rect.glassW;
        this.form.glassH = content.Rect.glassH;
        this.plate = content.plate;
        this.cutPlate = content.cutPlate;
        this.markers = content.markers;
        this.operationHistory = content.operationHistory;
        this.creatSvg(
          content.Rect.glassW,
          content.Rect.glassH,
          content.markers
        );
      };

      reader.readAsText(file); // 以文本形式读取文件内容
    },
    //导出png图片格式相关
    reEncode(data) {
      return decodeURIComponent(
        encodeURIComponent(data).replace(/%([0-9A-F]{2})/g, (match, p1) => {
          const c = String.fromCharCode(`0x${p1}`);
          return c === "%" ? "%25" : c;
        })
      );
    },
    //模板导出图片
    export2Base64ImgUserMd(path, rect, MIMEType, option) {
      // var serializer = new XMLSerializer();
      // console.log("**3=", typeof svgDom);
      // var source = serializer.serializeToString(svgDom);
      // // 方式一: unescape(encodeURIComponent(txt))
      // // var path = "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(source)));
      // // 方式二: decodeURIComponent(encodeURIComponent(txt))
      // var path =
      //   "data:image/svg+xml;base64," + window.btoa(this.reEncode(source));
      var canvas = document.createElement("canvas"),
        context = canvas.getContext("2d"),
        img = new Image(),
        pixelRatio = window.devicePixelRatio || 1,
        _exportPath,
        handler;
      option = option || {};
      // activeBigSize:{
      //   userHeight:"",
      //   userWide:"",
      // },
      canvas.width = parseFloat(rect.X * 1 + 100); //  * pixelRatio
      canvas.height = parseFloat(rect.Y * 1 + 100); //  * pixelRatio
      img.src = path;
      img.onload = function () {
        // 增加底色
        if (option.background) {
          context.beginPath();
          context.rect(0, 0, canvas.width, canvas.height);
          context.fillStyle = option.background;
          context.fill();
          context.closePath();
        }
        //
        context.drawImage(img, 0, 0);
        var marker = option.watermark || "";
        if (marker) {
          context.font = "18px 微软雅黑";
          context.fillStyle = "rgba(12, 0, 70, 0.5)";
          var textWidth = context.measureText(marker).width,
            textHegith = 50,
            pk = 1.2,
            rotate = ((option.rotation || -45) * Math.PI) / 180,
            sinReg = Math.sin(rotate),
            cosReg = Math.cos(rotate),
            width =
              Math.abs(canvas.width * cosReg) +
              Math.abs(canvas.height * sinReg),
            height =
              Math.abs(canvas.height * cosReg) +
              Math.abs(canvas.width * sinReg);
          var xf = Math.ceil((width / textWidth) * pk);
          var yf = Math.ceil(height / textHegith);
          context.rotate(rotate);
          for (var i = 0; i < yf; i++) {
            for (var k = 0; k < xf; k++) {
              context.fillText(
                marker,
                textWidth * k * pk - canvas.height * cosReg,
                textHegith * i
              );
            }
          }
        }

        document.body.appendChild(canvas);
        _exportPath = canvas.toDataURL(MIMEType || "image/png", 1);
        typeof handler === "function" && handler(_exportPath);
        document.body.removeChild(canvas);
      };

      return new Promise(function (resolve, reject) {
        handler = resolve;
      });
    },
    export2Base64Img(svgDom, MIMEType, option) {
      console.log("**");
      var serializer = new XMLSerializer();
      console.log("**3=", typeof svgDom);
      var source = serializer.serializeToString(svgDom);
      // 方式一: unescape(encodeURIComponent(txt))
      // var path = "data:image/svg+xml;base64," + window.btoa(unescape(encodeURIComponent(source)));
      // 方式二: decodeURIComponent(encodeURIComponent(txt))
      var path =
        "data:image/svg+xml;base64," + window.btoa(this.reEncode(source));
      var canvas = document.createElement("canvas"),
        context = canvas.getContext("2d"),
        img = new Image(),
        pixelRatio = window.devicePixelRatio || 1,
        _exportPath,
        handler;
      option = option || {};
      canvas.width = parseFloat(svgDom.getAttribute("width")); //  * pixelRatio
      canvas.height = parseFloat(svgDom.getAttribute("height")); //  * pixelRatio
      img.src = path;
      img.onload = function () {
        // 增加底色
        if (option.background) {
          context.beginPath();
          context.rect(0, 0, canvas.width, canvas.height);
          context.fillStyle = option.background;
          context.fill();
          context.closePath();
        }
        //
        context.drawImage(img, 0, 0);
        var marker = option.watermark || "";
        if (marker) {
          context.font = "18px 微软雅黑";
          context.fillStyle = "rgba(12, 0, 70, 0.5)";
          var textWidth = context.measureText(marker).width,
            textHegith = 50,
            pk = 1.2,
            rotate = ((option.rotation || -45) * Math.PI) / 180,
            sinReg = Math.sin(rotate),
            cosReg = Math.cos(rotate),
            width =
              Math.abs(canvas.width * cosReg) +
              Math.abs(canvas.height * sinReg),
            height =
              Math.abs(canvas.height * cosReg) +
              Math.abs(canvas.width * sinReg);
          var xf = Math.ceil((width / textWidth) * pk);
          var yf = Math.ceil(height / textHegith);
          context.rotate(rotate);
          for (var i = 0; i < yf; i++) {
            for (var k = 0; k < xf; k++) {
              context.fillText(
                marker,
                textWidth * k * pk - canvas.height * cosReg,
                textHegith * i
              );
            }
          }
        }

        document.body.appendChild(canvas);
        _exportPath = canvas.toDataURL(MIMEType || "image/png", 1);
        typeof handler === "function" && handler(_exportPath);
        document.body.removeChild(canvas);
      };

      return new Promise(function (resolve, reject) {
        handler = resolve;
      });
    },
    downLoad(url, fileName) {
      var oA = document.createElement("a");
      oA.download = fileName || "";
      oA.style.display = "none";
      oA.href = url;
      document.body.appendChild(oA);
      oA.click();
      oA.remove();
    },
    //导出png图片格式相关
    //获取当前时间 用来生成默认文件名称
    creatDate() {
      var currentDate = new Date();
      var year = currentDate.getFullYear(); // 获取年份
      var month = currentDate.getMonth() + 1; // 获取月份，月份从0开始，需加1
      var day = currentDate.getDate(); // 获取日期
      var hours = currentDate.getHours(); // 获取小时
      var minutes = currentDate.getMinutes(); // 获取分钟
      var seconds = currentDate.getSeconds(); // 获取秒数
      var currentDateTime =
        year + "" + month + "" + day + "" + hours + "" + minutes + "" + seconds;
      //var currentDateTime = year + month + day + hours + minutes + seconds;
      console.log("currentDateTime=", currentDateTime);
      return currentDateTime;
    },
    //创建本地文件夹
    creatFile() {
      var fso = new ActiveXObject("Scripting.FileSystemObject");
      var f1 = fso.createtextfile("D:\\myjstest.txt", true);
    },
  },
};
</script>
<style lang="less">
.txtRt{
  text-align: right;  
  height:30px;
  line-height:30px;
  }
.bg-purple-dark {
  background: #fff;
}
.bgParma {
  background-color: #fff;
}
.parmaRect {
  margin-top: 25px;
  margin-bottom: 100px;
}
.imgRect {
  margin-top: 25px;
  height: 600px;
}
.imgBtn {
  margin: 50px;
}
.el-aside {
  background-color: #fff;
  color: #333;
  text-align: center;
  min-height: 1000px;
  width: 100px;
}
.bgMain {
  background-color: #e9eef3;
  min-height: 1000px;
  height: 100%;
}
.imgWidth {
  width: 50px;
}
.asideCard {
}
.asideCard:hover {
  background-color: #e9f5fd;
  cursor: pointer;
}
.btnTop {
  margin-top: 5px;
}
.mdashape-img-container {
  margin: 10px auto auto 50px;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.mdashape-img-item {
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  margin-bottom: 10px;
  text-align: center;
  width: 100px;
  border-radius: 4px;
}
.span-title {
  height: 30px;
  line-height: 30px;
  text-align: left;
}
.mdashape-img-bottom {
  margin-bottom: 0px;
}
.mdashapeActiveImg {
  border: 1px solid #409eff;
  background-color: #e9f5fd;
}
.mdashapeActiveMenu {
  border: 1px solid #409eff;
  background-color: #c1e3fa;
}
.mdashape-img-item:nth-of-type(15n) {
  margin-right: 0px;
}

.el-main {
  background-color: #fff;
  color: #333;
  text-align: center;
  min-height: 100%;
  border: 1px solid #e9eef3;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 100%;
}
.mask {
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* 半透明遮罩 */
  color: #fff;
  opacity: 0;
  display: flex;
  justify-content: center;
}
.inputPadding {
  padding-left: 1px;
}
.foot_lf {
  margin-top: 8px;
  font-size: 11px;
  a:link {
    color: #303133; /* 文字颜色 */
    text-decoration: none; /* 无下划线 */
  }
}
.btnUserMdReSet {
  margin-top: 15px;
}
.imgUserMdMenu {
  color: #303133;
}
.imgUserMdDrop {
  padding-top: 8px;
}
.exportMenu {
  margin-top: 25px;
}
.borderbulue {
  border: 1px solid #409eff;
}
.myCursor {
  cursor: pointer;
}
.holes-img-container {
  margin: 10px auto auto 50px;
  max-height: 420px;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
.holes-img-item {
  width: 100px;
  height: 160px;
  margin-right: 10px;
  margin-bottom: 10px;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}
.holesActiveImg {
  border: 1px solid #409eff;
  background-color: #e9f5fd;
}
.showimgstyle:hover {
  border: 1px solid #409eff;
  background-color: #e9f5fd;
  cursor: pointer;
}
.holes-img-bottom {
  margin-bottom: 15px;
}
.holes-img-item:nth-of-type(15n) {
  margin-right: 0px;
}
.holes-img-parmSet {
  margin-top: 25px;
  color: #909399;
}
.holes-img-parmSet-imgs {
  margin: 5px 5px;
  text-align: center;
  height: auto;
}
.setParamH {
  height: 95vh;
}
.showImgBig {
  box-sizing: border-box;
  background-color: #b7b8ba;
  border: 1px solid #ebeef5;
  width: 100%;
  height: 600px; /* 或任意固定高度/百分比高度 */
  display: flex;
  align-items: center; /* 垂直居中 */
  justify-content: center; /* 水平居中 */
}
/* 确保图片填充容器 */
.centered-image {
  width: 100%;
  height: 100%;
}
.div-cursor {
  display: flex;
  flex-direction: column;
  cursor: pointer;
  padding: 10px;
}
.logo-img-contener {
  text-align: center;
}
.logo-img-item {
  display: flex;
  flex-direction: column;
}
.el-dropdown-link {
  cursor: pointer;
}
.display-clo {
  display: flex;
  flex-direction: column;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.txtHeight {
  line-height: 45px;
  text-align: center;
}
.iconfont {
  font-size: 42px;
}
.contanerBox {
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  margin: 0 auto;
  padding: 8px;
  .conHeader {
    padding-top: 8px;
    padding-left: 20px;
    background-color: #b3c0d1;
    color: #333;
    height: 8vh;
    line-height: 45px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .MenuBtns {
      margin-left: 0px;
      align-self: center;
      justify-items: center;
      display: flex;
      align-items: flex-end;
      justify-content: space-around;
      flex: 7;
      .openMenu {
        .open-svg {
          display: inline-block;
          cursor: pointer;
          padding: 10px;
        }
        #openSVG {
          display: none;
        }
      }
    }
    .MenuBtns-right {
      justify-content: flex-end;
      display: flex;
      text-align: right;
      flex: 9;
      padding-right: 15px;
      .div-right {
        padding: 8px;
      }
    }
  }
  .conMain {
    display: flex;
    background-color: #e9eef3;
    .conMainCon {
      position: relative;
      #view {
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        #drawCanvas {
          margin: 2em;
        }
      }
      flex: 13;
      background-color: #e9eef3;
      color: #333;
      .drawBack {
        background-color: #fff;
        margin: 20px 20px;
        .draw {
          box-sizing: border-box;
          svg {
            overflow: visible;
          }
        }
      }
    }

    .conMainRight {
      margin-top: 15px;
      flex: 5;
      background-color: #e9eef3;
      .hole-position {
        border: 1px solid #909399;
        padding-top: 5px;
        padding-bottom: 5px;
        .hole-lineH {
          height: 8px;
          line-height: 80px;
        }
      }
    }
  }
  .r_content {
    .el-dropdown-link {
      cursor: pointer;
      color: #0e1012;
      .user-img {
        width: 50px;
        height: 50px;
        border-radius: 50%;
      }
    }
  }
  .conMdMain {
    margin-left: 20%;
    display: flex;
    background-color: #e9eef3;
    .conMdMainCon {
      position: relative;
      #viewMd {
        color: #fff;
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        #svgToImg {
          margin: 2em;
        }
      }
      flex: 13;
      background-color: #e9eef3;
      color: #333;
      .drawBackMd {
        background-color: rgb(246, 123, 123);
        margin: 20px 20px;
        .drawmd {
          box-sizing: border-box;
          svg {
            overflow: visible;
          }
        }
      }
    }
  }
}
/**上传头像图片 */
.disabled .el-upload--picture-card {
  display: none;
}
/**上传头像图片 */
</style>
